<template>
  <div>
    <!-- keep this hidden QR code for download -->
    <qrcode-vue
      id="std-qr"
      :value="qrSID"
      :size="200"
      level="H"
      class="text-center"
      hidden
    ></qrcode-vue>

    <b-modal
      id="modal-qr"
      :title="qrModalTitle"
      centered
      size="sm"
      footer-class="justify-content-center"
    >
      <qrcode-vue
        :value="qrValue"
        :size="200"
        level="H"
        class="text-center"
      ></qrcode-vue>

      <template #modal-footer>
        <b-button variant="success" class="btn-icon" @click="saveQr()">
          <feather-icon icon="DownloadIcon" />
          <span class="align-middle ml-50">{{ $t("Download") }}</span>
        </b-button>
        <b-button variant="primary" class="btn-icon" @click="copyQr()">
          <feather-icon icon="CopyIcon" />
          <span class="align-middle ml-50">{{ $t("Copy") }}</span>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-login"
      hide-footer
      cancel-variant="outline-secondary"
      :ok-title="$t('Show data')"
      centered
      no-close-on-backdrop
      :title="$t('Filters')"
    >
      <b-form>
        <b-form-group
          v-if="isHeadOffice"
          :label="$t('Campus')"
          :invalid-feedback="$t('Campus is required.')"
        >
          <v-select
            v-model="filter.campusID"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="campuses"
            :clearable="false"
            label="branch"
            :reduce="(val) => val.id"
            :disabled="filterloading"
            :placeholder="$t('Select campus')"
            @input="LoadFilter('selected')"
          />
        </b-form-group>

        <b-form-group
          :label="$t(this.classLabel)"
          :invalid-feedback="$t(this.classLabel + ' is required')"
          ref="class_current"
        >
          <v-select
            v-model="filter.cls"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :clearable="false"
            :options="[
              { name: 'All ' + allClassLabel, id: 0 },
              ...classesOptions,
            ]"
            label="name"
            :reduce="(val) => val.id"
            input-id="id"
            ref="class_current"
            @input="FillSectionsCurrent()"
            :disabled="filterloading"
            :placeholder="$t('Select ' + this.classLabel)"
          />
          <!-- @search:blur="CheckClassCurrent()" -->
        </b-form-group>

        <b-form-group
          :label="$t(this.sectionLabel)"
          :invalid-feedback="$t(this.sectionLabel + ' name is required.')"
          ref="section_current"
        >
          <v-select
            v-model="filter.sec"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="currentSections"
            :reduce="(opt) => opt.id"
            label="section"
            :clearable="false"
            :disabled="filterloading"
            :placeholder="$t('Select ' + this.sectionLabel)"
          />
          <!-- @search:blur="CheckCurrentSec()" -->
        </b-form-group>

        <!-- <b-form-group
          label="Gender"
          invalid-feedback="gender is required."
          ref="gender"
        >
          <v-select
            v-model="filter.gender"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="genders"
            :clearable="false"
            :disabled="filterloading"
            placeholder="Select gender."
          />
        </b-form-group> -->

        <b-form-group
          :label="$t('Status')"
          :invalid-feedback="$t('status is required.')"
          ref="status"
        >
          <v-select
            v-model="filter.status"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="filterStatusOpt"
            :reduce="(opt) => opt.value"
            label="text"
            :clearable="false"
            :disabled="filterloading"
            :placeholder="$t('Select status')"
          />
        </b-form-group>
      </b-form>
      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="Filter(1)"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
          >
            <span class="align-middle">{{ $t("Show data") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-adm"
      hide-footer
      cancel-variant="outline-secondary"
      :ok-title="$t('Show data')"
      centered
      no-close-on-backdrop
      :title="$t('Filters')"
    >
      <b-form>
        <b-form-group
          :label="$t('Date')"
          :invalid-feedback="$t('Date is required')"
          ref="date"
        >
          <flat-pickr
            v-model="admDate"
            :config="config2"
            class="form-control"
            :placeholder="$t('Select Date')"
            @on-change="setDate"
          />
        </b-form-group>
      </b-form>
      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="Filter(1)"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
          >
            <span class="align-middle">{{ $t("Show data") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-reg"
      hide-footer
      cancel-variant="outline-secondary"
      :ok-title="$t('Show data')"
      centered
      no-close-on-backdrop
      :title="$t('Filters')"
    >
      <b-form>
        <b-form-group
          v-if="isHeadOffice"
          :label="$t('Campus')"
          :invalid-feedback="$t('Campus is required.')"
        >
          <v-select
            v-model="filter.campusID"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="campuses"
            :clearable="false"
            label="branch"
            :reduce="(val) => val.id"
            :disabled="filterloading"
            :placeholder="$t('Select campus')"
            @input="LoadFilter('selected')"
          />
        </b-form-group>

        <b-form-group
          :label="$t(this.classLabel)"
          :invalid-feedback="$t(this.classLabel + ' is required')"
          ref="class_current"
        >
          <v-select
            v-model="filter.cls"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="[
              { name: 'All ' + allClassLabel, id: 0 },
              ...classesOptions,
            ]"
            :clearable="false"
            label="name"
            :reduce="(val) => val.id"
            input-id="id"
            ref="class_current"
            @input="FillSectionsCurrent()"
            :disabled="filterloading"
            :placeholder="$t('Select ' + this.classLabel)"
          />
          <!-- @search:blur="CheckClassCurrent()" -->
        </b-form-group>

        <b-form-group
          :label="$t(this.sectionLabel)"
          :invalid-feedback="$t(this.sectionLabel + ' name is required.')"
          ref="section_current"
        >
          <v-select
            v-model="filter.sec"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="currentSections"
            :reduce="(opt) => opt.id"
            label="section"
            :clearable="false"
            :disabled="filterloading"
            :placeholder="$t('Select ' + this.sectionLabel)"
          />
          <!-- @search:blur="CheckCurrentSec()" -->
        </b-form-group>

        <b-form-group
          :label="$t('Status')"
          :invalid-feedback="$t('status is required.')"
          ref="reg_status"
        >
          <v-select
            v-model="filter.status"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="regFilterStOpt"
            :reduce="(opt) => opt.value"
            label="text"
            :clearable="false"
            :disabled="filterloading"
            :placeholder="$t('Select status')"
          />
        </b-form-group>

        <b-form-group
          v-if="['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)"
          :label="$t('Accepted By')"
          :invalid-feedback="$t('Accepted By is required.')"
        >
          <v-select
            v-model="acceptedBy"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="filterOptions"
            :clearable="false"
            label="text"
            :reduce="(val) => val.value"
            :placeholder="$t('Select')"
          />
        </b-form-group>
        <template v-else>
          <b-form-group
            :label="$t('Date For')"
            :invalid-feedback="$t('status is required.')"
            ref="dt_type"
          >
            <v-select
              v-model="regFilter.dateType"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="dtOptions"
              :reduce="(opt) => opt.value"
              label="text"
              :clearable="false"
              :disabled="filterloading"
              :placeholder="$t('Select type')"
            />
          </b-form-group>
          <b-form-group
            :label="$t('Date')"
            :invalid-feedback="$t('Date is required')"
            ref="date"
          >
            <flat-pickr
              v-model="filterDate"
              :config="config"
              class="form-control"
              :placeholder="$t('Select Date')"
            />
          </b-form-group>
        </template>
      </b-form>
      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="Filter(1)"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
          >
            <span class="align-middle">{{ $t("Show data") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-cert"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      :title="$t('Print')"
    >
      <b-form>
        <b-form-group
          :label="$t('Type')"
          :invalid-feedback="$t('Type is required')"
          ref="type"
        >
          <v-select
            ref="type"
            v-model="reportObj.type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="certOptions"
            :clearable="false"
            label="name"
            :reduce="(val) => val.value"
            :placeholder="$t('Select type')"
          />
        </b-form-group>
        <template
          v-if="
            reportDomain === 'myskoolkentschool' && reportObj.type === 'id-card'
          "
        >
          <b-form-group :label="$t(classLabel)">
            <v-select
              v-model="kentPrintClass"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
              :options="[
                { name: 'All ' + allClassLabel, id: 0 },
                ...classesOptions,
              ]"
              label="name"
              :reduce="(val) => val.id"
              :disabled="filterloading"
              @input="fillKentPrintSections()"
            />
          </b-form-group>
          <b-form-group :label="$t(sectionLabel)">
            <v-select
              v-model="kentPrintSec"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="kentPrintSections"
              :reduce="(opt) => opt.id"
              label="section"
              :clearable="false"
              :disabled="filterloading"
            />
          </b-form-group>
          <p v-if="stdIDs.length > 0" class="text-muted small mb-0">
            {{ stdIDs.length }}
            {{ $t("students selected on grid — print uses selection.") }}
          </p>
        </template>
        <template
          v-if="
            reportDomain === 'myskoolqalam' && reportObj.type === 'admit-card'
          "
        >
          <b-form-group
            :label="$t('Exam Type')"
            :invalid-feedback="$t('Exam type is required.')"
            ref="exType"
          >
            <v-select
              v-model="eTypee"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="examType"
              :reduce="(opt) => opt.examType"
              label="examType"
              :clearable="false"
              placeholder="Select exam type"
            />
          </b-form-group>
          <b-form-group
            :label="$t('Session')"
            :invalid-feedback="$t('Session is required.')"
            ref="admitSession"
          >
            <v-select
              v-model="admitCardSessionID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sessions"
              :reduce="(opt) => opt.id"
              label="session"
              :clearable="false"
              placeholder="Select session"
            />
          </b-form-group>
          <b-form-group
            :label="$t('Select Date')"
            :invalid-feedback="$t('Date is required')"
          >
            <flat-pickr
              :config="{
                altFormat: 'j M, Y',
                altInput: true,
                dateFormat: 'd-F-Y',
              }"
              v-model="admitCardDate"
              class="form-control"
              :placeholder="$t('Select Date')"
            />
          </b-form-group>
        </template>
        <b-form-group
          v-if="
            isHeadOffice &&
            isTcfReportDomain() &&
            reportObj.type == 'admission-form'
          "
          :label="$t('Campus')"
          :invalid-feedback="$t('Campus is required.')"
        >
          <v-select
            v-model="reportObj.selectedCampus"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="campuses"
            :clearable="false"
            label="branch"
            :reduce="(val) => val.id"
            :placeholder="$t('Select campus')"
          />
        </b-form-group>
      </b-form>
      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="printRep()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            :disabled="reportPrinting"
          >
            <b-spinner v-if="reportPrinting" small type="grow" />
            <span v-else class="align-middle">{{ $t("Print") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-search"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      hide-header
      :title="$t('Choose Search Criteria')"
      body-class="p-0"
    >
      <div class="pt-2 pl-2 pr-2 pb-0">
        <h2>{{ $t("Choose Search Criteria") }}</h2>
        <hr />
      </div>
      <div>
        <h5
          v-for="item in searchOptions"
          :key="item.name"
          class="pt-50 pb-50 pl-2 pr-2 font-weight-300 mb-0 cursor-pointer"
          :class="[
            item.value == searchType && 'text-white bg-primary',
            item.value != searchType && 'search-type',
          ]"
          @click="saveState(item.value)"
        >
          {{
            reportDomain === "myskoolhpgs" && item.name == "GR"
              ? $t("CID")
              : $t(item.name)
          }}
        </h5>
      </div>
      <!-- <b-form >
        <b-form-group
          label="Search by"
          invalid-feedback="Search by is required."
          ref="search"
        >
          <v-select
            ref="search"
            v-model="searchType"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="searchOptions"
            :clearable="false"
            label="name"
            :reduce="(val) => val.value"
            placeholder="Select"
            @input="saveState()"
          />
        </b-form-group>
      </b-form> -->
    </b-modal>

    <!-- add modal here -->
    <b-modal id="modal-message" title="Send Message" centered hide-footer>
      <b-form @submit.prevent>
        <b-form-group :label="$t('Message')">
          <b-form-textarea
            v-model.trim="messageText"
            rows="4"
            :placeholder="$t('Enter your message')"
          ></b-form-textarea>
        </b-form-group>

        <div class="d-flex justify-content-end mt-2">
          <b-button variant="primary" @click="sendMessage" :disabled="sending">
            <b-spinner small v-if="sending" class="mr-50" />
            <span>{{
              sending ? $t("Sending") + "..." : $t("Send Message")
            }}</span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <div>
      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility7"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Transfer Student") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility7 = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="">
            <b-col md="12" class="mb-1">
              <b-media vertical-align="center">
                <template #aside>
                  <b-avatar
                    size="44"
                    :src="getStudentPicturePreview(chObj.picture)"
                    variant="light-primary"
                    referrerpolicy="no-referrer"
                  />
                </template>

                <b-link
                  class="font-weight-bold d-block text-nowrap"
                  style="margin-bottom: 4px"
                >
                  <b-badge variant="light-primary">
                    {{ chObj.name }}
                  </b-badge>
                </b-link>
                <small class="text-muted">
                  <b-badge variant="light-primary" class="mr-50">
                    {{ $t("GR") }} -
                    {{
                      reportDomain === "myskoolhpgs" ||
                      reportDomain === "myskoolprofectus"
                        ? chObj.grNoLocal
                        : chObj.grNo
                    }}
                  </b-badge>
                  <b-badge variant="light-primary" class="mr-50">
                    F# - {{ chObj.family_code }}
                  </b-badge>
                  <b-badge variant="light-primary">
                    {{
                      reportDomain === "myskoolhpgs" ||
                      reportDomain === "myskoolprofectus"
                        ? "CID: "
                        : "ID: "
                    }}

                    {{
                      reportDomain === "myskoolhpgs" ||
                      reportDomain === "myskoolprofectus"
                        ? chObj.grNo
                        : chObj.id
                    }}
                  </b-badge>
                </small>
              </b-media>
            </b-col>
            <b-col cols="12">
              <b-form-group :label="$t('Current Campus')">
                <b-badge variant="primary">
                  {{ getCampus(chObj.campusID) }}
                </b-badge>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t('Transfer to Campus')"
                :invalid-feedback="$t('Campus is required.')"
                ref="ch_camp"
              >
                <v-select
                  v-model="chObj.newCampus"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="campuses"
                  :clearable="false"
                  label="branch"
                  :reduce="(val) => val.id"
                  :disabled="clsLoading"
                  :placeholder="$t('Select campus')"
                  @input="LoadClass()"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t(classLabel)"
                :invalid-feedback="$t(classLabel + ' is required')"
                ref="ch_cls"
              >
                <v-select
                  v-model="chObj.clsID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="chOptions"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  :disabled="clsLoading"
                  :placeholder="$t('Select ' + classLabel)"
                  @input="FillChSec()"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t('Section')"
                :invalid-feedback="$t('Section is required')"
                ref="ch_sec"
              >
                <v-select
                  v-model="chObj.secID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="chSections"
                  :reduce="(opt) => opt.id"
                  label="section"
                  :clearable="false"
                  :disabled="clsLoading"
                  :placeholder="$t('Select section')"
                  @input="checkChSec()"
                />
              </b-form-group>
            </b-col>

            <b-col class="mt-1" md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="success"
                class="mr-1"
                block
                :disabled="request"
                @click="saveCh()"
              >
                <b-spinner v-if="request" small type="grow" />
                <span v-else>{{ $t("Transfer") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
        <sidebar-content />
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <!-- <h5 class="mb-0">
            {{ sidebarTitle }}
          </h5> -->
          <h5 class="mb-0" v-html="sidebarTitle"></h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hideSideBar()"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="">
            <b-col cols="12">
              <b-form-group
                :label="$t('Reason')"
                :invalid-feedback="$t('reason is required.')"
              >
                <b-form-input
                  ref="reason"
                  id="mc-first-name"
                  :placeholder="$t('Enter leaving reason')"
                  v-model.trim="leaveObj.reason"
                  @focusout="CheckReason()"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t('Date of leaving')"
                :invalid-feedback="$t('Date of leaving is required')"
                ref="leave_date"
              >
                <flat-pickr
                  :config="leavingDateConfig"
                  v-model="leaveObj.date_of_leaving"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                  @on-change="CheckDate()"
                />
              </b-form-group>
            </b-col>

            <b-col cols="12" class="mb-1" v-if="!isHappiness">
              <b-form-group :invalid-feedback="$t('Category is required.')">
                <div class="">
                  <label class="bv-no-focus-ring col-form-label pt-0">{{
                    $t("Category")
                  }}</label>
                  <feather-icon
                    class="cursor-pointer ml-50"
                    icon="EditIcon"
                    size="18"
                    v-b-tooltip.hover.top
                    :title="$t('Manage Categories')"
                    @click="openCat()"
                  />
                </div>
                <v-select
                  v-model="leftSelected"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="[{ title: 'None' }, ...leftOptions]"
                  :reduce="(opt) => opt.title"
                  label="title"
                  :clearable="false"
                  :placeholder="$t('Select category')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="!isHappiness">
              <span>{{ $t("Remaining Dues") }}:</span>
              <b-badge variant="danger" class="ml-1">{{ totalDues }}</b-badge>
            </b-col>

            <b-col class="mt-1" md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="success"
                class="mr-1"
                @click="Add()"
                block
                :disabled="request"
              >
                <b-spinner v-if="request" small type="grow" />
                <span v-else> {{ $t(sidebarButton) }} </span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
        <sidebar-content />
      </b-sidebar>

      <b-sidebar
        id="sidebar-cat"
        bg-variant="white"
        v-model="visibility9"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Manage Categories") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility9 = false"
          />
        </div>

        <b-form class="p-2" @submit.prevent>
          <b-row class="d-flex align-items-center">
            <b-col md="12">
              <b-form-group
                :label="$t('Category Name')"
                :invalid-feedback="$t('Category name is required.')"
              >
                <b-form-input
                  ref="cat_name"
                  v-model.trim="catObj.title"
                  :placeholder="$t('Enter category name')"
                  @focusout="checkCat()"
                >
                </b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-button
                variant="success"
                class="btn-icon mt-1"
                @click="saveCat()"
                :disabled="savingCat"
                block
              >
                <b-spinner v-if="savingCat" small type="grow" />
                <span v-else>{{ $t("Save") }}</span>
              </b-button>
            </b-col>
          </b-row>
          <b-table
            class="mt-2"
            show-empty
            :items="leftOptions"
            :fields="catFields"
            responsive
            hover
          >
            <template #head()="scope">
              <div>
                <span>{{ $t(scope.label) }}</span>
              </div>
            </template>

            <template #head(actions)="data">
              <div class="text-right">
                <span>{{ $t(data.label) }}</span>
              </div>
            </template>

            <template #cell(actions)="data">
              <div class="text-right">
                <b-button
                  variant="primary"
                  class="btn-icon mr-50"
                  @click="editCat(data.item)"
                >
                  <feather-icon icon="EditIcon" />
                </b-button>
                <!-- <b-button
                  variant="outline-danger"
                  class="btn-icon"
                  @click="deleteCat(data.item.id)"
                >
                  <feather-icon icon="Trash2Icon" />
                </b-button> -->
              </div>
            </template>
          </b-table>
        </b-form>
        <sidebar-content />
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility6"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0" v-html="sidebarTitle"></h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility6 = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="">
            <b-table
              v-if="reqData.length > 0"
              show-empty
              :items="reqData"
              :fields="reqFields"
              responsive
              hover
              small
            >
              <template #head()="scope">
                <div>
                  <span>{{ $t(scope.label) }}</span>
                </div>
              </template>

              <template #cell(request)="data">
                <div class="mb-25">
                  <b-badge variant="light-primary">
                    ID: {{ data.item.id }}
                  </b-badge>
                </div>
                <div>
                  <b-badge variant="light-primary">
                    {{
                      new Date(data.item.request_date).toLocaleDateString(
                        "en-UK",
                        {
                          year: "numeric",
                          day: "numeric",
                          month: "short",
                        }
                      )
                    }}
                  </b-badge>
                </div>
              </template>

              <template #cell(type)="data">
                <b-badge variant="light-primary" class="text-capitalize">
                  {{ data.value }}
                </b-badge>
              </template>

              <template #cell(actions)="data">
                <b-button
                  variant="primary"
                  class="btn-icon"
                  @click="showReqDetails(data.item)"
                >
                  <feather-icon icon="EyeIcon" />
                </b-button>
              </template>
            </b-table>
            <b-col cols="12">
              <b-form-group
                :label="$t('Request on')"
                :invalid-feedback="$t('Date is required')"
                ref="req_date"
              >
                <flat-pickr
                  :config="config"
                  v-model="reqObj.request_date"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t('Reason')"
                :invalid-feedback="$t('Reason is required.')"
                ref="req_reason"
              >
                <b-form-textarea
                  :placeholder="$t('Enter reason')"
                  rows="3"
                  v-model.trim="reqObj.reason"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t('Request Type')"
                :invalid-feedback="$t('Type is required')"
                ref="req_st"
              >
                <v-select
                  v-model="reqObj.type"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="currentOptions"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :clearable="false"
                  :placeholder="$t('Select type')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="reqObj.type === 'monthly-discount'">
              <b-form-group
                :invalid-feedback="reqAmountFeedback"
                ref="req_amount"
              >
                <div class="d-flex justify-content-between pb-50">
                  <label class="bv-no-focus-ring col-form-label p-0">{{
                    $t("New Monthly Fee") + " *"
                  }}</label>
                  <span v-if="currentStd">
                    <span class="text-muted mr-50"
                      >{{ $t("Monthly Fee") }}:</span
                    >
                    <b-badge variant="light-primary">{{
                      currentStd.monthly_fee
                    }}</b-badge>
                  </span>
                </div>
                <b-form-input
                  type="number"
                  v-model="reqAmount"
                  :placeholder="$t('Enter monthly fee')"
                  no-wheel
                  @focusout="CheckReqAmount()"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <div class="d-flex justify-content-between">
                <label class="bv-no-focus-ring col-form-label pt-0">{{
                  $t("Documents")
                }}</label>
              </div>
              <div class="d-flex flex-wrap">
                <div
                  class="border-dashed d-flex flex-column justify-content-center align-items-center cursor-pointer rounded mr-50 mb-1"
                  style="width: 110px; height: 96px"
                  @click="!docLoading && $refs.reqDocs.click()"
                >
                  <b-spinner
                    v-if="docLoading"
                    small
                    :label="$t('Loading') + '...'"
                    variant="primary"
                  />
                  <feather-icon
                    v-else
                    icon="PlusIcon"
                    size="34"
                    class="text-primary"
                  />
                </div>
                <div
                  class="border-dashed d-flex flex-column justify-content-center align-items-center cursor-pointer rounded mr-50 mb-1"
                  style="width: 110px; height: 96px; position: relative"
                  v-for="(file, index) in docList"
                  :key="index"
                  @click="openFile(file)"
                >
                  <b-avatar
                    size="20"
                    variant="primary"
                    style="position: absolute; top: -5px; right: -5px"
                    button
                    @click.stop="removeDoc(index)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-avatar>
                  <feather-icon
                    :icon="isImage(file) ? 'ImageIcon' : 'FileTextIcon'"
                    size="30"
                    class="text-primary"
                  />
                </div>

                <input
                  type="file"
                  id="reqDocs"
                  hidden
                  ref="reqDocs"
                  multiple
                  @change="addDoc()"
                  accept="image/*,.pdf"
                />
              </div>
            </b-col>
            <b-col cols="12">
              <span>{{ $t("Remaining Dues") }}:</span>
              <b-badge variant="danger" class="ml-1">{{ totalDues }}</b-badge>
            </b-col>
            <b-col class="mt-1" md="12">
              <b-button
                variant="success"
                :disabled="saving"
                block
                @click="saveLeaveReq()"
              >
                <b-spinner v-if="saving" small type="grow" />
                <span v-else> {{ $t("Save") }} </span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
        <sidebar-content />
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility8"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0" v-html="sidebarTitle"></h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility8 = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <RequestDetails :reqItem="detailObj" />
        </b-form>
        <sidebar-content />
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility5"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0" v-html="sidebarTitle"></h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility5 = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="mt-1">
            <b-col cols="12">
              <b-form-group
                :label="$t('Reason')"
                :invalid-feedback="$t('Reason is required.')"
              >
                <b-form-input
                  ref="sus_reason"
                  id="mc-first-name"
                  :placeholder="$t('Enter suspension reason')"
                  v-model.trim="susObj.suspend_reason"
                  @focusout="CheckSusReason()"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <!-- label="Suspend Till" -->
              <b-form-group
                :invalid-feedback="$t('Date is required')"
                ref="sus_date"
              >
                <div class="d-flex justify-content-between pb-50">
                  <label class="bv-no-focus-ring col-form-label p-0">{{
                    $t("Suspend Till")
                  }}</label>
                  <span>
                    <b-badge
                      v-for="item in susOptions"
                      :key="item.value"
                      pill
                      :variant="
                        currentSelected == item.value
                          ? 'primary'
                          : 'light-primary'
                      "
                      class="mr-50 cursor-pointer"
                      @click="setTillDate(item.value)"
                    >
                      {{ item.text }}
                    </b-badge>
                  </span>
                </div>
                <flat-pickr
                  :config="config"
                  v-model="susObj.suspend_till"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
                <!-- @on-change="CheckSusDate()" -->
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group :label="$t('Suspend Mode')">
                <v-select
                  v-model="susObj.suspend_mode"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="suspendModeOptions"
                  :reduce="(val) => val.value"
                  label="text"
                  :clearable="false"
                  :placeholder="$t('Select')"
                  @input="onSuspendModeChange"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t('Suspend For')"
                :invalid-feedback="$t('Suspend for is required.')"
                ref="sus_for"
                v-show="susObj.suspend_mode === 'partial'"
              >
                <b-form-checkbox
                  class="mb-1"
                  v-model="susObj.suspend_for_attentance"
                >
                  {{ $t("Attendance") }}
                </b-form-checkbox>
                <b-form-checkbox
                  class="mb-1"
                  v-model="susObj.suspend_for_homework"
                >
                  {{ $t("Homework") }}
                </b-form-checkbox>
                <b-form-checkbox
                  class="mb-1"
                  v-model="susObj.suspend_for_exams"
                >
                  {{ $t("Examination") }}
                </b-form-checkbox>
                <b-form-checkbox
                  class="mb-1"
                  v-model="susObj.suspend_for_messaging"
                >
                  {{ $t("Messages") }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col class="mt-1" md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="success"
                class="mr-1"
                @click="Suspend()"
                block
                :disabled="request"
              >
                <b-spinner v-if="request" small type="grow" />
                <span v-else> {{ $t("Suspend") }} </span>
              </b-button>
            </b-col>
            <b-col class="mt-1" md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="danger"
                class="mr-1"
                @click="ClearSuspend()"
                block
                :disabled="request"
              >
                <b-spinner v-if="request" small type="grow" />
                <span v-else> {{ $t("Clear Suspension") }} </span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
        <sidebar-content />
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility2"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Import") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility2 = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="">
            <b-col md="12" class="pt-1 pl-1 mb-1" v-if="rights.add">
              <b-button
                @click="$refs.importFile.click()"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                :disabled="stdImporting"
                block
              >
                <b-spinner
                  v-if="stdImporting"
                  small
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                <div v-else>
                  <input
                    type="file"
                    id="importFile"
                    hidden
                    ref="importFile"
                    @change="Import()"
                  />
                  <feather-icon icon="PlusIcon" class="mr-50" />
                  <span class="align-middle">{{ $t("Import") }} </span>
                </div>
              </b-button>
            </b-col>
            <b-col md="12" class="pt-1 pl-1" v-if="rights.add">
              <b-button
                @click="$refs.importFee.click()"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                :disabled="feeImporting"
                block
              >
                <b-spinner
                  v-if="feeImporting"
                  small
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                <div v-else>
                  <input
                    type="file"
                    id="importFee"
                    hidden
                    ref="importFee"
                    @change="ImportFee()"
                  />
                  <feather-icon icon="PlusIcon" class="mr-50" />
                  <span class="align-middle"> {{ $t("Fee") }}</span>
                </div>
              </b-button>
            </b-col>
            <b-col md="12" class="pt-1 pl-1" v-if="rights.add">
              <b-button
                @click="openCustomFeeImportModal()"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                :disabled="customFeeSubmitting"
                block
              >
                <b-spinner
                  v-if="customFeeSubmitting"
                  small
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                <div v-else>
                  <span class="align-middle"> {{ $t("Custom Fees") }}</span>
                </div>
              </b-button>
            </b-col>
            <b-col
              md="12"
              class="pt-1 pl-1"
              v-if="rights.add && showBulkDriverLink"
            >
              <b-button
                @click="openBulkDriverLinkModal()"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                :disabled="driverLinkSubmitting"
                block
              >
                <b-spinner
                  v-if="driverLinkSubmitting"
                  small
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                <div v-else>
                  <span class="align-middle">
                    {{ $t("Bulk Driver Link") }}
                  </span>
                </div>
              </b-button>
            </b-col>
            <!-- <b-col md="12" class="pt-1 pl-1" v-if="rights.add">
              <b-button
                @click="$refs.importStaff.click()"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                :disabled="staffImporting"
                block
              >
                <b-spinner
                  v-if="staffImporting"
                  small
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                <div v-else>
                  <input
                    type="file"
                    id="importStaff"
                    hidden
                    ref="importStaff"
                    @change="ImportStaff()"
                  />
                  <feather-icon icon="PlusIcon" class="mr-50" />
                  <span class="align-middle">Staff</span>
                </div>
              </b-button>
            </b-col> -->
          </b-row>
        </b-form>
        <sidebar-content />
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility4"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Export") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility4 = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="">
            <b-col cols="12">
              <b-form-checkbox
                v-for="(data, ind) in exportSchema"
                :key="ind"
                class="mb-1"
                v-model="data.status"
              >
                {{ data.text }}
              </b-form-checkbox>
            </b-col>
            <b-col md="12" class="pt-1 pl-1">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                :disabled="exporting"
                block
                @click="exportNew()"
              >
                <b-spinner v-if="exporting" small varaint="primary" />
                <span v-else>{{ $t("Export") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
        <sidebar-content />
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility3"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Generate Family Code") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility3 = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="">
            <b-col md="12" class="mb-1">
              <b-button
                @click="codeBy = false"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                :variant="!codeBy ? 'primary' : 'outline-primary'"
                block
              >
                {{ $t("Generate By CNIC") }}
              </b-button>
            </b-col>
            <b-col md="12">
              <b-button
                @click="codeBy = true"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                :variant="codeBy ? 'primary' : 'outline-primary'"
                block
              >
                {{ $t("Generate By Contact Number") }}
              </b-button>
            </b-col>
            <b-col md="12" class="mt-2">
              <b-button
                @click="assignCode()"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                :disabled="assignLoading"
                block
              >
                <b-spinner
                  v-if="assignLoading"
                  small
                  variant="light"
                  :label="$t('assigning')"
                ></b-spinner>
                <span v-else> {{ $t("Assign Family Code") }} </span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
        <sidebar-content />
      </b-sidebar>

      <b-sidebar
        id="sidebar-Fee"
        bg-variant="white"
        v-model="sessionbar"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Manage Sessions") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="sessionbar = false"
          />
        </div>

        <b-form class="p-2" @submit.prevent>
          <b-row class="d-flex align-items-center">
            <b-col md="10">
              <b-form-group
                :label="$t('Name')"
                :invalid-feedback="$t('Session name is required')"
              >
                <b-form-input
                  ref="sess_name"
                  v-model="sessionObj.session"
                  :placeholder="$t('Enter session name')"
                  @focusout="SessName()"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-button
                variant="success"
                class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
                @click="saveSession()"
                :disabled="savingacc"
              >
                <b-spinner v-if="savingacc" small type="grow" />
                <feather-icon v-else :icon="accIcon" />
              </b-button>
            </b-col>
          </b-row>
          <b-table
            class="mt-1"
            show-empty
            :items="sessions"
            :fields="sessFields"
            responsive
            hover
            small
          >
            <template #head()="scope">
              <div>
                <span>{{ $t(scope.label) }}</span>
              </div>
            </template>

            <template #head(actions)="data">
              <div class="text-center">
                <span>{{ $t(data.label) }}</span>
              </div>
            </template>

            <template #cell(session)="data">
              <b-badge
                variant="light-primary"
                v-if="data.item.isCurrentSession"
              >
                {{ data.item.session }}
              </b-badge>
              <span v-else>{{ data.item.session }}</span>
            </template>

            <template #cell(actions)="data">
              <div class="text-center">
                <b-button
                  variant="primary"
                  class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                  @click="editSess(data.item)"
                >
                  <feather-icon icon="EditIcon" />
                </b-button>

                <b-button
                  variant="outline-danger"
                  class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                  @click="deleteSess(data.item)"
                >
                  <feather-icon icon="Trash2Icon" />
                </b-button>

                <b-button
                  v-if="!data.item.isCurrentSession"
                  variant="outline-primary"
                  class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                  @click="setCurrentSess(data.item.id)"
                >
                  <feather-icon icon="CheckCircleIcon" />
                </b-button>
              </div>
            </template>
          </b-table>
        </b-form>
        <sidebar-content />
      </b-sidebar>

      <b-sidebar
        id="sidebar-edit"
        bg-variant="white"
        v-model="visibility10"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t(editField.name) }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility10 = false"
          />
        </div>

        <b-form class="p-2" @submit.prevent>
          <b-row>
            <b-col md="12" class="mb-1">
              <b-media vertical-align="center">
                <template #aside>
                  <b-avatar
                    size="44"
                    :src="getStudentPicturePreview(editObj.picture)"
                    variant="light-primary"
                    referrerpolicy="no-referrer"
                  />
                </template>

                <b-link
                  class="font-weight-bold d-block text-nowrap"
                  style="margin-bottom: 4px"
                >
                  <b-badge variant="light-primary" class="font-small-4">
                    {{ editObj.name }}
                  </b-badge>
                </b-link>
                <small class="text-muted">
                  <b-badge variant="light-primary" class="mr-50">
                    {{ $t("GR") }} -
                    {{
                      reportDomain === "myskoolhpgs" ||
                      reportDomain === "myskoolprofectus"
                        ? editObj.grNoLocal
                        : editObj.grNo
                    }}
                  </b-badge>
                  <b-badge variant="light-primary" class="mr-50">
                    {{ $t("F#") }} - {{ editObj.family_code }}
                  </b-badge>
                </small>
              </b-media>
            </b-col>
            <b-col md="12" v-if="editField.field == 'section'">
              <b-form-group
                :label="$t('Section')"
                :invalid-feedback="$t('Section is required')"
                ref="ed_sec"
              >
                <v-select
                  v-model="editObj.section_current"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="editSections"
                  :reduce="(opt) => opt.id"
                  label="section"
                  :clearable="false"
                  :disabled="clsLoading"
                  :placeholder="$t('Select section')"
                />
              </b-form-group>
            </b-col>
            <b-col md="12" v-else-if="editField.field == 'grNo'">
              <b-form-group
                :label="$t('Gr number')"
                :invalid-feedback="$t('Gr number is required.')"
                ref="ed_gr"
              >
                <b-form-input
                  :placeholder="$t('Enter Gr number')"
                  v-model.trim="editObj.tempGr"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-button
                variant="success"
                class="btn-icon mt-1"
                @click="saveField()"
                :disabled="editing"
                block
              >
                <b-spinner v-if="editing" small type="grow" />
                <span v-else>{{ $t("Save") }}</span>
              </b-button>
            </b-col> </b-row
          >:
        </b-form>
        <sidebar-content />
      </b-sidebar>

      <b-card>
        <b-row>
          <b-col
            :md="isHappiness ? 4 : 2"
            class="pt-1 pr-md-0"
            v-if="
              rights.add &&
              (['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)
                ? isHeadOffice
                : true)
            "
          >
            <!-- v-if="!hideRegistration" -->
            <b-button
              @click="AddOpen('reg')"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              block
            >
              <feather-icon icon="UserPlusIcon" class="mr-50" />
              <span class="align-middle">{{
                $t(isHappiness ? "Register New Student" : "Registration")
              }}</span>
            </b-button>
          </b-col>
          <b-col
            md="2"
            class="pt-1 pr-md-0"
            v-if="
              !isHappiness &&
              rights.add &&
              (['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)
                ? isHeadOffice
                : true)
            "
          >
            <b-dropdown
              v-if="
                reportDomain == 'myskoolhpgs' &&
                $store.state.loggedUser.campusID == 1 &&
                ['Administrator', 'administrator'].includes(
                  $store.state.loggedUser.meta_role
                )
              "
              variant="success"
              block
              split
              right
              @click="AddOpen('add')"
            >
              <template #button-content>
                <feather-icon icon="PlusIcon" class="mr-50" />
                <span class="align-middle">{{ $t("Admission") }}</span>
              </template>
              <b-dropdown-item :to="{ name: 'add-student' }">
                {{ $t("Add Student") }}
              </b-dropdown-item>
            </b-dropdown>
            <b-button
              v-else
              @click="AddOpen('add')"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              block
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">{{
                $t(isHappiness ? "Enrollment" : "Admission")
              }}</span>
            </b-button>
          </b-col>

          <b-col
            :md="
              $store.state.currentBranch.organizationType == 'coaching'
                ? '3'
                : '4'
            "
            class="pt-1"
          >
            <b-form-group class="ml-md-0 ml-sm-0 ml-0 mb-0">
              <!-- <b-form-input
                v-model="searchQuery"
                @keyup.enter="loadSearch()"
                :placeholder="
                  searchType == '' ? 'Search...' : `Search by ${searchType}`
                "
                style="border-radius: inherit"
              >
              </b-form-input>
              <b-badge variant="primary">
                {{ searchType == "" ? "General" : searchType }}
              </b-badge> -->
              <b-input-group>
                <b-input-group-prepend
                  is-text
                  @click="loadSearch()"
                  class="cursor-pointer position-relative"
                >
                  <feather-icon icon="SearchIcon" />
                  <b-avatar
                    v-if="bySearch"
                    size="18"
                    class="p-25"
                    variant="danger"
                    style="
                      position: absolute;
                      top: -5px;
                      right: -5px;
                      z-index: 5;
                    "
                    button
                    v-b-tooltip.hover.top
                    :title="$t('Clear')"
                    @click.stop="ClearSearch()"
                  >
                    <feather-icon icon="XIcon" />
                  </b-avatar>
                </b-input-group-prepend>
                <b-form-input
                  v-model="searchQuery"
                  @keyup.enter="loadSearch()"
                  :placeholder="
                    searchType == ''
                      ? $t('Search') + '...'
                      : $t('Search by') +
                        ' ' +
                        $t(
                          `${
                            reportDomain === 'myskoolhpgs' && searchType == 'gr'
                              ? 'CID'
                              : searchType == 'grlocal'
                              ? 'grno'
                              : searchType
                          }`
                        )
                  "
                  style="border: none; border-left: 1px solid #d8d6de"
                >
                </b-form-input>
                <b-input-group-append
                  is-text
                  @click="openOptions()"
                  class="cursor-pointer p-50"
                >
                  <b-badge variant="primary">
                    {{
                      searchType == ""
                        ? $t("General")
                        : reportDomain === "myskoolhpgs" && searchType == "gr"
                        ? $t("CID")
                        : searchType == "grlocal"
                        ? $t("grno")
                        : $t(searchType)
                    }}
                  </b-badge>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="2" class="p-0 pt-1 pr-1">
            <!-- v-if="!byFilter" -->
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              block
              @click="openFilter()"
              class="position-relative"
            >
              <feather-icon icon="FilterIcon" class="mr-50" />
              <span class="align-middle">{{ $t("Filter") }}</span>
              <b-avatar
                v-if="byFilter"
                size="20"
                variant="danger"
                style="position: absolute; top: -5px; right: -5px"
                button
                v-b-tooltip.hover.top
                :title="$t('Clear')"
                @click.stop="LoadData()"
              >
                <feather-icon icon="XIcon" />
              </b-avatar>
            </b-button>
            <!-- <b-button
              v-else
              @click="LoadData()"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              block
            >
              <feather-icon icon="XIcon" class="mr-50" />
              <span class="align-middle">{{ $t("Clear") }}</span>
            </b-button> -->
          </b-col>

          <b-col
            :md="
              $store.state.currentBranch.organizationType == 'coaching'
                ? '3'
                : '2'
            "
            class="pt-1 pr-50 pl-0 d-flex justify-content-between align-items-start"
          >
            <v-select
              class="pr-50"
              :style="{
                width:
                  $store.state.currentBranch.organizationType == 'coaching'
                    ? '50%'
                    : '100%',
              }"
              v-model="currentStatus"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions"
              :reduce="(opt) => opt.value"
              label="text"
              @input="LoadData()"
              :clearable="false"
              :placeholder="$t('Select status')"
            />
            <!-- <b-form-group label="" class="ml-md-0 ml-sm-0 ml-0 mb-0 pr-50">
            </b-form-group> -->
            <v-select
              v-if="$store.state.currentBranch.organizationType == 'coaching'"
              class="pr-50"
              style="width: 50%"
              v-model="sessionID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sessions"
              :reduce="(opt) => opt.id"
              label="session"
              :clearable="false"
              :placeholder="$t('Select session')"
              @input="LoadData()"
            />
            <b-button
              v-if="['myskoolszablc'].includes(reportDomain)"
              @click="openQr()"
              variant="outline-secondary"
              class="btn-icon p-0 ml-50"
              v-b-tooltip.hover.top
              :title="$t('Generate QR Code')"
            >
              <img src="@/assets/images/icons/qr-code.png" width="34" />
            </b-button>
          </b-col>
          <!-- <div class="pt-1">
            
          </div> -->
        </b-row>

        <!--  <b-row class="align-items-center justify-content-between pl-1 pr-1">
          <h4 v-if="!byFilter" class="m-0">Total: {{ items.length }}</h4>
          <h4 v-else class="m-0">
            <span v-if="items.length > 0"
              >{{ items[0].meta_class }}: {{ items.length }}</span
            >
          </h4> 
         
        </b-row> -->
        <!-- Desktop: Buttons and Pagination in One Line -->
        <b-row class="d-none d-md-flex">
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-between mt-50"
          >
            <!-- Pagination on the left -->
            <div class="d-flex align-items-center">
              <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                size="sm"
                limit="2"
                class="mb-0"
                prev-class="prev-item"
                next-class="next-item"
                @input="move()"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="14" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="14" />
                </template>
              </b-pagination>
            </div>

            <!-- Buttons on the right -->
            <div>
              <b-button
                v-if="
                  msgVisible.includes(reportDomain) &&
                  currentStatus == 'registered' &&
                  stdIDs.length > 0
                "
                @click="openMessage()"
                variant="outline-success"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('Send Message')"
              >
                <feather-icon icon="MessageCircleIcon" />
                <span v-if="stdIDs.length > 0" class="ml-25"
                  >&nbsp;({{ stdIDs.length }})</span
                >
              </b-button>
              <b-button
                v-if="
                  ['myskoolcrestviewacademy', 'myskool'].includes(reportDomain)
                "
                @click="openRegistrationQr()"
                variant="outline-secondary"
                class="btn-icon mr-1 p-0"
                v-b-tooltip.hover.top
                :title="$t('Generate QR Code')"
              >
                <img src="@/assets/images/icons/qr-code.png" width="34" />
              </b-button>
              <b-button
                @click="openReport()"
                variant="outline-primary"
                class="btn-icon mr-1"
                :disabled="printing"
              >
                <b-spinner
                  v-if="printing"
                  variant="primary"
                  label="loading"
                  small
                ></b-spinner>
                <feather-icon
                  v-if="!printing"
                  icon="PrinterIcon"
                  class="mr-50"
                />
                <span v-if="!printing">{{ $t("Print") }}</span>
                <span v-if="!printing && stdIDs.length > 0"
                  >&nbsp;({{ stdIDs.length }})</span
                >
              </b-button>
              <b-button
                v-if="
                  stdIDs.length > 0 &&
                  templateLink &&
                  templateLink.value == 'template_link'
                "
                @click="openTemplateModal()"
                variant="outline-success"
                class="btn-icon mr-1"
                :disabled="printing"
              >
                <feather-icon icon="FileTextIcon" class="mr-50" />
                <span>{{ $t("Select Template") }}</span>
                <span>&nbsp;({{ stdIDs.length }})</span>
              </b-button>
              <b-button
                v-if="stdIDs.length > 0"
                @click="unselect()"
                variant="outline-secondary"
                class="btn-icon mr-1"
                :disabled="printing"
              >
                <feather-icon icon="XIcon" class="mr-50" />
                <span>{{ $t("Unselect All") }}</span>
              </b-button>
              <b-button
                v-if="reportDomain == 'myskoolroyal'"
                variant="outline-success"
                class="btn-icon mr-1"
                :disabled="resetLoading"
                v-b-tooltip.hover.top
                :title="$t('Reset Roll No')"
                @click="resetRollNo()"
              >
                <b-spinner
                  v-if="resetLoading"
                  variant="success"
                  label="loading"
                  small
                ></b-spinner>
                <feather-icon v-else icon="RefreshCwIcon" class="" />
              </b-button>
              <b-button
                @click="syncApp()"
                variant="outline-primary"
                class="btn-icon mr-1"
                :disabled="syncLoading"
                v-b-tooltip.hover.top
                :title="$t('Sync App Accounts')"
              >
                <b-spinner
                  v-if="syncLoading"
                  variant="primary"
                  label="loading"
                  small
                ></b-spinner>
                <feather-icon v-else icon="SmartphoneIcon" class="" />
              </b-button>
              <b-button
                @click="visibility3 = true"
                variant="outline-primary"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('Generate Family Code')"
              >
                <feather-icon icon="UsersIcon" class="" />
              </b-button>
              <student-import
                v-if="
                  ['myskooltcfdemo', 'myskooltcf'].includes(reportDomain) &&
                  isHeadOffice
                "
                class="mr-1 d-inline-block"
                button-class="btn-icon"
                @imported="LoadData"
              />
              <b-button
                v-else-if="
                  !['myskooltcfdemo', 'myskooltcf'].includes(reportDomain) &&
                  !rights.disableImport
                "
                @click="OpenImport()"
                variant="outline-primary"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('Import')"
              >
                <feather-icon icon="DownloadIcon" class="" />
              </b-button>
              <b-button
                v-if="!rights.disableExport"
                variant="outline-primary"
                v-b-tooltip.hover.top
                :title="$t('Export')"
                class="btn-icon"
                :disabled="exporting"
                @click="openExport()"
              >
                <!-- @click="exportData()" -->
                <b-spinner v-if="exporting" small varaint="primary" />
                <feather-icon v-else icon="UploadIcon" class="" />
              </b-button>
              <b-button
                v-if="$store.state.currentBranch.organizationType == 'coaching'"
                variant="outline-primary"
                v-b-tooltip.hover.top
                :title="$t('Manage Sessions')"
                class="btn-icon ml-1"
                @click="openSession()"
              >
                <feather-icon icon="SettingsIcon" class="" />
              </b-button>
            </div>
          </b-col>
        </b-row>

        <!-- Mobile: Buttons on Top, Pagination Below -->
        <b-row class="d-flex d-md-none">
          <!-- Buttons Row for Mobile -->
          <b-col cols="12" class="d-flex justify-content-center mt-50 mb-2">
            <div class="d-flex flex-wrap justify-content-center">
              <b-button
                v-if="
                  msgVisible.includes(reportDomain) &&
                  currentStatus == 'registered' &&
                  stdIDs.length > 0
                "
                @click="openMessage()"
                variant="outline-success"
                class="btn-icon mr-1 mb-1"
                v-b-tooltip.hover.top
                :title="$t('Send Message')"
              >
                <feather-icon icon="MessageCircleIcon" />
                <span v-if="stdIDs.length > 0" class="ml-25"
                  >({{ stdIDs.length }})</span
                >
              </b-button>
              <b-button
                v-if="
                  ['myskoolcrestviewacademy', 'myskool'].includes(reportDomain)
                "
                @click="openRegistrationQr()"
                variant="outline-secondary"
                class="btn-icon mr-1 mb-1 p-0"
                v-b-tooltip.hover.top
                :title="$t('Generate QR Code')"
              >
                <img src="@/assets/images/icons/qr-code.png" width="34" />
              </b-button>
              <b-button
                @click="openReport()"
                variant="outline-primary"
                class="btn-icon mr-1 mb-1"
                :disabled="printing"
              >
                <b-spinner
                  v-if="printing"
                  variant="primary"
                  label="loading"
                  small
                ></b-spinner>
                <feather-icon
                  v-if="!printing"
                  icon="PrinterIcon"
                  class="mr-50"
                />
                <span v-if="!printing">{{ $t("Print") }}</span>
                <span v-if="!printing && stdIDs.length > 0"
                  >({{ stdIDs.length }})</span
                >
              </b-button>
              <b-button
                v-if="stdIDs.length > 0"
                @click="unselect()"
                variant="outline-secondary"
                class="btn-icon mr-1 mb-1"
                :disabled="printing"
              >
                <feather-icon icon="XIcon" class="mr-50" />
                <span>{{ $t("Unselect All") }}</span>
              </b-button>
              <b-button
                v-if="reportDomain == 'myskoolroyal'"
                variant="outline-success"
                class="btn-icon mr-1 mb-1"
                :disabled="resetLoading"
                v-b-tooltip.hover.top
                :title="$t('Reset Roll No')"
                @click="resetRollNo()"
              >
                <b-spinner
                  v-if="resetLoading"
                  variant="success"
                  label="loading"
                  small
                ></b-spinner>
                <feather-icon v-else icon="RefreshCwIcon" class="" />
              </b-button>
              <b-button
                @click="syncApp()"
                variant="outline-primary"
                class="btn-icon mr-1 mb-1"
                :disabled="syncLoading"
                v-b-tooltip.hover.top
                :title="$t('Sync App Accounts')"
              >
                <b-spinner
                  v-if="syncLoading"
                  variant="primary"
                  label="loading"
                  small
                ></b-spinner>
                <feather-icon v-else icon="SmartphoneIcon" class="" />
              </b-button>
              <b-button
                @click="visibility3 = true"
                variant="outline-primary"
                class="btn-icon mr-1 mb-1"
                v-b-tooltip.hover.top
                :title="$t('Generate Family Code')"
              >
                <feather-icon icon="UsersIcon" class="" />
              </b-button>
              <student-import
                v-if="
                  ['myskooltcfdemo', 'myskooltcf'].includes(reportDomain) &&
                  isHeadOffice
                "
                class="mr-1 d-inline-block"
                button-class="btn-icon"
                @imported="LoadData"
              />
              <b-button
                v-else-if="
                  !['myskooltcfdemo', 'myskooltcf'].includes(reportDomain) &&
                  !rights.disableImport
                "
                @click="OpenImport()"
                variant="outline-primary"
                class="btn-icon mr-1 mb-1"
                v-b-tooltip.hover.top
                :title="$t('Import')"
              >
                <feather-icon icon="DownloadIcon" class="" />
              </b-button>
              <b-button
                v-if="!rights.disableExport"
                variant="outline-primary"
                v-b-tooltip.hover.top
                :title="$t('Export')"
                class="btn-icon mr-1 mb-1"
                :disabled="exporting"
                @click="openExport()"
              >
                <b-spinner v-if="exporting" small varaint="primary" />
                <feather-icon v-else icon="UploadIcon" class="" />
              </b-button>
              <b-button
                v-if="$store.state.currentBranch.organizationType == 'coaching'"
                variant="outline-primary"
                v-b-tooltip.hover.top
                :title="$t('Manage Sessions')"
                class="btn-icon ml-1 mb-1"
                @click="openSession()"
              >
                <feather-icon icon="SettingsIcon" class="" />
              </b-button>
            </div>
          </b-col>

          <!-- Pagination Row for Mobile -->
          <b-col cols="12" class="d-flex justify-content-center">
            <b-pagination
              v-model="currentPage"
              :total-rows="total"
              :per-page="perPage"
              size="sm"
              limit="2"
              class="mb-0"
              prev-class="prev-item"
              next-class="next-item"
              @input="move()"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="14" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="14" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>

        <b-table
          class="mt-1 rotate-table"
          thead-tr-class="adjust-head"
          ref="selectableTable"
          :items="items"
          :fields="
            surnameVisible.includes(this.$store.state.clientID)
              ? otherFields
              : fields
          "
          :busy="dataLoading"
          show-empty
          responsive
          hover
          small
          :selectable="rights.edit"
          select-mode="multi"
          @row-selected="stdSelect($event)"
        >
          <template #empty="scope">
            <h3 class="mt-1 mb-1 text-center">{{ $t("No records found") }}</h3>
          </template>

          <template #table-busy>
            <div class="d-flex justify-content-center mb-3 mt-50">
              <b-spinner
                style="width: 3rem; height: 3rem"
                type="grow"
                variant="primary"
                label="Spinning"
              ></b-spinner>
            </div>
          </template>

          <template #head()="scope">
            <div>
              <span>{{
                $t(
                  scope.label == "Class"
                    ? `${classLabel} - ${sectionLabel}`
                    : scope.label
                )
              }}</span>
            </div>
          </template>

          <template #cell(index)="data">
            <b-badge variant="light-primary">
              {{ (currentPage - 1) * perPage + data.index + 1 }}
            </b-badge>
          </template>
          <template #cell(grNo)="data">
            <b-badge variant="light-primary">
              {{ data.item.grNo }}
            </b-badge>
          </template>
          <template #cell(pic)="data">
            <img
              v-if="data.item.picture"
              :src="getStudentPicturePreview(data.item.picture)"
              height="60"
              width="60"
              style="border-radius: 50%; object-fit: cover"
              referrerpolicy="no-referrer"
              alt="pic"
              @error="onStudentPictureError($event, data.item.picture)"
            />
            <b-img
              v-else
              src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
              height="60px"
              width="60px"
              style="border-radius: 50%; object-fit: contain"
              alt="pic"
            />
          </template>

          <template #cell(name)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  v-if="logoloading && currentID.id == data.item.id"
                  size="44"
                  variant="light-primary"
                >
                  <b-spinner small />
                </b-avatar>
                <b-avatar
                  v-else-if="data.item.picture"
                  size="44"
                  :src="getStudentPicturePreview(data.item.picture)"
                  variant="light-primary"
                  button
                  :disabled="logoloading"
                  referrerpolicy="no-referrer"
                  @click.stop="openUpload(data.item)"
                />
                <b-avatar
                  v-else
                  size="44"
                  variant="outline-primary"
                  button
                  :disabled="logoloading"
                  @click.stop="openUpload(data.item)"
                >
                  <feather-icon
                    size="22"
                    icon="UserIcon"
                    class="text-primary"
                  />
                </b-avatar>
                <input
                  type="file"
                  id="fileProfile"
                  hidden
                  ref="fileProfile"
                  @change="selectlogo()"
                  accept="image/*"
                />
              </template>

              <b-link
                class="font-weight-bold d-block text-nowrap"
                style="margin-bottom: 4px"
              >
                <b-badge variant="light-primary" class="font-small-4">
                  {{ data.item.name }}
                </b-badge>
              </b-link>
              <small
                v-if="['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)"
                class="text-muted d-block text-nowrap"
              >
                <b-badge variant="light-primary" class="mr-50">
                  FB Reg. No. -
                  {{ getDetails(data.item.id, "federalRegNo") || "—" }}
                </b-badge>
              </small>
              <small v-else class="text-muted">
                <b-badge variant="light-primary" class="mr-50">
                  {{ $t("GR") }} -
                  {{
                    reportDomain === "myskoolhpgs" ||
                    reportDomain === "myskoolprofectus"
                      ? data.item.grNoLocal
                      : data.item.grNo
                  }}
                </b-badge>
                <b-badge variant="light-primary" class="mr-50">
                  {{ $t("F#") }} - {{ data.item.family_code }}
                </b-badge>
                <b-badge variant="light-primary" class="mr-50">
                  {{ $t("RFID") }}: {{ data.item.rfid_number }}
                </b-badge>
              </small>
              <b-link
                class="font-weight-bold d-block text-nowrap"
                style="margin-top: 4px"
              >
                <b-badge variant="light-primary">
                  {{
                    reportDomain === "myskoolhpgs" ||
                    reportDomain === "myskoolprofectus"
                      ? "CID: "
                      : "ID: "
                  }}

                  {{
                    reportDomain === "myskoolhpgs" ||
                    reportDomain === "myskoolprofectus"
                      ? data.item.grNo
                      : data.item.id
                  }}
                </b-badge>
              </b-link>
              <b-link
                v-if="
                  ['left', 'alumni'].includes(data.item.status.toLowerCase()) &&
                  data.item.date_of_leaving
                "
                class="font-weight-bold d-block text-nowrap"
                style="margin-top: 4px"
              >
                <b-badge variant="light-primary">
                  {{
                    new Date(data.item.date_of_leaving).toLocaleDateString(
                      "en-UK",
                      {
                        year: "numeric",
                        day: "numeric",
                        month: "short",
                      }
                    )
                  }}
                </b-badge>
              </b-link>
              <b-link
                v-else-if="
                  ['registered'].includes(data.item.status) &&
                  data.item.date_of_registraion
                "
                class="font-weight-bold d-block text-nowrap"
                style="margin-top: 4px"
              >
                <b-badge variant="light-primary">
                  {{
                    new Date(data.item.date_of_registraion).toLocaleDateString(
                      "en-UK",
                      {
                        year: "numeric",
                        day: "numeric",
                        month: "short",
                      }
                    )
                  }}
                </b-badge>
              </b-link>
              <b-link
                v-else-if="
                  ['present'].includes(data.item.status) &&
                  data.item.date_of_admission
                "
                class="font-weight-bold d-block text-nowrap"
                style="margin-top: 4px"
              >
                <b-badge variant="light-primary">
                  {{
                    new Date(data.item.date_of_admission).toLocaleDateString(
                      "en-UK",
                      {
                        year: "numeric",
                        day: "numeric",
                        month: "short",
                      }
                    )
                  }}
                </b-badge>
              </b-link>
              <b-link
                v-if="
                  slrObj && slrObj.valueBool && reqStdIDs.includes(data.item.id)
                "
                class="font-weight-bold d-block text-nowrap mt-25"
              >
                <b-badge variant="light-success">
                  {{ $t("Request") }}: {{ getReqCount(data.item.id) }}
                </b-badge>
              </b-link>
              <b-link
                v-if="
                  admFeeObj &&
                  admFeeObj.valueBool &&
                  admStdIDs.includes(data.item.id)
                "
                class="font-weight-bold d-block text-nowrap mt-25"
              >
                <b-badge variant="light-warning">
                  {{ getAdmFee(data.item.id) }}
                </b-badge>
              </b-link>
            </b-media>
          </template>
          <template #cell(campus)="data">
            <b-badge variant="light-primary">
              {{ getCampus(data.item.campusID) }}
            </b-badge>
          </template>
          <template #cell(admitted_campus)="data">
            <b-badge variant="light-primary">
              {{ getCampus(data.item.campus_Admitted) }}
            </b-badge>
          </template>
          <template #cell(father_name)="data">
            <b-badge variant="light-primary">
              {{ data.item.father_name }}
            </b-badge>
          </template>
          <template #cell(surname)="data">
            <b-badge variant="light-primary">
              {{ data.item.surname }}
            </b-badge>
          </template>
          <template #cell(contact_father)="data">
            <b-badge variant="light-primary">
              {{ data.item.contact_father }}
            </b-badge>
            <div v-if="data.item.contact_mother" class="mt-25">
              <b-badge variant="light-primary">
                {{ data.item.contact_mother }}
              </b-badge>
            </div>
          </template>
          <template #cell(class_current)="data">
            <b-badge variant="light-primary">
              {{ data.item.meta_class }}
            </b-badge>
            <br />
            <b-badge
              v-if="reportDomain == 'myskoolksa' && data.item.house"
              variant="light-primary"
              class="mt-50"
            >
              {{ data.item.house }}
            </b-badge>
          </template>
          <template #cell(monthly_fee)="data">
            <b-badge variant="light-primary">
              {{ data.item.monthly_fee }}
            </b-badge>
          </template>
          <template #cell(status)="data">
            <b-badge
              :variant="
                data.item.status.toLowerCase() == 'left'
                  ? 'light-danger'
                  : data.item.status.toLowerCase() == 'suspend'
                  ? 'light-warning'
                  : 'light-primary'
              "
            >
              {{ data.item.status }}
            </b-badge>
          </template>

          <template #head(actions)="data">
            <div class="text-center">
              <span>{{ $t(data.label) }}</span>
            </div>
          </template>

          <template #cell(actions)="data">
            <div class="d-flex">
              <b-button
                v-if="data.item.id > 0 && !isHappiness"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                :variant="
                  data.item.synced ? 'outline-success' : 'outline-danger'
                "
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="
                  data.item.synced
                    ? $t('Synced Account Details')
                    : $t('Not Synced')
                "
                :disabled="syncLoading && selectedSyncedStaffID == data.item.id"
                @click="
                  showSyncedDetails(data.item.syncedDetails, data.item.id)
                "
              >
                <b-spinner
                  v-if="syncLoading && selectedSyncedStaffID == data.item.id"
                  small
                />
                <feather-icon v-else icon="SmartphoneIcon" />
              </b-button>

              <b-button
                v-if="rights.view"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('View Student\'s Profile')"
                :to="
                  ['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)
                    ? {
                        name: 'student-details',
                        params: {
                          id: data.item.id,
                        },
                      }
                    : {
                        name: 'apps-users-view',
                        params: {
                          id: data.item.id,
                          item: { ...data.item },
                        },
                      }
                "
              >
                <!-- @click="View(data.item)" -->
                <feather-icon icon="EyeIcon" />
              </b-button>
              <b-button
                v-if="
                  rights.edit &&
                  (['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)
                    ? isHeadOffice
                    : true)
                "
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('Edit')"
                :to="{
                  name: 'manage-student',
                  params: {
                    id: data.item.id,
                    readmit: false,
                  },
                  query: {
                    status: data.item.status.toLowerCase(),
                  },
                }"
              >
                <!-- @click="Edit(data.item.id, false)" -->
                <feather-icon icon="EditIcon" class="" />
              </b-button>

              <b-button
                v-if="
                  slrObj &&
                  slrObj.valueBool &&
                  ['present', 'registered', 'left'].includes(
                    data.item.status.toLowerCase()
                  )
                "
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-success"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('Request')"
                @click="openLeaveReq(data.item)"
              >
                <feather-icon icon="LogOutIcon" />
              </b-button>

              <b-button
                v-if="
                  rights.editCampus &&
                  !['left', 'enrolled', 'alumni'].includes(
                    data.item.status.toLowerCase()
                  ) &&
                  (['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)
                    ? isHeadOffice
                    : true)
                "
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('Transfer Student')"
                @click="openCh(data.item)"
              >
                <feather-icon icon="RepeatIcon" />
              </b-button>

              <b-button
                v-if="
                  rights.edit &&
                  ['left'].includes(data.item.status.toLowerCase()) &&
                  (reportDomain == 'myskoolhpgs'
                    ? $store.state.loggedUser.campusID == 1
                    : ['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)
                    ? isHeadOffice
                    : true)
                "
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('Readmit')"
                @click="handleReadmit(data.item)"
              >
                <feather-icon icon="CheckIcon" />
              </b-button>
              <b-button
                v-if="
                  rights.edit &&
                  ['registered', 'enrolled'].includes(
                    data.item.status.toLowerCase()
                  ) &&
                  (reportDomain == 'myskoolhpgs'
                    ? $store.state.loggedUser.campusID == 1
                    : ['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)
                    ? !getDetails(data.item.id, 'acceptedBy')
                    : true)
                "
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                :variant="isHappiness ? 'warning' : 'success'"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t(isHappiness ? 'Enroll Now' : 'Confirm Admission')"
                @click="confirmAdmission(data.item)"
              >
                <feather-icon icon="CheckCircleIcon" />
              </b-button>

              <b-button
                v-if="isHappiness"
                variant="outline-primary"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('Download QR Code')"
                @click="downloadQR(data.item)"
              >
                <feather-icon icon="DownloadIcon" />
              </b-button>

              <b-button
                v-if="
                  rights.edit &&
                  ['registered', 'enrolled'].includes(
                    data.item.status.toLowerCase()
                  ) &&
                  ['myskooltcfdemo', 'myskooltcf'].includes(reportDomain) &&
                  isAccepted(data.item.id)
                "
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t(isHeadOffice ? 'Conditionally Verify' : 'Verify')"
                @click="openVerify(data.item)"
              >
                <feather-icon icon="CheckIcon" />
              </b-button>

              <b-button
                v-if="
                  !['left', 'alumni'].includes(data.item.status.toLowerCase())
                "
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('Print')"
                @click="printAdm(data.item)"
              >
                <feather-icon icon="PrinterIcon" />
              </b-button>

              <b-button
                v-if="
                  reportDomain === 'myskoolcrestviewacademy' &&
                  data.item.status.toLowerCase() === 'registered'
                "
                variant="outline-secondary"
                class="btn-icon mr-1 p-0"
                v-b-tooltip.hover.top
                :title="$t('Registration QR Code')"
                @click="openStudentRegistrationQr(data.item)"
              >
                <img src="@/assets/images/icons/qr-code.png" width="34" />
              </b-button>

              <b-button
                v-if="
                  !isHappiness &&
                  rights.edit &&
                  ['present'].includes(data.item.status.toLowerCase()) &&
                  (reportDomain == 'myskoolhpgs'
                    ? $store.state.loggedUser.campusID == 1
                    : ['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)
                    ? isHeadOffice
                    : true)
                "
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-danger"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('Suspend')"
                @click="openSus(data.item)"
              >
                <feather-icon icon="XIcon" />
              </b-button>

              <b-button
                v-if="
                  rights.edit &&
                  !['left', 'alumni', 'enrolled'].includes(
                    data.item.status.toLowerCase()
                  ) &&
                  (reportDomain == 'myskoolhpgs'
                    ? $store.state.loggedUser.campusID == 1
                    : ['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)
                    ? isHeadOffice
                    : true)
                "
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-danger"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('Left')"
                @click="Leave(data.item)"
              >
                <feather-icon icon="InfoIcon" />
              </b-button>

              <b-button
                v-if="
                  rights.delete &&
                  (['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)
                    ? isHeadOffice
                    : true)
                "
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-danger"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('Delete')"
                @click="Delete(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>

              <b-dropdown
                v-if="
                  reportDomain == 'myskoolhpgs' &&
                  rights.editAllows &&
                  rights.editAllows.length > 0
                "
                variant="outline-secondary"
                no-caret
                :right="$store.state.appConfig.isRTL"
                toggle-class="btn-icon"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    class="align-middle text-body"
                  />
                </template>

                <b-dropdown-item
                  v-for="(dd, ind) in rights.editAllows"
                  :key="ind"
                  @click="openEdit(dd, data.item)"
                >
                  <span class="align-middle text-capitalize">
                    {{ dd.name }}
                  </span>
                </b-dropdown-item>
              </b-dropdown>

              <b-button
                v-if="showFaceId"
                variant="primary"
                class="btn-icon mr-1 ml-1"
                v-b-tooltip.hover.top
                title="Register Face ID"
                :disabled="faceIdLoading"
                @click="registerFaceId(data.item)"
              >
                <b-spinner v-if="faceIdLoading" small />
                <feather-icon v-else icon="UserIcon" />
              </b-button>
            </div>
          </template>
        </b-table>

        <div class="cropper" v-if="image">
          <cropper
            :src="image"
            :stencil-props="{
              aspectRatio: 1,
              width: 200,
              height: 200,
            }"
            @change="onChange"
          ></cropper>
          <div class="d-flex justify-content-center">
            <b-button
              :disabled="logoLoading"
              v-if="image"
              class="mt-2 mr-2"
              variant="primary"
              @click="uploadCroppedImage"
            >
              {{ $t("Upload Image") }}
            </b-button>
            <b-button
              :disabled="logoLoading"
              v-if="image"
              class="mt-2 ml-2"
              variant="danger"
              @click="CloseCropper"
            >
              {{ $t("Cancel") }}
            </b-button>
          </div>
        </div>
        <b-row>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >{{ $t("Showing") }} {{ items.length }} {{ $t("of") }}
              {{ total == 0 ? items.length : total }} {{ $t("entries") }}</span
            >
          </b-col>
          <b-col cols="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="total"
              :per-page="perPage"
              first-number
              last-number
              limit="10"
              class="mb-0 mt-50 justify-content-center"
              prev-class="prev-item"
              next-class="next-item"
              @input="move()"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <b-modal
      v-model="showFaceIdModal"
      :title="$t('Register Face ID')"
      size="lg"
      centered
      hide-footer
    >
      <iframe
        :src="enrollmentLink"
        style="width: 100%; height: 70vh; border: none"
        allow="camera;microphone"
        referrerpolicy="no-referrer"
      ></iframe>

      <b-row class="mt-2 bg-white p-2">
        <b-col class="d-flex justify-content-center">
          <b-button variant="success" @click="shareWhatsApp">
            <feather-icon icon="MessageSquareIcon" class="mr-50" />
            <span>{{ $t("WhatsApp Link") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="modal-select-template"
      v-model="showTemplateModal"
      :title="$t('Select Template')"
      centered
      size="lg"
      hide-footer
    >
      <div class="p-1">
        <b-row class="mb-2">
          <b-col md="12">
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                v-model="templateSearch"
                placeholder="Search templates..."
                @input="fetchTemplates()"
              />
            </b-input-group>
          </b-col>
        </b-row>

        <b-table
          :items="templates"
          :fields="templateFields"
          :busy="templateLoading"
          hover
          show-empty
          responsive
          selectable
          select-mode="single"
          @row-selected="(row) => (selectedTemplate = row[0])"
          class="mb-2"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-1">{{ $t("Loading templates") }}...</strong>
            </div>
          </template>

          <template #head()="scope">
            <div>
              <span>{{ $t(scope.label) }}</span>
            </div>
          </template>

          <template #cell(title)="data">
            <span class="font-weight-bold">{{ data.value }}</span>
          </template>

          <template #cell(templateFor)="data">
            <b-badge variant="light-primary">{{ data.value }}</b-badge>
          </template>
        </b-table>

        <b-pagination
          v-if="templateTotal > templatePerPage"
          v-model="templatePage"
          :total-rows="templateTotal"
          :per-page="templatePerPage"
          align="center"
          size="sm"
          @input="fetchTemplates()"
        />

        <div class="d-flex justify-content-end mt-2">
          <b-button
            variant="outline-secondary"
            @click="showTemplateModal = false"
            class="mr-1"
          >
            {{ $t("Cancel") }}
          </b-button>
          <b-button
            variant="success"
            :disabled="!selectedTemplate || stdIDs.length === 0"
            @click="printWithTemplate()"
          >
            <b-spinner v-if="printingTemplate" small class="mr-50" />
            <feather-icon v-else icon="PrinterIcon" class="mr-50" />
            <span>{{ $t("Print") }}</span>
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Synced Details Modal -->
    <b-modal
      id="modal-synced-details"
      v-model="showSyncedModal"
      :title="$t('App Account Details')"
      centered
      hide-footer
      body-class="p-0"
    >
      <template #modal-header>
        <h5 class="modal-title">App Account Details</h5>
        <b-button
          variant="primary"
          class="btn-icon ml-50"
          size="sm"
          :disabled="stdSyncing"
          @click="syncSingle()"
        >
          <b-spinner v-if="stdSyncing" small />
          <feather-icon v-else icon="RefreshCwIcon" class="" />
          <span class="line-height-1 ml-50">Sync</span>
        </b-button>
      </template>

      <div v-if="selectedSyncedDetails">
        <div
          v-for="(val, key) in selectedSyncedDetails"
          :key="key"
          class="p-2 border-bottom d-flex align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              size="40"
              :variant="val.synced ? 'light-success' : 'light-danger'"
              class="mr-1"
            >
              <feather-icon
                :icon="key === 'student' ? 'UserIcon' : 'UsersIcon'"
              />
            </b-avatar>
            <div>
              <h5
                v-if="['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)"
                class="text-capitalize font-weight-bolder mb-0"
              >
                {{
                  $t(
                    key == "father"
                      ? "WhatsApp No"
                      : key == "mother"
                      ? "Parent's Contact"
                      : key == "student"
                      ? "Student's Contact"
                      : key
                  )
                }}
              </h5>
              <h5 v-else class="text-capitalize font-weight-bolder mb-0">
                {{ $t(key) }}
              </h5>
              <small class="text-muted d-block">
                {{ val.number || $t("No number provided") }}
              </small>
            </div>
          </div>
          <b-badge
            pill
            :variant="val.synced ? 'light-success' : 'light-danger'"
            class="text-uppercase"
            style="padding: 0.5rem 1rem"
          >
            {{ val.synced ? $t("Active") : $t("Inactive") }}
          </b-badge>
        </div>
      </div>
      <div v-else class="p-3 text-center">
        <h5 class="text-muted">
          {{ $t("No synchronization details found.") }}
        </h5>
      </div>
    </b-modal>

    <!-- Scholarship Confirmation Modal -->
    <b-modal
      id="modal-scholarship-confirm"
      v-model="scholarshipModalVisible"
      :title="$t('Confirm Scholarship')"
      centered
      no-close-on-backdrop
      :ok-title="$t('Confirm')"
      :cancel-title="$t('Cancel')"
      ok-variant="success"
      cancel-variant="outline-secondary"
      :ok-disabled="scholarshipConfirming || secLoading"
      @ok.prevent="acceptScholarship"
    >
      <div v-if="scholarshipStudent" class="py-50">
        <p class="mb-1">
          {{ $t("Are you sure you want to confirm the scholarship for:") }}
        </p>
        <div class="d-flex flex-column" style="gap: 0.4rem">
          <div>
            <span class="font-weight-bolder">{{ $t("Student") }}: </span>
            <span>{{ scholarshipStudent.name }}</span>
          </div>
          <div>
            <span class="font-weight-bolder">{{ $t("Father") }}: </span>
            <span>{{ scholarshipStudent.father_name }}</span>
          </div>
          <div>
            <span class="font-weight-bolder">{{ $t("Class") }}: </span>
            <span>{{ scholarshipStudent.meta_class }}</span>
          </div>
        </div>
        <div class="mt-50" v-if="sectionList.length > 0">
          <b-form-group
            :label="$t('Inter Faculty')"
            label-class="font-weight-bolder"
            :invalid-feedback="$t('Inter Faculty is required')"
          >
            <v-select
              v-model="scholarshipSectionID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sectionList"
              :reduce="(val) => val.id"
              label="section"
              :clearable="false"
              :placeholder="$t('Select faculty')"
            />
          </b-form-group>
        </div>
      </div>
      <template #modal-ok>
        <b-spinner
          v-if="scholarshipConfirming"
          small
          type="grow"
          class="mr-50"
        />
        <span>{{ $t("Confirm") }}</span>
      </template>
    </b-modal>

    <!-- Readmit Modal -->
    <b-modal
      id="modal-readmit"
      v-model="readmitModalVisible"
      :title="$t('Readmit Student')"
      centered
      no-close-on-backdrop
      :ok-title="$t('Confirm')"
      :cancel-title="$t('Cancel')"
      ok-variant="success"
      cancel-variant="outline-secondary"
      :ok-disabled="readmitting"
      @ok.prevent="confirmReadmit"
    >
      <div v-if="readmitStudent" class="py-50">
        <p class="mb-1">
          {{ $t("Are you sure you want to readmit this student?") }}
        </p>
        <div class="d-flex flex-column" style="gap: 0.4rem">
          <div>
            <span class="font-weight-bolder">{{ $t("Student") }}: </span>
            <span>{{ readmitStudent.name }}</span>
          </div>
          <div>
            <span class="font-weight-bolder">{{ $t("Father") }}: </span>
            <span>{{ readmitStudent.father_name }}</span>
          </div>
          <div>
            <span class="font-weight-bolder">{{ $t("Class") }}: </span>
            <span>{{ readmitStudent.meta_class }}</span>
          </div>
        </div>
      </div>
      <template #modal-ok>
        <b-spinner v-if="readmitting" small type="grow" class="mr-50" />
        <span>{{ $t("Confirm") }}</span>
      </template>
    </b-modal>

    <!-- Verification Confirmation Modal -->
    <b-modal
      id="modal-scholarship-confirm"
      v-model="verifyModalVisible"
      :title="$t('Verify Student')"
      centered
      no-close-on-backdrop
      :ok-title="$t('Verify')"
      :cancel-title="$t('Cancel')"
      ok-variant="success"
      cancel-variant="outline-secondary"
      :ok-disabled="verifying"
      @ok.prevent="acceptVerification"
    >
      <div v-if="verifyStd" class="py-50">
        <p class="mb-1">
          {{ $t("Are you sure you want to verify this student:") }}
        </p>
        <div class="d-flex flex-column" style="gap: 0.4rem">
          <div>
            <span class="font-weight-bolder">{{ $t("Student") }}: </span>
            <span>{{ verifyStd.name }}</span>
          </div>
          <div>
            <span class="font-weight-bolder">{{ $t("Father") }}: </span>
            <span>{{ verifyStd.father_name }}</span>
          </div>
          <div>
            <span class="font-weight-bolder">{{ $t("Class") }}: </span>
            <span>{{ verifyStd.meta_class }}</span>
          </div>
        </div>
        <div class="pt-50 mt-50 border-top" v-if="isHeadOffice">
          <b-form-group
            :label="
              $t(
                'You\'re conditionally verifying this student. Please enter the comment below.'
              )
            "
            :invalid-feedback="$t('Comment is required.')"
            label-class="font-weight-bolder"
          >
            <b-form-textarea
              :placeholder="$t('Enter comment')"
              rows="3"
              :disabled="!verifyObj.isConditional"
              v-model.trim="verifyObj.comment"
            />
          </b-form-group>
        </div>
      </div>
      <template #modal-ok>
        <b-spinner v-if="verifying" small type="grow" class="mr-50" />
        <span>{{ $t("Verify") }}</span>
      </template>
    </b-modal>

    <!-- Custom fee import (StudentsCustomFee/Import) -->
    <b-modal
      id="modal-import-custom-fee"
      v-model="showCustomFeeImportModal"
      :title="
        customFeeStep === 'summary'
          ? $t('Import summary')
          : $t('Import Custom Fees')
      "
      centered
      size="lg"
      hide-footer
      scrollable
      no-close-on-backdrop
      @hidden="resetCustomFeeImportModal"
    >
      <div v-if="customFeeStep === 'form'" class="custom-fee-import-form">
        <b-form-group :label="$t('Fee Type') + ' *'">
          <v-select
            v-model="customFeeObj.feeTypeID"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="importFeeTypeOptions"
            :reduce="(opt) => opt.id"
            label="feeType"
            :clearable="false"
            :loading="importFeeTypeLoading"
            :disabled="importFeeTypeLoading || customFeeParsing"
            :placeholder="$t('Select fee type')"
          />
          <small class="text-muted">
            {{ $t("This fee type is applied to every row in the file.") }}
          </small>
        </b-form-group>

        <b-row class="mb-2">
          <b-col md="6" sm="12" class="mb-1">
            <b-button
              variant="outline-primary"
              block
              :disabled="customFeeExporting || !items.length"
              @click="exportCustomFeeTemplate()"
            >
              <b-spinner v-if="customFeeExporting" small class="mr-50" />
              <feather-icon v-else icon="DownloadIcon" class="mr-50" />
              {{ $t("Export student template") }}
            </b-button>
          </b-col>
          <b-col md="6" sm="12" class="mb-1">
            <b-button
              variant="primary"
              block
              :disabled="customFeeParsing || customFeeSubmitting"
              @click="$refs.customFeeImportFile.click()"
            >
              <input
                ref="customFeeImportFile"
                type="file"
                hidden
                accept=".xlsx,.xls,.csv"
                @change="onCustomFeeImportFileSelected"
              />
              <b-spinner v-if="customFeeParsing" small class="mr-50" />
              <feather-icon v-else icon="UploadIcon" class="mr-50" />
              {{
                customFeeParsing ? $t("Reading file...") : $t("Import file")
              }}
            </b-button>
          </b-col>
        </b-row>

        <div v-if="customFeeParsing" class="text-center text-muted py-2 mb-2">
          <b-spinner small class="mr-50" />
          {{ $t("Reading file...") }}
        </div>

        <div
          v-if="
            customFeeParseStats.included ||
            customFeeParseStats.excludedNoAmount
          "
          class="import-parse-stats mb-2"
        >
          <div class="import-parse-stat import-parse-stat--ready">
            <span class="import-parse-stat__num">{{
              customFeeParseStats.included
            }}</span>
            <span class="import-parse-stat__lbl">{{
              $t("Ready to import")
            }}</span>
          </div>
          <div
            v-if="customFeeParseStats.excludedNoAmount"
            class="import-parse-stat import-parse-stat--skip"
          >
            <span class="import-parse-stat__num">{{
              customFeeParseStats.excludedNoAmount
            }}</span>
            <span class="import-parse-stat__lbl">{{
              $t("Excluded (no amount)")
            }}</span>
          </div>
        </div>

        <div
          v-if="customFeePreview.length"
          class="summary-table-wrap import-preview-table mb-2"
        >
          <div
            class="import-preview-table__title text-muted small mb-50 d-flex justify-content-between"
          >
            <span>
              {{ $t("Preview") }}
              <span class="font-weight-bold text-body">{{
                customFeeRows.length
              }}</span>
              {{ $t("rows") }}
            </span>
            <b-badge v-if="selectedImportFeeType" variant="light-primary">
              {{ selectedImportFeeType.feeType }}
            </b-badge>
          </div>
          <b-table
            :items="customFeePreview"
            :fields="customFeePreviewFields"
            small
            responsive
            sticky-header="220px"
            show-empty
            class="bulk-inc-summary-table bulk-inc-preview-table mb-0"
          >
            <template #head()="scope">
              <span>{{ $t(scope.label) }}</span>
            </template>
            <template #cell(amount)="data">
              <span class="font-weight-bold text-right d-block">{{
                formatCustomFeeMoney(data.value)
              }}</span>
            </template>
          </b-table>
        </div>

        <div class="d-flex justify-content-end mt-2">
          <b-button
            variant="outline-secondary"
            class="mr-1"
            @click="showCustomFeeImportModal = false"
          >
            {{ $t("Cancel") }}
          </b-button>
          <b-button
            variant="primary"
            :disabled="
              customFeeSubmitting ||
              !customFeeRows.length ||
              !customFeeObj.feeTypeID
            "
            @click="submitImportCustomFee()"
          >
            <b-spinner v-if="customFeeSubmitting" small class="mr-50" />
            {{
              customFeeSubmitting ? $t("Submitting...") : $t("Submit import")
            }}
          </b-button>
        </div>
      </div>

      <div v-else class="custom-fee-summary">
        <div class="custom-fee-summary__hero">
          <div class="custom-fee-summary__icon">
            <feather-icon icon="CheckCircleIcon" size="22" />
          </div>
          <div class="custom-fee-summary__hero-text">
            <h5 class="mb-0">{{ $t("Import complete") }}</h5>
            <small class="text-muted">
              {{ customFeeResult.savedCount || 0 }}
              {{ $t("of") }}
              {{ customFeeResult.totalRows || customFeeResult.savedCount || 0 }}
              {{ $t("rows imported") }}
            </small>
          </div>
        </div>

        <div class="custom-fee-stats">
          <div class="custom-fee-stat custom-fee-stat--saved">
            <span class="custom-fee-stat__num">{{
              customFeeResult.savedCount || 0
            }}</span>
            <span class="custom-fee-stat__lbl">{{ $t("Saved") }}</span>
          </div>
          <div
            v-if="customFeeResult.updatedCount"
            class="custom-fee-stat custom-fee-stat--updated"
          >
            <span class="custom-fee-stat__num">{{
              customFeeResult.updatedCount
            }}</span>
            <span class="custom-fee-stat__lbl">{{ $t("Updated") }}</span>
          </div>
          <div
            v-if="customFeeResult.skippedCount"
            class="custom-fee-stat custom-fee-stat--skipped"
          >
            <span class="custom-fee-stat__num">{{
              customFeeResult.skippedCount
            }}</span>
            <span class="custom-fee-stat__lbl">{{ $t("Skipped") }}</span>
          </div>
        </div>

        <div
          v-if="customFeeResult.saved && customFeeResult.saved.length"
          class="summary-table-wrap import-preview-table mb-2"
        >
          <div
            class="import-preview-table__title d-flex justify-content-between align-items-center mb-50"
          >
            <span class="font-weight-bold text-body">
              {{ $t("Imported rows") }}
            </span>
            <b-badge variant="light-primary" pill>
              {{ customFeeResult.savedCount }}
            </b-badge>
          </div>
          <b-table
            :items="customFeeResult.saved"
            :fields="customFeeSavedFields"
            small
            responsive
            sticky-header="240px"
            class="bulk-inc-summary-table bulk-inc-preview-table mb-0"
          >
            <template #head()="scope">
              <span>{{ $t(scope.label) }}</span>
            </template>
            <template #cell(amount)="data">
              <div class="text-right">
                <span class="font-weight-bold d-block">{{
                  formatCustomFeeMoney(data.value)
                }}</span>
                <small
                  v-if="
                    data.item.previousAmount != null &&
                    Number(data.item.previousAmount) !== Number(data.value)
                  "
                  class="text-muted d-block"
                >
                  {{ $t("was") }}
                  {{ formatCustomFeeMoney(data.item.previousAmount) }}
                </small>
              </div>
            </template>
            <template #cell(action)="data">
              <b-badge
                :variant="
                  data.value === 'created' ? 'light-success' : 'light-primary'
                "
                class="text-capitalize"
              >
                {{ data.value }}
              </b-badge>
            </template>
          </b-table>
        </div>

        <div
          v-if="customFeeResult.skipped && customFeeResult.skipped.length"
          class="summary-table-wrap mb-2"
        >
          <div
            class="import-preview-table__title d-flex justify-content-between align-items-center mb-50"
          >
            <span class="font-weight-bold text-body">
              {{ $t("Skipped rows") }}
            </span>
            <b-badge variant="light-warning" pill>
              {{ customFeeResult.skippedCount }}
            </b-badge>
          </div>
          <b-table
            :items="customFeeResult.skipped"
            :fields="customFeeSkippedFields"
            small
            responsive
            sticky-header="180px"
            class="bulk-inc-summary-table mb-0"
          >
            <template #head()="scope">
              <span>{{ $t(scope.label) }}</span>
            </template>
          </b-table>
        </div>

        <div class="d-flex justify-content-end mt-2">
          <b-button
            size="sm"
            variant="primary"
            class="px-3"
            @click="showCustomFeeImportModal = false"
          >
            {{ $t("Close") }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Bulk driver link import (StudentDriver/Import) -->
    <b-modal
      id="modal-import-driver-link"
      v-model="showBulkDriverLinkModal"
      :title="
        driverLinkStep === 'summary'
          ? $t('Import summary')
          : $t('Bulk Driver Link')
      "
      centered
      size="lg"
      hide-footer
      scrollable
      no-close-on-backdrop
      @hidden="resetBulkDriverLinkModal"
    >
      <div v-if="driverLinkStep === 'form'" class="custom-fee-import-form">
        <b-form-group :label="$t('Driver') + ' *'">
          <v-select
            v-model="driverLinkObj.driverID"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="driverLinkOptions"
            :reduce="(opt) => opt.id"
            label="name"
            :clearable="false"
            :loading="driverLinkOptionsLoading"
            :disabled="driverLinkOptionsLoading || driverLinkParsing"
            :placeholder="$t('Select driver')"
            @input="onDriverLinkDriverChange"
          />
          <small class="text-muted">
            {{ $t("This driver is linked to every student row in the file.") }}
          </small>
        </b-form-group>

        <b-form-group :label="$t('Vehicle')">
          <v-select
            v-model="driverLinkObj.vehicleID"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="driverLinkVehicleOptions"
            :reduce="(opt) => opt.id"
            label="name"
            :clearable="true"
            :disabled="
              !driverLinkObj.driverID || !driverLinkVehicleOptions.length
            "
            :placeholder="
              driverLinkVehicleOptions.length
                ? $t('Select vehicle')
                : $t('No vehicles for this driver')
            "
          />
          <small class="text-muted">
            {{
              $t(
                "Optional — the vehicle must belong to the selected driver."
              )
            }}
          </small>
        </b-form-group>

        <b-row class="mb-2">
          <b-col md="6" sm="12" class="mb-1">
            <b-button
              variant="outline-primary"
              block
              :disabled="driverLinkExporting || !items.length"
              @click="exportBulkDriverLinkTemplate()"
            >
              <b-spinner v-if="driverLinkExporting" small class="mr-50" />
              <feather-icon v-else icon="DownloadIcon" class="mr-50" />
              {{ $t("Export student template") }}
            </b-button>
          </b-col>
          <b-col md="6" sm="12" class="mb-1">
            <b-button
              variant="primary"
              block
              :disabled="driverLinkParsing || driverLinkSubmitting"
              @click="$refs.driverLinkImportFile.click()"
            >
              <input
                ref="driverLinkImportFile"
                type="file"
                hidden
                accept=".xlsx,.xls,.csv"
                @change="onBulkDriverLinkFileSelected"
              />
              <b-spinner v-if="driverLinkParsing" small class="mr-50" />
              <feather-icon v-else icon="UploadIcon" class="mr-50" />
              {{
                driverLinkParsing ? $t("Reading file...") : $t("Import file")
              }}
            </b-button>
          </b-col>
        </b-row>

        <div v-if="driverLinkParsing" class="text-center text-muted py-2 mb-2">
          <b-spinner small class="mr-50" />
          {{ $t("Reading file...") }}
        </div>

        <div
          v-if="driverLinkParseStats.included || driverLinkParseStats.skipped"
          class="import-parse-stats mb-2"
        >
          <div class="import-parse-stat import-parse-stat--ready">
            <span class="import-parse-stat__num">{{
              driverLinkParseStats.included
            }}</span>
            <span class="import-parse-stat__lbl">{{
              $t("Ready to import")
            }}</span>
          </div>
          <div
            v-if="driverLinkParseStats.skipped"
            class="import-parse-stat import-parse-stat--skip"
          >
            <span class="import-parse-stat__num">{{
              driverLinkParseStats.skipped
            }}</span>
            <span class="import-parse-stat__lbl">{{
              $t("Skipped (no student ID)")
            }}</span>
          </div>
        </div>

        <div
          v-if="driverLinkPreview.length"
          class="summary-table-wrap import-preview-table mb-2"
        >
          <div
            class="import-preview-table__title text-muted small mb-50 d-flex justify-content-between"
          >
            <span>
              {{ $t("Preview") }}
              <span class="font-weight-bold text-body">{{
                driverLinkRows.length
              }}</span>
              {{ $t("rows") }}
            </span>
            <span class="d-flex align-items-center">
              <b-badge v-if="selectedBulkDriver" variant="light-primary">
                {{ selectedBulkDriver.name }}
              </b-badge>
              <b-badge
                v-if="driverLinkObj.vehicleID"
                variant="light-secondary"
                class="ml-50"
              >
                {{ driverLinkVehicleLabel(driverLinkObj.vehicleID) }}
              </b-badge>
            </span>
          </div>
          <b-table
            :items="driverLinkPreview"
            :fields="driverLinkPreviewFields"
            small
            responsive
            sticky-header="220px"
            show-empty
            class="bulk-inc-summary-table bulk-inc-preview-table mb-0"
          >
            <template #head()="scope">
              <span>{{ $t(scope.label) }}</span>
            </template>
          </b-table>
        </div>

        <div class="d-flex justify-content-end mt-2">
          <b-button
            variant="outline-secondary"
            class="mr-1"
            @click="showBulkDriverLinkModal = false"
          >
            {{ $t("Cancel") }}
          </b-button>
          <b-button
            variant="primary"
            :disabled="
              driverLinkSubmitting ||
              !driverLinkRows.length ||
              !driverLinkObj.driverID
            "
            @click="submitBulkDriverLink()"
          >
            <b-spinner v-if="driverLinkSubmitting" small class="mr-50" />
            {{
              driverLinkSubmitting ? $t("Submitting...") : $t("Submit import")
            }}
          </b-button>
        </div>
      </div>

      <div v-else class="custom-fee-summary">
        <div class="custom-fee-summary__hero">
          <div class="custom-fee-summary__icon">
            <feather-icon icon="CheckCircleIcon" size="22" />
          </div>
          <div class="custom-fee-summary__hero-text">
            <h5 class="mb-0">{{ $t("Import complete") }}</h5>
            <small class="text-muted">
              {{ driverLinkResult.savedCount || 0 }}
              {{ $t("of") }}
              {{
                driverLinkResult.totalRows || driverLinkResult.savedCount || 0
              }}
              {{ $t("rows imported") }}
            </small>
          </div>
        </div>

        <div class="custom-fee-stats">
          <div class="custom-fee-stat custom-fee-stat--saved">
            <span class="custom-fee-stat__num">{{
              driverLinkResult.savedCount || 0
            }}</span>
            <span class="custom-fee-stat__lbl">{{ $t("Saved") }}</span>
          </div>
          <div
            v-if="driverLinkResult.createdCount"
            class="custom-fee-stat custom-fee-stat--updated"
          >
            <span class="custom-fee-stat__num">{{
              driverLinkResult.createdCount
            }}</span>
            <span class="custom-fee-stat__lbl">{{ $t("Created") }}</span>
          </div>
          <div
            v-if="driverLinkResult.updatedCount"
            class="custom-fee-stat custom-fee-stat--updated"
          >
            <span class="custom-fee-stat__num">{{
              driverLinkResult.updatedCount
            }}</span>
            <span class="custom-fee-stat__lbl">{{ $t("Updated") }}</span>
          </div>
          <div
            v-if="driverLinkResult.skippedCount"
            class="custom-fee-stat custom-fee-stat--skipped"
          >
            <span class="custom-fee-stat__num">{{
              driverLinkResult.skippedCount
            }}</span>
            <span class="custom-fee-stat__lbl">{{ $t("Skipped") }}</span>
          </div>
        </div>

        <div
          v-if="driverLinkResult.saved && driverLinkResult.saved.length"
          class="summary-table-wrap import-preview-table mb-2"
        >
          <div
            class="import-preview-table__title d-flex justify-content-between align-items-center mb-50"
          >
            <span class="font-weight-bold text-body">
              {{ $t("Imported rows") }}
            </span>
            <b-badge variant="light-primary" pill>
              {{ driverLinkResult.savedCount }}
            </b-badge>
          </div>
          <b-table
            :items="driverLinkResult.saved"
            :fields="driverLinkSavedFields"
            small
            responsive
            sticky-header="240px"
            class="bulk-inc-summary-table bulk-inc-preview-table mb-0"
          >
            <template #head()="scope">
              <span>{{ $t(scope.label) }}</span>
            </template>
            <template #cell(vehicle)="data">
              {{ driverLinkVehicleLabel(data.item.vehicleID) }}
            </template>
            <template #cell(action)="data">
              <b-badge
                :variant="
                  data.value === 'created' ? 'light-success' : 'light-primary'
                "
                class="text-capitalize"
              >
                {{ data.value }}
              </b-badge>
            </template>
          </b-table>
        </div>

        <div
          v-if="driverLinkResult.skipped && driverLinkResult.skipped.length"
          class="summary-table-wrap mb-2"
        >
          <div
            class="import-preview-table__title d-flex justify-content-between align-items-center mb-50"
          >
            <span class="font-weight-bold text-body">
              {{ $t("Skipped rows") }}
            </span>
            <b-badge variant="light-warning" pill>
              {{ driverLinkResult.skippedCount }}
            </b-badge>
          </div>
          <b-table
            :items="driverLinkResult.skipped"
            :fields="driverLinkSkippedFields"
            small
            responsive
            sticky-header="180px"
            class="bulk-inc-summary-table mb-0"
          >
            <template #head()="scope">
              <span>{{ $t(scope.label) }}</span>
            </template>
          </b-table>
        </div>

        <div class="d-flex justify-content-end mt-2">
          <b-button
            size="sm"
            variant="primary"
            class="px-3"
            @click="showBulkDriverLinkModal = false"
          >
            {{ $t("Close") }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  // BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BContainer,
  BMediaAside,
  BAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
  BFormTextarea,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import readXlsxFile from "read-excel-file";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import { TheMask } from "vue-the-mask";
import { mapActions, mapGetters } from "vuex";
import {
  getUploadPath,
  getUploadedPaths,
  uploadToMySkool,
  getMediaPreviewUrl,
  handleDrivePreviewError,
  isImageUrl,
} from "@/utils/gdriveUpload";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

import * as XLSX from "xlsx";
import {
  buildFormattedWorksheet,
  buildTcfBulkExportColumnDefinitions,
  writeWorkbookToFile,
  STUDENT_EXPORT_HEADER_LABELS,
  STUDENT_QUICK_EXPORT_COLUMNS,
} from "@/utils/excelExport";

import QrcodeVue from "qrcode.vue";
import { useClipboard } from "@vueuse/core";
const { copy } = useClipboard();

import RequestDetails from "./RequestDetails.vue";
import StudentImport from "./StudentImport.vue";

/** Column order must match public/student-sample.xlsx (Bulk Upload sample). */
const TCF_BULK_SAMPLE_HEADERS = [
  "id",
  "Region",
  "Area",
  "Class",
  "Section",
  "Federal Board Registration No",
  "Matric Roll No.",
  "Student Name",
  "Father Name",
  "Gender",
  "School",
  "9th %",
  "HSST %",
  "Overall Score (HSST + Matric)",
  "HSST Status",
  "Matric %",
  "Matric Grade",
  "Student Contact No",
  "WhatsApp No",
  "Parent's Contact",
  "Student's CNIC No.",
  "Scholarship Category",
  "Branch Code",
  "Institute Name",
  "Comment",
  "Scholarship Status",
  "Avg Attendance",
  "Student Status",
  "Inter Faculty",
  "1st Year Roll Number",
  "Intermediate Board",
  "1st Year % ",
  "1st Year Paper Passed",
  "Current Campus",
];

/** Template columns for StudentsCustomFee/Import (sID + amount are required). */
const CUSTOM_FEE_IMPORT_COLUMNS = [
  { key: "sID", label: "Student ID" },
  { key: "name", label: "Student Name" },
  { key: "amount", label: "Amount" },
];

let prevRoute = null;

export default {
  components: {
    RequestDetails,
    StudentImport,
    Cropper,
    TheMask,
    BInputGroup,
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    vSelect,
    BAvatar,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BSpinner,
    BFormCheckbox,
    BForm,
    BContainer,
    //BCardTitle,
    //BCardText,
    BMediaAside,
    BImg,
    BMedia,
    //BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormTextarea,
    flatPickr,
    QrcodeVue,
  },
  props: {},
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  beforeRouteEnter(to, from, next) {
    prevRoute = from ? from.name : null;
    next((vm) => {
      vm.prevRoute = from ? from.name : null;
    });
  },
  async created() {
    // console.log(prevRoute,this.$store.state.isBack);
    let right = {};
    this.$store.state.menu.forEach((el) => {
      el.children.forEach((ch) => {
        right[ch.route] = {
          view: ch.view,
          add: ch.add,
          edit: ch.edit,
          delete: ch.delete,
          hideFee: ch.hideFee,
          editCampus: ch.editCampus,
          editAllows: ch.editAllows,
          disableImport: ch.disableImport,
          disableExport: ch.disableExport,
        };
      });
    });
    // console.log(right);
    this.$store.commit("setRights", right);

    if (!this.$store.state.rights[this.$route.name]) {
      // console.log(this.$store.state.rights[this.$route.name]);
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      this.currentSections = [
        { section: "All " + this.allSectionLabel, id: 0 },
      ];
      // console.log(this.rights);
      let obj = this.filterData.find(
        (el) =>
          el.db == this.$store.state.userData.db &&
          el.cID == this.$store.state.userData.cId
      );
      // console.log(obj);
      if (obj) {
        this.filter.campusID = obj.campusID || this.$store.state.userData.cId;
        this.filter.cls = obj.cls;
        this.filter.sec = obj.sec;
        this.filter.status = obj.status;
        this.regFilter.dateType = obj.dateType;
        this.filterDate = obj.filterDate;
        this.byFilter = obj.byFilter;
        this.total = obj.total;
        this.currentPage = obj.page;
        this.currentStatus = obj.currentStatus;
        this.acceptedBy = obj.acceptedBy || "";
        this.bySearch = obj.bySearch || false;
        if (
          this.bySearch &&
          this.$store.state.isBack &&
          (prevRoute == "apps-users-view" || prevRoute == "manage-student")
        ) {
          this.searchQuery = obj.searchQuery || "";
          this.searchType = obj.searchType || "";
          this.loadSearch("page-enter");
        } else this.move();
      } else this.LoadData();

      this.$store.commit("setIsBack", false);

      // this.LoadData();
      this.LoadFilter();
      this.loadSessions();
      this.LoadLeftCat();
      if (this.reportDomain == "myskoolhpgs") {
        this.fields.splice(
          3,
          0,
          { label: "admitted campus", key: "admitted_campus" },
          { label: "current campus", key: "campus" }
        );
        this.otherFields.splice(
          3,
          0,
          { label: "admitted campus", key: "admitted_campus" },
          { label: "current campus", key: "campus" }
        );

        this.searchOptions.splice(
          2,
          0,
          { name: "GR No", value: "grlocal" },
          { name: "Receipt No", value: "receipt" }
        );
      }
      if (this.reportDomain == "myskoolprofectus") {
        this.searchOptions.splice(2, 0, {
          name: "Consumer No",
          value: "consumerNo",
        });
      }
      if (this.isHappiness) {
        this.fields = this.fields.filter(
          (field) => field.key !== "monthly_fee"
        );
        this.otherFields = this.otherFields.filter(
          (field) => field.key !== "monthly_fee"
        );
      }
      this.LoadCampuses();
      this.LoadSettingsAll();
      this.loadSettings();
      if (this.msgVisible.includes(this.reportDomain)) {
        this.LoadTemplates();
      }
      if (this.moreReports.includes(this.reportDomain)) {
        this.certOptions.push(
          { name: "Fee Card", value: "fee-card" },
          { name: "Acknowledgement Form", value: "acknowledgement-form" }
        );
      }
      if (this.reportDomain === "myskoolqalam") {
        this.certOptions.push({ name: "Admit Card", value: "admit-card" });
        this.loadExamTypes();
      }
    }
  },
  computed: {
    filters: function () {
      return this.items.filter((pro) => {
        return pro.name.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
    isHappiness() {
      return ["myskoolhappinessfoundation"].includes(this.reportDomain);
    },
    allClassLabel: function () {
      return this.isHappiness ? "Groups" : "Classes";
    },
    allSectionLabel: function () {
      return this.isHappiness ? "Levels" : "Sections";
    },
    classLabel: function () {
      return this.isHappiness ? "Group" : "Class";
    },
    sectionLabel: function () {
      return this.isHappiness ? "Level" : "Section";
    },
    selectedImportFeeType() {
      return (
        (this.importFeeTypeOptions || []).find(
          (ft) => Number(ft.id) === Number(this.customFeeObj.feeTypeID)
        ) || null
      );
    },
    // Student driver tab is available for these domains in student.vue
    showBulkDriverLink() {
      const allowed = [
        "myskool",
        "myskoolelixir",
        "myskooliqradq",
        "myskoolkentschool",
      ];
      const candidates = [
        this.reportDomain,
        this.$store.state.report,
        this.$store.state.clientID,
      ]
        .filter((value) => value !== null && value !== undefined && value !== "")
        .map((value) =>
          String(value)
            .toLowerCase()
            .replace(/[^a-z0-9]/g, "")
        );
      return candidates.some((domain) => allowed.includes(domain));
    },
    selectedBulkDriver() {
      return (
        (this.driverLinkOptions || []).find(
          (driver) => Number(driver.id) === Number(this.driverLinkObj.driverID)
        ) || null
      );
    },
    driverLinkVehicleOptions() {
      const driver = this.selectedBulkDriver;
      const vehicles =
        driver && Array.isArray(driver.vehicles) ? driver.vehicles : [];
      return vehicles
        .map((vehicle) => ({
          id: Number(vehicle.id) || 0,
          name: this.formatDriverLinkVehicle(vehicle),
        }))
        .filter((vehicle) => vehicle.id > 0);
    },
  },
  data() {
    return {
      previousRoute: null,
      showSyncedModal: false,
      selectedSyncedDetails: null,
      selectedSyncedStaffID: null,
      stdSyncing: false,
      croppedCanvas: null,
      image: null,
      rights: {},
      filterloading: false,
      filter: {
        campusID: this.$store.state.userData.cId,
        cls: 0,
        sec: 0,
        gender: null,
        status: "present",
      },
      regFilter: {
        dateType: "admission",
        dtFrom: null,
        dtTill: null,
      },
      admDate: null,
      admFilter: {
        dtFrom: null,
        dtTill: null,
      },
      dtOptions: [
        { text: "Admission Test", value: "admission" },
        { text: "Interview", value: "interview" },
      ],
      filterDate: null,
      config2: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
      },
      byFilter: false,
      bySearch: false,
      genders: ["Male", "Female"],
      classes: [],
      contacterror: false,
      docsloading: "Upload",
      request: false,
      visibility2: false,
      secLoading: false,
      sectionList: [],
      scholarshipModalVisible: false,
      scholarshipStudent: null,
      scholarshipSectionID: 0,
      scholarshipConfirming: false,
      readmitStudent: null,
      readmitModalVisible: false,
      readmitting: false,
      visibility3: false,
      sidebarTitle: "Leave Student",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,
      departments: [],
      visibility: false,
      logoloading: false,
      currentID: {},
      searchQuery: "",
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      statusOptions: [
        { text: "Present", value: "present" },
        { text: "Registered", value: "registered" },
        // { text: "Admission", value: "admission" },
        { text: "Left", value: "left" },
        { text: "Suspend", value: "suspend" },
        // { text: "Alumni", value: "alumni" },
      ],
      filterStatusOpt: [
        { text: "Present", value: "present" },
        { text: "Registered", value: "registered" },
        { text: "Left", value: "left" },
        { text: "Suspend", value: "suspend" },
      ],
      regFilterStOpt: [
        { text: "Present", value: "present" },
        { text: "Registered", value: "registered" },
      ],
      missingOptions: [
        { text: "Family code", value: "family_code" },
        { text: "Picture", value: "picture" },
        { text: "Father's Contact", value: "contact_father" },
        { text: "Mother's Contact", value: "contact_mother" },
        { text: "Student's Contact", value: "contact_student" },
      ],
      currentStatus: "present",
      filterData: this.$store.state.stdFilter,
      date: {
        range: "",
      },
      index: null,
      cover: "",
      docs: [],
      partners: [],
      fields: [
        { label: "S.No", key: "index" },
        { label: "name", key: "name", stickyColumn: true, tdClass: "bg-white" },
        { label: "father name", key: "father_name" },
        { label: "Contact", key: "contact_father" },
        { label: "Class", key: "class_current" },
        { label: "Fees", key: "monthly_fee" },
        { label: "status", key: "status" },
        "actions",
      ],
      otherFields: [
        { label: "S.No", key: "index" },
        { label: "name", key: "name" },
        { label: "Surname", key: "surname" },
        { label: "father name", key: "father_name" },
        { label: "Contact", key: "contact_father" },
        { label: "Class", key: "class_current" },
        { label: "Fees", key: "monthly_fee" },
        { label: "status", key: "status" },
        "actions",
      ],
      surnameVisible: [
        "myskool_concept_thatta",
        "myskool_perfect_thatta",
        "myskool_yakubov",
      ],
      currentSections: [],
      items: [],
      total: null,
      selected: null,
      rangeDate: null,
      myObj: {
        id: 0,
        name: "",
        father_name: "",
        contact: "",
        email: "",
        address: "",
        purpose: "",
        tag: "",
        date: "0001-01-01T00:00:00",
        campusID: this.$store.state.userData.cId,
        attachments: [],
      },
      leftSelected: "None",
      leftOptions: [
        // { text: "Left", value: "" }, // default in api
        // { text: "Alumni", value: "alumni" },
      ],
      catFields: [
        { label: "Name", key: "title" },
        { key: "actions", label: "actions" },
      ],
      visibility9: false,
      catObj: {},
      savingCat: false,
      leaveObj: {},
      susObj: {
        sID: 0,
        suspend_till: null,
        suspend_reason: "",
        suspend_mode: "partial",
        suspend_for_attentance: false,
        suspend_for_homework: false,
        suspend_for_exams: false,
        suspend_for_messaging: false,
      },
      suspendModeOptions: [
        { text: "Partial", value: "partial" },
        { text: "Full", value: "full" },
      ],
      currentSelected: "",
      susOptions: [
        { text: "1 Week", value: "week" },
        { text: "1 Month", value: "month" },
        { text: "1 Year", value: "year" },
      ],
      visibility5: false,
      totalDues: 0,
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      leavingDateConfig: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        maxDate: "today",
      },
      classesOptions: [],
      detailObj: null,
      avatarURL:
        "https://raw.githubusercontent.com/Ashwinvalento/cartoon-avatar/master/lib/images/female/110.png",
      feeImporting: false,
      stdImporting: false,
      staffImporting: false,
      feeData: [],
      stdData: [],
      staffData: [],
      codeBy: false,
      syncLoading: false,
      assignLoading: false,
      exporting: false,
      printing: false,
      stdIDs: [],
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      sessionID: null,
      sessionName: "",
      sessions: [],
      certOptions: [
        { name: "ID Card", value: "id-card" },
        { name: "Gate Pass", value: "gatepass" },
        { name: "Admission Form", value: "admission-form" },
        { name: "Transfer Certificate", value: "transfer" },
        { name: "Leaving Certificate", value: "leaving" },
        { name: "Character Certificate", value: "character" },
        { name: "Provisional Certificate", value: "provisional" },
      ],
      searchType: this.$store.state.stdSearch,
      searchOptions: [
        { name: "General", value: "" },
        { name: "GR", value: "gr" },
        { name: "Name", value: "name" },
        { name: "Father Name", value: "father name" },
        { name: "Family Code", value: "family code" },
        { name: "Contact", value: "contact" },
        { name: "Surname", value: "surname" },
        { name: "CNIC", value: "cnic" },
        { name: "Section", value: "section" },
      ],
      eTypee: "",
      examType: [],
      admitCardSessionID: null,
      admitCardDate: new Date().toLocaleDateString("en-UK", {
        year: "numeric",
        day: "numeric",
        month: "long",
      }),
      reportObj: {
        type: "",
        selectedCampus: this.$store.state.userData.cId,
      },
      kentPrintClass: 0,
      kentPrintSec: 0,
      kentPrintSections: [{ section: "All Sections", id: 0 }],
      reportPrinting: false,
      exportSchema: [],
      exportSelected: [],
      visibility4: false,
      reqObj: {},
      visibility6: false,
      requestOptions: [
        { text: "General", value: "general" },
        { text: "Left", value: "left" },
        { text: "TC", value: "tc" },
        { text: "Transfer", value: "transfer" },
        { text: "Re Enroll", value: "re enroll" },
      ],
      currentOptions: [],
      visibility8: false,
      reqData: [],
      reqFields: [
        { label: "request", key: "request" },
        { label: "Request type", key: "type" },
        { label: "status", key: "status" },
        { label: "actions", key: "actions" },
      ],
      accIcon: "",
      sessionbar: false,
      sessionObj: {
        id: 0,
        session: "",
        campusID: this.$store.state.userData.cId,
      },
      sessFields: [
        { label: "Name", key: "session" },
        { key: "actions", label: "actions" },
      ],
      savingacc: false,
      campuses: [],
      chObj: {},
      visibility7: false,
      chOptions: [],
      chClasses: [],
      chSections: [],
      clsLoading: false,
      saving: false,
      slrObj: null,
      docLoading: false,
      docList: [],
      reqCountList: [],
      reqStdIDs: [],
      editField: {},
      visibility10: false,
      editObj: {},
      editSections: [],
      editing: false,
      qrValue: "",
      showFaceId: false,
      faceIdLoading: false,
      showFaceIdModal: false,
      enrollmentLink: "",
      currentStudentId: null,
      isHeadOffice: null,
      msgVisible: ["myskoolksa", "myskool"],
      regTemplate: null,
      messageText: "",
      sending: false,
      admFeeObj: null,
      admFeeList: [],
      admStdIDs: [],
      moreReports: ["myskoolalhameed"],

      // Template related state
      showTemplateModal: false,
      templates: [],
      templateLoading: false,
      templatePage: 1,
      templateTotal: 0,
      templatePerPage: 10,
      selectedTemplate: null,
      printingTemplate: false,
      templateSearch: "",
      templateFields: [
        { key: "title", label: "Title", sortable: false },
        { key: "templateFor", label: "Type", sortable: false },
      ],
      templateLink: null,
      resetLoading: false,
      hideRegistration: false,
      hideAdmission: false,
      qrSID: "",
      qrModalTitle: "",
      allDocs: [],
      stdDetails: [],
      verifyModalVisible: false,
      verifyStd: null,
      verifyObj: {
        sID: 0,
        userID: 0,
        isConditional: false,
        comment: "",
      },
      verifying: false,
      acceptedBy: "",
      filterOptions: [
        { text: "All", value: "" },
        { text: "App", value: "app-login" },
        { text: "Admin", value: "admin-portal" },
      ],
      approvalList: [],
      currentStd: null,
      reqAmount: null,
      reqAmountFeedback: "",
      utpCampuses: [],
      includeUtp: false,

      // Custom fee import (StudentsCustomFee/Import)
      showCustomFeeImportModal: false,
      customFeeStep: "form",
      customFeeObj: { feeTypeID: null },
      importFeeTypeOptions: [],
      importFeeTypeLoading: false,
      customFeeRows: [],
      customFeePreview: [],
      customFeeParseStats: { included: 0, excludedNoAmount: 0 },
      customFeeFile: null,
      customFeeParsing: false,
      customFeeSubmitting: false,
      customFeeExporting: false,
      customFeeResult: {},
      customFeePreviewFields: [
        { key: "row", label: "Row" },
        { key: "sID", label: "Student ID" },
        { key: "name", label: "Name" },
        {
          key: "amount",
          label: "Amount",
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      customFeeSavedFields: [
        { key: "row", label: "Row" },
        { key: "sID", label: "Student ID" },
        { key: "studentName", label: "Name" },
        { key: "grNo", label: "GR No" },
        { key: "feeType", label: "Fee Type" },
        {
          key: "amount",
          label: "Amount",
          thClass: "text-right",
          tdClass: "text-right",
        },
        { key: "action", label: "Action" },
      ],
      customFeeSkippedFields: [
        { key: "row", label: "Row" },
        { key: "sID", label: "Student ID" },
        { key: "reason", label: "Reason" },
      ],

      // Bulk driver link import (StudentDriver/Import)
      showBulkDriverLinkModal: false,
      driverLinkStep: "form",
      driverLinkObj: { driverID: null, vehicleID: null },
      driverLinkOptions: [],
      driverLinkOptionsLoading: false,
      driverLinkRows: [],
      driverLinkPreview: [],
      driverLinkParseStats: { included: 0, skipped: 0 },
      driverLinkFile: null,
      driverLinkParsing: false,
      driverLinkSubmitting: false,
      driverLinkExporting: false,
      driverLinkResult: {},
      driverLinkPreviewFields: [
        { key: "row", label: "Row" },
        { key: "sID", label: "Student ID" },
        { key: "name", label: "Name" },
      ],
      driverLinkSavedFields: [
        { key: "row", label: "Row" },
        { key: "sID", label: "Student ID" },
        { key: "grNo", label: "GR No" },
        { key: "studentName", label: "Name" },
        { key: "className", label: "Class" },
        { key: "sectionName", label: "Section" },
        { key: "driverName", label: "Driver" },
        { key: "vehicle", label: "Vehicle" },
        { key: "action", label: "Action" },
      ],
      driverLinkSkippedFields: [
        { key: "row", label: "Row" },
        { key: "sID", label: "Student ID" },
        { key: "reason", label: "Reason" },
      ],
    };
  },
  methods: {
    ...mapActions({
      get: "get",
      post: "post",
      put: "put",
      delete: "delete",
      postObj: "postObj",
    }),

    isImage(url) {
      return isImageUrl(url);
    },
    getStudentPicturePreview(url) {
      if (!url) return "";
      if (String(url).startsWith("blob:")) return url;
      return getMediaPreviewUrl(url, "Image");
    },
    onStudentPictureError(event, url) {
      if (!url || String(url).startsWith("blob:")) return;
      handleDrivePreviewError(event, url, "image");
    },
    openFile(url) {
      window.open(url, "_blank");
    },

    downloadQR(item) {
      this.qrSID = item.id.toString();
      this.$nextTick(() => {
        const canvas = document.querySelector("#std-qr canvas");
        let image = canvas.toDataURL();
        let dLink = document.createElement("a");
        dLink.download = `${item.name}-${item.id}.png`;
        dLink.href = image;
        dLink.click();
      });
    },

    showSyncedDetails(details, id) {
      if (!details) {
        this.$bvToast.toast(this.$t("No synchronization details found."), {
          title: this.$t("Wait!"),
          variant: "warning",
          solid: true,
        });
        return;
      }
      this.selectedSyncedStaffID = id;

      if (typeof details === "string") {
        try {
          this.selectedSyncedDetails = JSON.parse(details);
        } catch (e) {
          this.selectedSyncedDetails = null;
        }
      } else {
        this.selectedSyncedDetails = details;
      }
      this.showSyncedModal = true;
    },
    async syncSingle() {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: "This will syncronize mobile accounts.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, Sync it!",
      });

      if (result.isConfirmed) {
        this.stdSyncing = true;
        var status = await this.get({
          url:
            this.$store.state.domain +
            "Students/SyncStudent?db=" +
            this.$store.state.userData.db +
            "&sID=" +
            this.selectedSyncedStaffID,
          message: "Accounts synced successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.stdSyncing = false;
        if (status) {
          this.showSyncedModal = false;
          if (this.byFilter) this.Filter(this.currentPage);
          else this.LoadData();
        }
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const formattedDate = date.toLocaleDateString("en-GB"); // 'DD/MM/YYYY'
      return formattedDate;
      // Replace '/' with '-' to match the desired format
      // return formattedDate.replace(/\//g, "-");
    },

    openQr() {
      this.qrValue = `${window.location.origin}/student-admission?db=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}`;
      this.$bvModal.show("modal-qr");
    },
    /** Registration QR — same link as studentPublic / studentRegistered */
    openRegistrationQr() {
      this.qrModalTitle = this.$t("Registration QR Code");
      if (this.reportDomain === "myskoolhpgs") {
        this.qrValue = `${window.location.origin}/registration?db=${this.$store.state.userData.db}`;
      } else if (["myskoolprofectus", "myskool"].includes(this.reportDomain)) {
        this.qrValue = `${window.location.origin}/school-inquiry?db=${this.$store.state.userData.db}`;
      } else if (this.reportDomain === "myskoolcrestviewacademy") {
        this.qrValue = `${window.location.origin}/crestview-student-registration?db=${this.$store.state.userData.db}&cId=${this.$store.state.userData.cId}`;
      } else {
        this.qrValue = `${window.location.origin}/student-registration?db=${this.$store.state.userData.db}&cId=${this.$store.state.userData.cId}`;
      }
      this.$bvModal.show("modal-qr");
    },
    openStudentRegistrationQr(item) {
      const campusId = item.campusID || this.$store.state.userData.cId;
      this.qrModalTitle = `${this.$t("Registration QR Code")} - ${
        item.name || item.id
      }`;
      this.qrValue = `${window.location.origin}/crestview-student-registration?db=${this.$store.state.userData.db}&cId=${campusId}&sID=${item.id}`;
      this.$bvModal.show("modal-qr");
    },
    copyQr() {
      copy(this.qrValue);
      this.$bvToast.toast(this.$t("Link Copied."), {
        title: this.$t("Copied!"),
        variant: "success",
        toaster: "b-toaster-top-center",
        solid: true,
      });
    },
    saveQr() {
      const canvas = document.querySelector("#modal-qr canvas");
      let image = canvas.toDataURL();
      let dLink = document.createElement("a");
      dLink.download = "registration.png";
      dLink.href = image;
      dLink.click();
    },

    handleReadmit(item) {
      if (["myskooltcfdemo", "myskooltcf"].includes(this.reportDomain)) {
        this.openReadmitModal(item);
      } else {
        this.$router.push({
          name: "manage-student",
          params: {
            id: item.id,
            readmit: true,
          },
          query: {
            status: item.status.toLowerCase(),
          },
        });
      }
    },
    openReadmitModal(item) {
      this.readmitStudent = item;
      this.readmitModalVisible = true;
    },
    async confirmReadmit() {
      if (!this.readmitStudent) return;

      this.readmitting = true;

      const status = await this.post({
        url:
          this.$store.state.domain +
          "StudentDetails/ReadmitStudent?db=" +
          this.$store.state.userData.db +
          "&sID=" +
          this.readmitStudent.id +
          "&userID=" +
          this.$store.state.userData.userID,
        message: this.$t("Student readmitted successfully."),
        context: this,
        token: this.$store.state.userData.token,
      });

      this.readmitting = false;

      if (status) {
        this.readmitModalVisible = false;
        this.readmitStudent = null;
        if (this.byFilter) this.Filter(this.currentPage);
        else this.LoadData();
      }
    },

    confirmAdmission(item) {
      if (["myskooltcfdemo", "myskooltcf"].includes(this.reportDomain)) {
        this.openScholarshipModal(item);
      } else if (this.approvalList.includes("confirm-admission")) {
        this.openLeaveReq(item, "confirm-admission");
      } else {
        this.$router.push({
          name: "manage-student",
          params: {
            id: item.id,
            readmit: true,
          },
          query: {
            status: item.status.toLowerCase(),
          },
        });
      }
    },
    openScholarshipModal(item) {
      this.scholarshipStudent = item;
      this.scholarshipModalVisible = true;

      this.sectionList = [];
      this.scholarshipSectionID = 0;
      if (item.meta_class.includes("N/A")) {
        this.LoadSections(item.campusID);
      }
    },
    async LoadSections(cID) {
      this.secLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Sections?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          cID,
        token: this.$store.state.userData.token,
      };
      this.sectionList = await this.get(obj);
      this.sectionList = this.sectionList.filter((el) => el.section != "N/A");
      this.secLoading = false;
    },
    async acceptScholarship() {
      if (!this.scholarshipStudent) return;
      if (this.sectionList.length > 0 && this.scholarshipSectionID == 0) {
        this.$bvToast.toast(this.$t("Please select the Inter Faculty"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.scholarshipConfirming = true;

      const status = await this.post({
        url:
          this.$store.state.domain +
          "StudentDetails/AcceptScholarship?db=" +
          this.$store.state.userData.db +
          "&sID=" +
          this.scholarshipStudent.id +
          "&userID=" +
          this.$store.state.userData.userID +
          "&sectionID=" +
          this.scholarshipSectionID,
        message: this.$t("Scholarship confirmed successfully."),
        context: this,
        token: this.$store.state.userData.token,
      });

      this.scholarshipConfirming = false;

      if (status) {
        this.scholarshipModalVisible = false;
        this.scholarshipStudent = null;
        if (this.byFilter) this.Filter(this.currentPage);
        else this.LoadData();
      }
    },

    isAccepted(id) {
      const acceptVia = this.getDetails(id, "acceptedBy");
      if (acceptVia) {
        return this.isHeadOffice
          ? acceptVia == "admin-portal"
          : acceptVia == "app-login";
      }
      return false;
    },
    openVerify(item) {
      this.verifyStd = item;
      this.verifyModalVisible = true;

      this.verifyObj = {
        sID: item.id,
        userID: this.$store.state.userData.userID,
        isConditional: this.isHeadOffice,
        comment: "",
      };
    },
    async acceptVerification() {
      if (!this.verifyStd) return;
      if (this.verifyObj.isConditional && !this.verifyObj.comment) {
        this.$bvToast.toast(this.$t("Please enter the comment"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.verifying = true;
      this.verifyObj.comment = this.verifyObj.isConditional
        ? this.verifyObj.comment
        : "";

      const status = await this.post({
        url:
          this.$store.state.domain +
          "StudentDetails/VerifyStudent?db=" +
          this.$store.state.userData.db,
        body: this.verifyObj,
        message: this.$t("Student verified successfully."),
        context: this,
        token: this.$store.state.userData.token,
      });

      this.verifying = false;

      if (status) {
        this.verifyModalVisible = false;
        this.verifyStd = null;
        if (this.byFilter) this.Filter(this.currentPage);
        else this.LoadData();
      }
    },

    openEdit(val, item) {
      // console.log(val);
      this.editField = val;
      this.editObj = { ...item };
      this.editSections = [];

      if (val.field == "section") {
        let obj = this.classes.find((el) => el.cls.id == item.class_current);
        if (obj && obj.sections.length > 0) {
          this.editSections = obj.sections;
        } else this.editSections = [];
      } else if (val.field == "grNo") {
        this.editObj.tempGr = this.editObj.grNoLocal;

        // ["myskoolhpgs", "myskoolprofectus"].includes(
        //   this.reportDomain
        // )
        //   ? this.editObj.grNoLocal
        //   : this.editObj.grNo;
      }
      this.visibility10 = true;

      this.$nextTick(() => {
        var elem = this.$refs["ed_sec"] || this.$refs["ed_gr"];
        elem.state = undefined;
        // console.log(elem);
      });
    },
    checkField() {
      if (this.editField.field == "section") {
        var elem = this.$refs["ed_sec"];
        if (this.editObj.section_current == 0) {
          return (elem.state = false);
        } else return (elem.state = true);
      } else if (this.editField.field == "grNo") {
        var elem = this.$refs["ed_gr"];
        if (this.editObj.tempGr == "") {
          return (elem.state = false);
        } else return (elem.state = true);
      }
      return false;
    },
    async saveField() {
      // console.log(this.editObj);
      // console.log(this.checkField());

      if (this.checkField() == true) {
        this.editing = true;
        if (this.editField.field == "grNo") {
          this.editObj.grNoLocal = this.editObj.tempGr;
        }
        var status = await this.put({
          url:
            this.$store.state.domain +
            "Students/" +
            this.editObj.id +
            "?db=" +
            this.$store.state.userData.db,
          message: this.editField.field + " updated successfully.",
          context: this,
          body: this.editObj,
          // savingStudent: true,
          token: this.$store.state.userData.token,
        });
        this.editing = false;
        if (status) {
          if (this.byFilter) this.Filter(this.currentPage);
          else this.LoadData();
          this.visibility10 = false;
        }
      }
    },

    async LoadTemplates() {
      var obj = {
        url:
          this.$store.state.domain +
          "MessageTemplate?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      this.regTemplate = res.find((el) =>
        el.title.toLowerCase().includes("registration")
      );
      // console.log(this.regTemplate);
    },
    openMessage() {
      if (this.regTemplate && this.regTemplate.message) {
        this.messageText = this.regTemplate.message;
      }
      this.$bvModal.show("modal-message");
    },
    async sendMessage() {
      if (this.messageText.trim() == "") {
        this.$bvToast.toast(this.$t("Please enter message"), {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.sending = true;
      try {
        const messageObj = {
          audio: "",
          media: this.regTemplate ? this.regTemplate.media : "",
          message: this.messageText,
          sIDs: this.stdIDs,
          tIDs: [],
          campusID: this.$store.state.userData.cId,
          userID: this.$store.state.userData.userID,
        };

        var resp = await this.postObj({
          url:
            this.$store.state.domain +
            "Chat/SendMessageSelected?db=" +
            this.$store.state.userData.db,
          body: messageObj,
          message: "Messages are being processed.",
          context: this,
          token: this.$store.state.userData.token,
        });

        this.$bvModal.hide("modal-message");
        this.messageText = "";
        this.unselect();
      } catch (error) {
        console.error("Error sending message:", error);
      } finally {
        this.sending = false;
      }
    },

    async LoadSettingsAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: [
          "student_left_request",
          "adm_fee_details",
          "template_link",
          "hide_registration",
          "hide_admission",
          "admin-approval",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.slrObj = res.find((el) => el.key == "student_left_request");
      this.admFeeObj = res.find((el) => el.key == "adm_fee_details");
      this.templateLink = res.find((el) => el.key == "template_link");
      this.hideRegistration =
        res.find((el) => el.key == "hide_registration")?.valueBool || false;
      this.hideAdmission =
        res.find((el) => el.key == "hide_admission")?.valueBool || false;
      // console.log(this.slrObj);
      if (this.slrObj && this.slrObj.valueBool) this.LoadReqCount();
      if (this.admFeeObj && this.admFeeObj.valueBool) this.LoadAdmFee();

      const obj = res.find((el) => el.key == "admin-approval");
      if (obj && obj.valueBool && obj.value) {
        this.approvalList = obj.value
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v);
      }
    },
    async LoadReqCount() {
      var obj = {
        url:
          this.$store.state.domain +
          "studentLeftRequest/LoadRequestCount?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.reqCountList = await this.get(obj);
      this.reqStdIDs = this.reqCountList.map((el) => el.sID);
      // console.log(this.reqStdIDs);
    },
    getReqCount(id) {
      let obj = this.reqCountList.find((el) => el.sID == id);
      return obj ? obj.requestCount : 0;
    },
    async LoadAdmFee() {
      let res = await this.get({
        url:
          this.$store.state.domain +
          "Students/AdmFeeDetails?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      });
      this.admFeeList = res;
      this.admStdIDs = this.admFeeList.map((el) => el.studentID);
      // console.log(this.admFeeList);
    },
    getAdmFee(id) {
      let obj = this.admFeeList.find((el) => el.studentID == id);
      return obj ? `Adm. Bal: ${obj.remainingAmount}` : "";
    },

    // Template specific methods
    openTemplateModal() {
      this.templatePage = 1;
      this.selectedTemplate = null;
      this.templateSearch = "";
      this.showTemplateModal = true;
      this.fetchTemplates();
    },

    async fetchTemplates() {
      this.templateLoading = true;
      try {
        const params = new URLSearchParams({
          db: this.$store.state.userData.db,
          cID: this.$store.state.userData.cId,
          page: this.templatePage,
          pageSize: this.templatePerPage,
          templateFor: "Student",
        });

        if (this.templateSearch) {
          params.append("search", this.templateSearch);
        }

        const obj = {
          url:
            this.$store.state.domain +
            "TemplateData/GetByPagination?" +
            params.toString(),
          token: this.$store.state.userData.token,
          dashboard: true,
        };

        const res = await this.get(obj);

        if (res && res.status === "success" && Array.isArray(res.data)) {
          this.templates = res.data;
          this.templateTotal = res.totalCount || 0;
        } else if (res && Array.isArray(res.data)) {
          this.templates = res.data;
          this.templateTotal = res.total || res.totalCount || 0;
        } else {
          this.templates = [];
          this.templateTotal = 0;
        }
      } catch (error) {
        console.error("Error fetching templates:", error);
        this.$bvToast.toast(this.$t("Failed to load templates"), {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
      } finally {
        this.templateLoading = false;
      }
    },

    printWithTemplate() {
      if (!this.selectedTemplate || this.stdIDs.length === 0) {
        return;
      }

      this.printingTemplate = true;
      try {
        // Construct the print URL
        const url =
          `https://${this.reportDomain}.myskool.app/Certificate/DataTemplate?dbb=` +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&id=" +
          this.stdIDs.join(",") +
          "&templateID=" +
          this.selectedTemplate.id +
          "&type=Student";

        window.open(url, "_blank");
      } catch (error) {
        console.error("Error printing template:", error);
      } finally {
        this.printingTemplate = false;
      }
    },

    async LoadLeftCat() {
      var obj = {
        url:
          this.$store.state.domain +
          "DropDownList/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&category=leftCategories",
        token: this.$store.state.userData.token,
      };
      this.leftOptions = await this.get(obj);
    },
    openCat() {
      this.catObj = {
        id: 0,
        title: "",
        typee: "leftCategories",
        campusID: this.$store.state.userData.cId,
      };
      this.visibility9 = true;
      var elem = this.$refs["cat_name"];
      elem.state = undefined;
    },
    checkCat() {
      var elem = this.$refs["cat_name"];
      if (this.catObj.title.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveCat() {
      if (this.checkCat() == true) {
        this.savingCat = true;
        if (this.catObj.id == 0) {
          var status = await this.post({
            url:
              this.$store.state.domain +
              "DropDownList?db=" +
              this.$store.state.userData.db,
            body: this.catObj,
            message: "Category added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "DropDownList/" +
              this.catObj.id +
              "?db=" +
              this.$store.state.userData.db,
            message: "Category updated successfully.",
            context: this,
            body: this.catObj,
            token: this.$store.state.userData.token,
          });
        }
        if (status) {
          this.LoadLeftCat();
          this.catObj = {
            id: 0,
            title: "",
            typee: "leftCategories",
            campusID: this.$store.state.userData.cId,
          };
          var elem = this.$refs["cat_name"];
          elem.state = undefined;
        }
        this.savingCat = false;
      }
    },
    async editCat(acc) {
      this.catObj = { ...acc };
      var elem = this.$refs["cat_name"];
      elem.state = undefined;
    },
    async deleteCat(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "DropDownList/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          message: "Category deleted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadLeftCat();
      }
    },

    openCh(item) {
      this.chObj = {
        ...item,
        newCampus: 0,
        clsID: 0,
        secID: 0,
      };

      this.visibility7 = true;
      this.chSections = [];
      this.chClasses = [];
      this.chOptions = [];
    },
    async LoadClass() {
      this.checkChCamp();
      this.clsLoading = true;
      this.chObj.clsID = 0;
      this.chObj.secID = 0;
      this.chSections = [];

      var obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.chObj.newCampus +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      //  this.items =[];
      let myitem = await this.get(obj);
      this.chClasses = myitem;
      this.chOptions = this.chClasses.map((el) => el.cls);

      this.clsLoading = false;
    },
    FillChSec() {
      this.chObj.secID = 0;
      this.chSections = [];
      let obj = this.chClasses.find((el) => el.cls.id == this.chObj.clsID);
      if (obj && obj.sections.length > 0) {
        this.chSections = obj.sections;
      } else this.chSections = [];

      this.checkChClass();
    },
    checkChCamp() {
      var elem = this.$refs["ch_camp"];
      if (this.chObj.newCampus == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkChClass() {
      var elem = this.$refs["ch_cls"];
      if (this.chObj.clsID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkChSec() {
      var elem = this.$refs["ch_sec"];
      if (this.chObj.secID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveCh() {
      this.checkChCamp();
      this.checkChClass();
      this.checkChSec();
      if (
        this.checkChCamp() == false ||
        this.checkChClass() == false ||
        this.checkChSec() == false
      ) {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
      // else if (this.chObj.campusID == this.chObj.newCampus) {
      //   this.$bvToast.toast("Current campus and transfer campus are same", {
      //     title: this.$t("Error!"),
      //     variant: "danger",
      //     toaster: "b-toaster-top-center",
      //   });
      // }
      else {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: "Do you want to transfer the student?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes!",
        });

        if (result.isConfirmed) {
          this.request = true;
          let data = {
            sID: this.chObj.id,
            previousCampus: this.chObj.campusID,
            newCampus: this.chObj.newCampus,
            clsID: this.chObj.clsID,
            secID: this.chObj.secID,
            userID: this.$store.state.userData.userID,
          };
          // console.log(data);
          let status = await this.post({
            url:
              this.$store.state.domain +
              "Students/TransferCampus?db=" +
              this.$store.state.userData.db,
            body: data,
            message: "Student transferred successfully!",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) {
            this.visibility7 = false;
            if (this.byFilter) this.Filter(this.currentPage);
            else this.LoadData();
          }
        }
      }
    },

    setDate(sd, dateStr) {
      if (dateStr) {
        if (sd.length > 1) {
          let date = dateStr.split(" to ");
          if (date.length == 1) {
            this.admFilter.dtFrom = date[0];
            this.admFilter.dtTo = date[0];
          } else {
            this.admFilter.dtFrom = date[0];
            this.admFilter.dtTo = date[1];
          }
        } else {
          this.admFilter.dtFrom = dateStr;
          this.admFilter.dtTo = null;
        }
      } else {
        this.admFilter.dtFrom = null;
        this.admFilter.dtTo = null;
      }
      // console.log(this.admFilter.dtFrom, this.admFilter.dtTill);
    },
    getCampus(id) {
      let obj = this.campuses.find((el) => el.id == id);
      return obj ? obj.branch : "";
    },
    getDetails(id, key) {
      let obj = this.stdDetails.find((el) => el.sID == id);
      return obj ? obj[key] || "" : "";
    },

    applyStudentGridPayload(res) {
      if (!res) {
        return { items: [], total: 0, stdDetails: [], allDocs: [] };
      }

      if (Array.isArray(res)) {
        const normalized = this.normalizeGridStudents(res);
        return {
          items: normalized.items,
          total: res.length,
          stdDetails: normalized.details,
          allDocs: normalized.docs,
        };
      }

      if (Array.isArray(res.data)) {
        const normalized = this.normalizeGridStudents(res.data);
        const total =
          Number(res.count ?? res.totalCount ?? res.data.length) || 0;
        const stdDetails = [
          ...normalized.details,
          ...(Array.isArray(res.stdDetails) ? res.stdDetails : []),
        ];
        const docsData = [
          ...normalized.docs,
          ...(Array.isArray(res.allDocs) ? res.allDocs : []),
        ];
        return {
          items: normalized.items,
          total,
          stdDetails,
          allDocs: docsData,
        };
      }

      if (
        res.data &&
        typeof res.data === "object" &&
        Array.isArray(res.data.data)
      ) {
        const normalized = this.normalizeGridStudents(res.data.data);
        const total =
          Number(
            res.data.count ?? res.data.totalCount ?? res.data.data.length
          ) || 0;
        const stdDetails = [
          ...normalized.details,
          ...(Array.isArray(res.data.stdDetails) ? res.data.stdDetails : []),
          ...(Array.isArray(res.stdDetails) ? res.stdDetails : []),
        ];
        const docsData = [
          ...(Array.isArray(res.data.allDocs) ? res.data.allDocs : []),
          ...(Array.isArray(res.allDocs) ? res.allDocs : []),
        ];
        return {
          items: normalized.items,
          total,
          stdDetails,
          allDocs: docsData,
        };
      }

      return { items: [], total: 0, stdDetails: [], allDocs: [] };
    },

    normalizeGridStudents(rows) {
      const items = [];
      const details = [];
      const docs = [];

      (rows || []).forEach((entry) => {
        if (entry?.student) {
          items.push(entry.student);
          if (entry.studentDetails) {
            details.push(entry.studentDetails);
          }
          return;
        }
        items.push(entry);
      });

      return { items, details, docs };
    },

    openUpload(item) {
      this.currentID = item;
      // console.log(item);
      this.$refs.fileProfile.click();
    },
    selectlogo() {
      this.croppedCanvas = null;
      this.image = null;
      const file = this.$refs.fileProfile.files[0];
      if (file) {
        this.image = URL.createObjectURL(file);
      }
    },
    onChange({ coordinates, canvas }) {
      // Here you can handle the cropped image
      this.croppedCanvas = canvas;
      //console.log(coordinates, canvas);
    },
    uploadCroppedImage() {
      if (this.croppedCanvas) {
        this.croppedCanvas.toBlob((blob) => {
          const file = new File([blob], "cropped_image.png", {
            type: "image/png",
          });
          this.uploadLogo(file);
        }, "image/png");
      }
    },
    CloseCropper() {
      this.image = null;
      this.croppedCanvas = null;
      this.$refs.fileProfile.files = null;
    },
    async uploadLogo(file) {
      this.image = null;
      if (!file) return;
      this.logoloading = true;
      try {
        const uploaded = await uploadToMySkool([file]);
        this.currentID.picture = getUploadPath(uploaded[0]);
        this.updateStd();
        this.CloseCropper();
      } catch (err) {
        this.currentID = {};
        this.logoloading = false;
        this.CloseCropper();
      }
    },
    async updateStd() {
      let status = await this.put({
        url:
          this.$store.state.domain +
          "Students/UpdatePicture?db=" +
          this.$store.state.userData.db +
          "&sID=" +
          this.currentID.id +
          "&picture=" +
          this.currentID.picture,
        message: "Picture updated successfully!",
        context: this,
        token: this.$store.state.userData.token,
      });
      this.logoloading = false;
      this.currentID = {};
    },

    async LoadCampuses() {
      var obj = {
        url:
          this.$store.state.domain +
          "campuses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.campuses = await this.get(obj);
    },

    async loadSessions() {
      var obj = {
        url:
          this.$store.state.domain +
          "Sessions?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.sessions = await this.get(obj);
      let sess = this.sessions.find((el) => el.isCurrentSession);
      if (
        sess &&
        this.$store.state.currentBranch.organizationType == "coaching"
      ) {
        this.sessionName = sess.session;
        this.sessionID = sess.id;
      }
    },
    async loadExamTypes() {
      var obj = {
        url:
          this.$store.state.domain +
          "ExamTypes?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.examType = await this.get(obj);
    },
    initQalamAdmitCardDefaults() {
      if (!this.admitCardSessionID && this.sessions.length) {
        const sess =
          this.sessions.find((el) => el.isCurrentSession) || this.sessions[0];
        if (sess) {
          this.admitCardSessionID = sess.id;
        }
      }
      if (!this.examType.length) {
        this.loadExamTypes();
      }
    },
    formatAdmitCardDateForUrl(dateVal) {
      if (!dateVal) {
        return "";
      }
      const parsed = new Date(dateVal);
      if (!Number.isNaN(parsed.getTime())) {
        return parsed.toLocaleDateString("en-UK", {
          year: "numeric",
          day: "numeric",
          month: "long",
        });
      }
      return String(dateVal);
    },
    openSession() {
      this.accIcon = "PlusIcon";
      this.sessionbar = true;

      this.sessionObj = {
        id: 0,
        session: "",
        campusID: this.$store.state.userData.cId,
      };
      var elem = this.$refs["sess_name"];
      elem.state = undefined;
    },
    async editSess(item) {
      this.sessionObj = { ...item };
      this.accIcon = "Edit2Icon";
      var elem = this.$refs["sess_name"];
      elem.state = undefined;
      // console.log(this.sessionObj);
    },
    SessName() {
      var elem = this.$refs["sess_name"];
      if (this.sessionObj.session.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async setCurrentSess(id) {
      var status = await this.post({
        url:
          this.$store.state.domain +
          "Sessions/SetCurrentSession?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&sessionID=" +
          id,
        body: this.sessionObj,
        message: "Session marked as current",
        context: this,
        token: this.$store.state.userData.token,
      });

      if (status) {
        this.loadSessions();
      }
    },
    async saveSession() {
      if (this.SessName() == true) {
        this.savingacc = true;
        if (this.sessionObj.id == 0) {
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Sessions?db=" +
              this.$store.state.userData.db,
            body: this.sessionObj,
            message: "Session added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "Sessions/" +
              this.sessionObj.id +
              "?db=" +
              this.$store.state.userData.db,
            message: "Session updated successfully.",
            context: this,
            body: this.sessionObj,
            token: this.$store.state.userData.token,
          });
        }
        this.savingacc = false;
        if (status) {
          this.loadSessions();
          var elem = this.$refs["sess_name"];
          elem.state = undefined;
          this.sessionObj = {
            id: 0,
            session: "",
            campusID: this.$store.state.userData.cId,
          };
          this.accIcon = "PlusIcon";
        }
      }
    },
    async deleteSess(item) {
      // console.log(acc);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "Sessions/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          message: "Session removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.loadSessions();
      }
    },

    openReport() {
      if (this.stdIDs.length > 0) {
        if (this.reportDomain === "myskoolqalam") {
          this.initQalamAdmitCardDefaults();
        }
        this.$bvModal.show("modal-cert");
      } else if (
        this.reportDomain === "myskoolkentschool" ||
        (this.isHeadOffice && this.isTcfReportDomain())
      ) {
        if (this.reportDomain === "myskoolkentschool") {
          this.kentPrintClass = this.filter.cls || 0;
          this.kentPrintSec = this.filter.sec || 0;
          this.fillKentPrintSections("filled");
          if (!this.reportObj.type) {
            this.reportObj.type = "id-card";
          }
        }
        this.$bvModal.show("modal-cert");
      } else {
        this.$bvToast.toast(this.$t("Please select students first."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },
    checkRepType() {
      var elem = this.$refs["type"];
      if (this.reportObj.type == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    printRep() {
      if (this.checkRepType() == true) {
        this.reportPrinting = true;

        if (
          this.reportObj.type == "admission-form" &&
          ["myskooltcfdemo", "myskooltcf"].includes(this.reportDomain)
        ) {
          this.$router.push({
            name: "student-tcf-print",
            query: {
              db: this.$store.state.userData.db,
              cID:
                this.reportObj.selectedCampus || this.$store.state.userData.cId,
              sID: this.stdIDs.join(","),
            },
          });
          this.reportPrinting = false;
          this.$bvModal.hide("modal-cert");
          return;
        }

        if (
          this.reportObj.type == "admission-form" &&
          this.reportDomain === "myskoolcrestviewacademy"
        ) {
          const route = this.$router.resolve({
            name: "crestview-student-print",
            query: {
              db: this.$store.state.userData.db,
              cID: this.$store.state.userData.cId,
              sID: this.stdIDs.join(","),
            },
          });
          window.open(route.href, "_blank");
          this.reportPrinting = false;
          this.$bvModal.hide("modal-cert");
          return;
        }

        if (this.reportObj.type == "id-card") {
          // Farabi domain: route internally to FarabiCoaIDCard with selected student IDs
          if (this.reportDomain == "myskoolfarabicoa") {
            this.$router.push({
              name: "farabi-coa-id-card",
              query: {
                studentIDs: this.stdIDs.join(","),
                cID: this.$store.state.userData.cId,
                db: this.$store.state.userData.db,
                status: this.currentStatus,
                sessionID: this.$store.state.sessionID || 0,
              },
            });
            this.reportPrinting = false;
            this.$bvModal.hide("modal-cert");
            return;
          }

          // Happiness Foundation domain: route internally to happinessFoundationIDCard
          if (this.reportDomain == "myskoolhappinessfoundation") {
            this.$router.push({
              name: "happiness-foundation-id-card",
              query: {
                studentIDs: this.stdIDs.join(","),
                cID: this.$store.state.userData.cId,
                db: this.$store.state.userData.db,
                status: this.currentStatus,
                sessionID: this.$store.state.sessionID || 0,
              },
            });
            this.reportPrinting = false;
            this.$bvModal.hide("modal-cert");
            return;
          }

          // kent school
          if (this.reportDomain == "myskoolkentschool") {
            const query = {
              cID: this.$store.state.userData.cId,
              db: this.$store.state.userData.db,
              status: this.currentStatus,
              sessionID: this.sessionID || this.$store.state.sessionID || 0,
            };

            if (this.stdIDs.length) {
              query.studentIDs = this.stdIDs.join(",");
            } else {
              query.cls = this.kentPrintClass || 0;
              query.sec = this.kentPrintSec || 0;
            }

            this.$router.push({
              name: "kent-id-card",
              query,
            });
            this.reportPrinting = false;
            this.$bvModal.hide("modal-cert");
            return;
          }

          // smart hassan campus
          if (
            this.reportDomain == "myskoolsmarthf" &&
            this.$store.state.userData.cId == 2
          ) {
            this.$router.push({
              name: "smart-hassan-id-card",
              query: {
                studentIDs: this.stdIDs.join(","),
                cID: this.$store.state.userData.cId,
                db: this.$store.state.userData.db,
                status: this.currentStatus,
                sessionID: this.$store.state.sessionID || 0,
              },
            });
            this.reportPrinting = false;
            this.$bvModal.hide("modal-cert");
            return;
          }

          // beprince
          if (this.reportDomain == "myskoolbeprince") {
            this.$router.push({
              name: "beprince-id-card",
              query: {
                studentIDs: this.stdIDs.join(","),
                cID: this.$store.state.userData.cId,
                db: this.$store.state.userData.db,
                status: this.currentStatus,
                sessionID: this.$store.state.sessionID || 0,
              },
            });
            this.reportPrinting = false;
            this.$bvModal.hide("modal-cert");
            return;
          }

          // hpgs
          if (this.reportDomain == "myskoolhpgs") {
            const routename =
              this.$store.state.userData.cId == 57
                ? "hpgs-id-card-alevel"
                : "hpgs-id-card";
            this.$router.push({
              name: routename,
              query: {
                studentIDs: this.stdIDs.join(","),
                cID: this.$store.state.userData.cId,
                db: this.$store.state.userData.db,
                status: this.currentStatus,
                sessionID: this.$store.state.sessionID || 0,
              },
            });
            this.reportPrinting = false;
            this.$bvModal.hide("modal-cert");
            return;
          }

          var url =
            `https://${this.reportDomain}.myskool.app/Certificate/Show?type=id-card&dbb=` +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&sID=" +
            this.stdIDs +
            "&session=" +
            this.sessionName;
          window.open(url, "_blank");
        } else if (
          this.reportObj.type === "admit-card" &&
          this.reportDomain === "myskoolqalam"
        ) {
          if (!this.stdIDs.length) {
            this.$bvToast.toast(this.$t("Please select students first."), {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            });
            this.reportPrinting = false;
            return;
          }
          if (!this.eTypee) {
            this.$bvToast.toast(this.$t("Exam type is required."), {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            });
            this.reportPrinting = false;
            return;
          }
          if (!this.admitCardSessionID) {
            this.$bvToast.toast(this.$t("Session is required."), {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            });
            this.reportPrinting = false;
            return;
          }
          const dateParam = encodeURIComponent(
            this.formatAdmitCardDateForUrl(this.admitCardDate)
          );
          var url =
            `https://${this.reportDomain}.myskool.app/Certificate/Show?type=admit-card&dbb=` +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&cls=&sec=" +
            "&exam=" +
            encodeURIComponent(this.eTypee) +
            "&session=" +
            this.admitCardSessionID +
            "&date=" +
            dateParam +
            "&sID=" +
            this.stdIDs;
          window.open(url, "_blank");
        } else {
          var url =
            `https://${this.reportDomain}.myskool.app/Certificate/Show?type=${this.reportObj.type}&dbb=` +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&sID=" +
            this.stdIDs +
            "&cls=0&sec=0";
          window.open(url, "_blank");
        }
        this.reportPrinting = false;
        this.$bvModal.hide("modal-cert");
      }
    },
    printAdm(item) {
      if (["myskooltcfdemo", "myskooltcf"].includes(this.reportDomain)) {
        this.$router.push({
          name: "student-tcf-print",
          query: {
            db: this.$store.state.userData.db,
            cID: item.campusID || this.$store.state.userData.cId,
            sID: item.id,
          },
        });
        return;
      }

      if (this.reportDomain === "myskoolcrestviewacademy") {
        const route = this.$router.resolve({
          name: "crestview-student-print",
          query: {
            db: this.$store.state.userData.db,
            cID: item.campusID || this.$store.state.userData.cId,
            sID: item.id,
          },
        });
        window.open(route.href, "_blank");
        return;
      }

      var url =
        `https://${this.reportDomain}.myskool.app/Certificate/Show?type=admission-form&dbb=` +
        this.$store.state.userData.db +
        "&cID=" +
        item.campusID +
        "&sID=" +
        item.id +
        "&cls=0&sec=0";
      window.open(url, "_blank");
    },

    stdSelect(row) {
      this.stdIDs = row.reduce((acc, el) => {
        acc.push(el.id);
        return acc;
      }, []);

      // console.log(this.stdIDs);
    },

    unselect() {
      this.$refs.selectableTable.clearSelected();
      // this.stdIDs = [];
    },

    async resetRollNo() {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: "This will reset the roll numbers.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      });

      if (result.isConfirmed) {
        this.resetLoading = true;
        var status = await this.get({
          url:
            this.$store.state.domain +
            "Students/ResetRollNumber?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          message: "Roll numbers reset successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.resetLoading = false;
      }
    },

    async syncApp() {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: "This will syncronize mobile accounts.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, Sync it!",
      });

      if (result.isConfirmed) {
        this.syncLoading = true;
        var status = this.get({
          url:
            this.$store.state.domain +
            "Students/SyncAll?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          message: "Accounts synced successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });

        if (status) this.syncLoading = false;
      }
    },

    async assignCode() {
      console.log(this.codeBy);
      this.assignLoading = true;
      var status = this.post({
        url:
          this.$store.state.domain +
          "Students/GenerateFamilyCode?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&mob=" +
          this.codeBy,
        body: null,
        message: "Family code assigned successfully!",
        context: this,
        token: this.$store.state.userData.token,
      });

      if (status) {
        this.assignLoading = false;
        this.visibility3 = false;
      }

      // let result = await Swal.fire({
      //   title: this.$t("Are you sure?"),
      //   text: "This will auto assign family code using father's CNIC.",
      //   icon: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#d33",
      //   cancelButtonColor: "#3085d6",
      //   confirmButtonText: "Yes, Assign it!",
      // });

      // if (result.isConfirmed) {

      // }
    },
    async openExport() {
      if (this.isTcfReportDomain()) {
        if (this.isHeadOffice) {
          let result = await Swal.fire({
            title: this.$t("Include UTP?"),
            text: this.$t(
              "Do you want to include the UTP fields while exporting?"
            ),
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: this.$t("Yes"),
            cancelButtonText: this.$t("No"),
          });
          this.includeUtp = result.isConfirmed;
        }
        this.exportTcfBulkExcel();
        return;
      }

      this.exportSchema = [
        {
          text: "ID",
          value: "id",
          status: true,
        },
        {
          text: "grNo",
          value: "grNo",
          status: true,
        },
        {
          text: "Fcode",
          value: "family_code",
          status: true,
        },
        {
          text: "name",
          value: "name",
          status: true,
        },
        {
          text: "father_name",
          value: "father_name",
          status: false,
        },
        {
          text: "mother_name",
          value: "mother_name",
          status: false,
        },
        {
          text: "gender",
          value: "gender",
          status: false,
        },
        {
          text: "date_of_birth",
          value: "date_of_birth",
          status: false,
        },
        {
          text: "religion",
          value: "religion",
          status: false,
        },
        {
          text: "surname",
          value: "surname",
          status: false,
        },
        {
          text: "contact",
          value: "contact_father",
          status: false,
        },
        {
          text: "contact_mother",
          value: "contact_mother",
          status: false,
        },
        {
          text: "contact_student",
          value: "contact_student",
          status: false,
        },
        {
          text: "address",
          value: "address_current",
          status: false,
        },
        {
          text: "rollNo",
          value: "roll_number",
          status: false,
        },
        {
          text: "date_of_admission",
          value: "date_of_admission",
          status: false,
        },
        {
          text: "last_institute",
          value: "last_institute",
          status: false,
        },
        {
          text: "class",
          value: "meta_class",
          status: false,
        },
        {
          text: "class_admitted",
          value: "class_admitted",
          status: false,
        },
        {
          text: "fees",
          value: "monthly_fee",
          status: false,
        },
        {
          text: "status",
          value: "status",
          status: false,
        },
        {
          text: "house",
          value: "house",
          status: false,
        },
        {
          text: "bform_number",
          value: "bform_number",
          status: false,
        },
        {
          text: "father_occupation",
          value: "father_occupation",
          status: false,
        },
        {
          text: "father_cnic",
          value: "father_cnic",
          status: false,
        },
        {
          text: "father_education",
          value: "father_education",
          status: false,
        },
        {
          text: "father_office_phone",
          value: "office_phone",
          status: false,
        },
        {
          text: "father_office_address",
          value: "office_address",
          status: false,
        },
        {
          text: "mother_occupation",
          value: "mother_occupation",
          status: false,
        },
        {
          text: "mother_cnic",
          value: "mother_cnic",
          status: false,
        },
        {
          text: "mother_education",
          value: "mother_education",
          status: false,
        },
        {
          text: "mother_office_phone",
          value: "mother_office_phone",
          status: false,
        },
        {
          text: "mother_office_address",
          value: "mother_office_address",
          status: false,
        },
        {
          text: "guardian_name",
          value: "guardian_name",
          status: false,
        },
        {
          text: "guardian_cnic",
          value: "guardian_cnic",
          status: false,
        },
        {
          text: "rfID",
          value: "rfid_number",
          status: false,
        },
        {
          text: "date_of_leaving",
          value: "date_of_leaving",
          status: false,
        },
        {
          text: "leaving_reason",
          value: "last_note",
          status: false,
        },
        {
          text: "siblings",
          value: "siblings",
          status: false,
        },
      ];

      if (this.reportDomain == "myskoolhpgs") {
        this.exportSchema.splice(
          6,
          0,
          {
            text: "admitted campues",
            value: "campus_Admitted",
            status: false,
          },
          {
            text: "current campues",
            value: "campusID",
            status: false,
          }
        );
      } else {
        this.exportSchema.splice(6, 0, {
          text: "campus",
          value: "campusID",
          status: false,
        });
      }
      // console.log(this.exportSchema);
      this.visibility4 = true;
    },

    isTcfReportDomain() {
      return ["myskooltcfdemo", "myskooltcf"].includes(this.reportDomain);
    },

    parseTcfClassSection(student, studentDetails = {}) {
      const meta = String(student.meta_class || "").trim();
      if (meta.includes(" - ")) {
        const splitAt = meta.indexOf(" - ");
        return {
          className: meta.slice(0, splitAt).trim(),
          sectionName: meta.slice(splitAt + 3).trim(),
        };
      }
      return {
        className:
          student.cls_current?.name || student.cls_admitted?.name || "",
        sectionName:
          student.section_name ||
          student.sec_current?.name ||
          student.sec_admitted?.name ||
          "",
      };
    },

    formatTcfExportPercent(value) {
      if (value === null || value === undefined || value === "") return "";
      const num = Number(value);
      if (Number.isNaN(num)) return "";
      return `${num.toFixed(2)}%`;
    },

    mapTcfBulkExportRow(
      student,
      studentDetails = {},
      studentDocs = {},
      docTitles = []
    ) {
      const { className, sectionName } = this.parseTcfClassSection(
        student,
        studentDetails
      );
      const pct = (value) => this.formatTcfExportPercent(value);
      const leftDate = student.date_of_leaving
        ? new Date(student.date_of_leaving).toLocaleDateString("en-UK", {
            year: "numeric",
            day: "numeric",
            month: "short",
          })
        : "";

      const row = {
        id: student.id || "",
        "Fiscal Year": studentDetails.fiscalYear || "",
        Region: studentDetails.region || "",
        Area: studentDetails.area || "",
        Class: className,
        Section: sectionName,
        "Federal Board Registration No": studentDetails.federalRegNo || "",
        "Matric Roll No.": studentDetails.matricRollNo || "",
        "Student Name": student.name || "",
        "Father Name": student.father_name || "",
        Gender: student.gender || "",
        "School ID": studentDetails.schoolID || "",
        School: studentDetails.school || "",
        "9th %": pct(studentDetails.ninthPerc),
        "HSST %": pct(studentDetails.hsstPerc),
        "Overall Score (HSST + Matric)": pct(studentDetails.overallPerc),
        "HSST Status": studentDetails.hsstStatus || "",
        "Matric %": pct(studentDetails.matricPerc),
        "Matric Grade": studentDetails.matricGrade || "",
        "Student Contact No": student.contact_student || "",
        "WhatsApp No": student.contact_father || "",
        "Parent's Contact": student.contact_mother || "",
        "Student's CNIC No.": studentDetails.studentCnic || "",
        "Scholarship Category": studentDetails.scholarshipCategory || "",
        "Supported Years": studentDetails.supportedYears || 0,
        "Branch Code": studentDetails.branchCode || "",
        "Institute Name": studentDetails.instituteName || "",
        Comment: studentDetails.comment || "",
        "Scholarship Status": studentDetails.scholarshipStatus || "",
        "Zakat Eligibility": studentDetails.zakatEligible || "",
        "Avg Attendance": studentDetails.avgAttendance ?? "",
        "Student Status": studentDetails.studentStatus || "",
        // "Inter Faculty": studentDetails.interFaculty || "",
        "1st Year Roll Number": studentDetails.firstYearRollNo || "",
        "Intermediate Board": studentDetails.intermediateBoard || "",
        "1st Year % ": pct(studentDetails.firstYearPerc),
        "1st Year Paper Passed": studentDetails.paperPassed || "",
        Email: student.emailAddress || "",
        "Student Category": student.last_result || "",
        College: studentDetails.college || "",
        "Matric Board": studentDetails.matricBoard || "",
        "2nd Year Roll Number": studentDetails.secondYearRollNo || "",
        "2nd Year %": pct(studentDetails.secondYearPerc),
        "Current Campus": this.getCampus(student.campusID) || "",
        "Current Status": student.status || "",
        "Leaving Date": leftDate,
        "Leaving Reason": student.last_note || "",
        ...(this.includeUtp
          ? {
              "UTP Support": studentDetails.utpSupport || "",
              "UTP Enrolled On": studentDetails.utpEnrolledOn
                ? new Date(studentDetails.utpEnrolledOn).toLocaleDateString("en-UK", {
                    year: "numeric",
                    day: "numeric",
                    month: "short",
                  })
                : "",
              "UTP Fiscal Year": studentDetails.utpFiscalYear || "",
              "UTP Course": studentDetails.utpCourse || "",
              "1. Locked Program": studentDetails.utpLockedProgram1 || "",
              "1. Locked Tier": studentDetails.utpLockedTier1 || "",
              "2. Locked Program": studentDetails.utpLockedProgram2 || "",
              "2. Locked Tier": studentDetails.utpLockedTier2 || "",
              "UTP Institute ID": studentDetails.utpInstituteID || "",
              "UTP Institute": studentDetails.utpInstituteName || "",
              "Mode of Class": studentDetails.utpClassMode || "",
              "Qarz-e-hasna Form Status": studentDetails.utpQarzehasnaStatus || "",
              "UTP Status": studentDetails.utpStatus || "",
              "UTP Comment": studentDetails.utpComment || "",
            }
          : {}),
      };

      if (Array.isArray(studentDocs)) {
        const docMap = {};
        studentDocs.forEach((doc) => {
          const title = (doc?.docTitle || doc?.title || "").trim();
          if (title) {
            if (docMap[title]) {
              if (doc.url && !docMap[title].includes(doc.url)) {
                docMap[title] += `, ${doc.url}`;
              }
            } else {
              docMap[title] = doc.url || "";
            }
          }
        });
        (docTitles || []).forEach((title) => {
          row[title] = docMap[title] || "";
        });
      } else if (studentDocs && typeof studentDocs === "object") {
        (docTitles || []).forEach((title) => {
          row[title] = studentDocs[title] || "";
        });
      } else {
        (docTitles || []).forEach((title) => {
          row[title] = "";
        });
      }

      return row;
    },

    writeTcfExportRowsToSheet(worksheet, headers, dataRows) {
      const sheetRange = XLSX.utils.decode_range(worksheet["!ref"] || "A1");
      for (let r = 1; r <= sheetRange.e.r; r += 1) {
        for (let c = 0; c < headers.length; c += 1) {
          delete worksheet[XLSX.utils.encode_cell({ r, c })];
        }
      }

      dataRows.forEach((rowData, rowIdx) => {
        const r = rowIdx + 1;
        headers.forEach((header, c) => {
          const value = rowData[header];
          if (value === null || value === undefined || value === "") return;
          worksheet[XLSX.utils.encode_cell({ r, c })] = {
            t: "s",
            v: String(value),
          };
        });
      });

      const lastRow = Math.max(0, dataRows.length);
      worksheet["!ref"] = XLSX.utils.encode_range({
        s: { r: 0, c: 0 },
        e: { r: lastRow, c: headers.length - 1 },
      });
    },

    buildTcfDetailsMap(details = []) {
      const map = {};
      details.forEach((detail) => {
        const id = detail?.sID ?? detail?.id;
        if (id != null && id !== "") {
          map[id] = detail;
        }
      });
      return map;
    },

    buildTcfDocsMap(docs = []) {
      const map = {};
      (docs || []).forEach((item) => {
        const id = item?.localID ?? item?.sID ?? item?.id ?? item?.studentID;
        if (id != null && id !== "") {
          if (!map[id]) {
            map[id] = {};
          }
          const docList = Array.isArray(item?.documents)
            ? item.documents
            : Array.isArray(item?.docs)
            ? item.docs
            : [];
          docList.forEach((doc) => {
            const title = (doc?.docTitle || doc?.title || "").trim();
            if (title) {
              if (map[id][title]) {
                if (doc.url && !map[id][title].includes(doc.url)) {
                  map[id][title] += `, ${doc.url}`;
                }
              } else {
                map[id][title] = doc.url || "";
              }
            }
          });
        }
      });
      return map;
    },

    normalizeTcfExportEntry(item) {
      if (item?.student) {
        return {
          student: item.student,
          studentDetails: item.studentDetails || {},
        };
      }
      return {
        student: item || {},
        studentDetails: null,
      };
    },

    unwrapTcfPageResponse(res) {
      if (!res) return { rows: [], stdDetails: [], allDocs: [] };
      if (Array.isArray(res)) return { rows: res, stdDetails: [], allDocs: [] };
      if (Array.isArray(res.data)) {
        return {
          rows: res.data,
          stdDetails: Array.isArray(res.stdDetails) ? res.stdDetails : [],
          allDocs: Array.isArray(res.allDocs)
            ? res.allDocs
            : Array.isArray(res.docs)
            ? res.docs
            : [],
        };
      }
      if (res.data && Array.isArray(res.data.data)) {
        return {
          rows: res.data.data,
          stdDetails: Array.isArray(res.data.stdDetails)
            ? res.data.stdDetails
            : Array.isArray(res.stdDetails)
            ? res.stdDetails
            : [],
          allDocs: Array.isArray(res.data.allDocs)
            ? res.data.allDocs
            : Array.isArray(res.data.docs)
            ? res.data.docs
            : Array.isArray(res.allDocs)
            ? res.allDocs
            : Array.isArray(res.docs)
            ? res.docs
            : [],
        };
      }
      return { rows: [], stdDetails: [], allDocs: [] };
    },

    async fetchAllStudentsForTcfExport() {
      const pageSize = 50;
      let students = [];
      let details = [];
      let docs = [];

      if (this.bySearch) {
        this.items.forEach((item) => {
          const entry = this.normalizeTcfExportEntry(item);
          students.push(entry.student);
          if (entry.studentDetails) {
            details.push(entry.studentDetails);
          }
        });
        details = [...details, ...(this.stdDetails || [])];
        docs = [...(this.allDocs || [])];
        return { students, details, docs };
      }

      if (this.byFilter) {
        const count =
          this.total < pageSize ? 1 : Math.ceil(this.total / pageSize);
        for (let i = 1; i <= count; i++) {
          const result = await this.get({
            url:
              this.$store.state.domain +
              "students/Filterdata?cls=" +
              this.filter.cls +
              "&sec=" +
              this.filter.sec +
              "&status=" +
              this.filter.status +
              "&db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.filter.campusID +
              "&page=" +
              i,
            token: this.$store.state.userData.token,
          });
          const {
            rows: pageRows,
            stdDetails: pageDetails,
            allDocs: pageDocs,
          } = this.unwrapTcfPageResponse(result);
          pageRows.forEach((item) => {
            const entry = this.normalizeTcfExportEntry(item);
            students.push(entry.student);
            if (entry.studentDetails) {
              details.push(entry.studentDetails);
            }
          });
          if (Array.isArray(pageDetails) && pageDetails.length) {
            details = [...details, ...pageDetails];
          }
          if (Array.isArray(pageDocs) && pageDocs.length) {
            docs = [...docs, ...pageDocs];
          }
        }
        return { students, details, docs };
      }

      const count =
        this.total < pageSize ? 1 : Math.ceil(this.total / pageSize);
      const paramStr = this.sessionID ? "&sessionID=" + this.sessionID : "";

      for (let i = 1; i <= count; i++) {
        const res = await this.get({
          url:
            this.$store.state.domain +
            "Students/LoadDataPagination?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&clsID=0&section=0&page=" +
            i +
            "&status=" +
            this.currentStatus +
            paramStr,
          token: this.$store.state.userData.token,
        });

        const {
          rows: pageRows,
          stdDetails: pageDetails,
          allDocs: pageDocs,
        } = this.unwrapTcfPageResponse(res);
        pageRows.forEach((item) => {
          const entry = this.normalizeTcfExportEntry(item);
          students.push(entry.student);
          if (entry.studentDetails) {
            details.push(entry.studentDetails);
          }
        });
        if (Array.isArray(pageDetails) && pageDetails.length) {
          details = [...details, ...pageDetails];
        }
        if (Array.isArray(pageDocs) && pageDocs.length) {
          docs = [...docs, ...pageDocs];
        }
      }

      return { students, details, docs };
    },

    async exportTcfBulkExcel() {
      this.exporting = true;
      try {
        const { students, details, docs } =
          await this.fetchAllStudentsForTcfExport();
        const detailsMap = this.buildTcfDetailsMap(details);
        const docsMap = this.buildTcfDocsMap(docs);

        if (!students.length) {
          this.$bvToast.toast(this.$t("No records to export"), {
            title: this.$t("Export"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          });
          return;
        }

        const docTitles = [];
        const docTitleSet = new Set();
        (docs || []).forEach((item) => {
          const docList = Array.isArray(item?.documents)
            ? item.documents
            : Array.isArray(item?.docs)
            ? item.docs
            : [];
          docList.forEach((doc) => {
            const title = (doc?.docTitle || doc?.title || "").trim();
            if (title && !docTitleSet.has(title)) {
              docTitleSet.add(title);
              docTitles.push(title);
            }
          });
        });

        const expData = students.map((student) => {
          const studentId = student.id ?? student.sID;
          const studentDetails =
            detailsMap[studentId] ||
            (studentId != null ? detailsMap[String(studentId)] : {}) ||
            {};
          const studentDocs =
            docsMap[studentId] ||
            (studentId != null ? docsMap[String(studentId)] : {}) ||
            {};
          return this.mapTcfBulkExportRow(
            student,
            studentDetails,
            studentDocs,
            docTitles
          );
        });

        // const baseUrl = process.env.BASE_URL || "/";
        // const templateRes = await fetch(`${baseUrl}student-sample.xlsx`);
        // if (!templateRes.ok) {
        //   throw new Error("Could not load student sample template");
        // }

        // const workbook = XLSX.read(await templateRes.arrayBuffer(), {
        //   type: "array",
        // });
        // const sheetName = workbook.SheetNames[0];
        // const worksheet = workbook.Sheets[sheetName];
        // const templateHeaders =
        //   XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "" })[0] ||
        //   [];
        // const headers =
        //   templateHeaders.length >= TCF_BULK_SAMPLE_HEADERS.length
        //     ? templateHeaders
        //     : TCF_BULK_SAMPLE_HEADERS;

        const worksheet = XLSX.utils.json_to_sheet(expData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          "Student Form Fields"
        );

        const stamp = new Date().toISOString().slice(0, 10);
        XLSX.writeFile(workbook, `students-${stamp}.xlsx`);
      } catch (error) {
        console.error("exportTcfBulkExcel", error);
        this.$bvToast.toast(this.$t("Could not export students."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.exporting = false;
      }
    },

    resolveSiblingClassLabel(sib) {
      if (!sib) return "";
      if (sib.meta_class) return sib.meta_class;
      if (sib.className) {
        return sib.sectionName
          ? `${sib.className} - ${sib.sectionName}`
          : sib.className;
      }

      let className = "";
      let sectionName = "";
      const clsWrap = (this.classes || []).find(
        (c) => c.cls && c.cls.id == sib.class_current
      );
      if (clsWrap) {
        className = clsWrap.cls.name || "";
        const sec = (clsWrap.sections || []).find(
          (s) => s.id == sib.section_current
        );
        sectionName = sec ? sec.section || sec.name || "" : "";
      } else {
        const opt = (this.classesOptions || []).find(
          (el) => el.id == sib.class_current
        );
        className = opt ? opt.name : "";
      }

      if (className && sectionName) return `${className} - ${sectionName}`;
      return className || sectionName || "";
    },

    getStudentSiblings(item, siblingsList = []) {
      const studentId = item?.id;
      if (studentId == null) return [];

      if (Array.isArray(item.siblings) && item.siblings.length) {
        return item.siblings;
      }

      return (siblingsList || []).filter(
        (sib) => String(sib.studentId) === String(studentId)
      );
    },

    async exportNew() {
      let toShow = this.exportSchema.filter((el) => el.status == true);
      // console.log(toShow);

      if (toShow.length > 0) {
        this.exporting = true;

        const includeSiblings = toShow.some(
          (el) => el.value === "siblings" || el.text === "siblings"
        );
        const fieldCols = toShow.filter(
          (el) => el.value !== "siblings" && el.text !== "siblings"
        );
        const siblingQuery = includeSiblings
          ? "&isSibling=true"
          : "&isSibling=false";

        const pageSize =
          this.reportDomain == "myskoolhpgs" &&
          this.$store.state.userData.cId == 1 &&
          !this.byFilter
            ? 500
            : 50;
        const exportVal = pageSize == 500;

        const count =
          this.total < pageSize ? 1 : Math.ceil(this.total / pageSize);
        let arr = [];
        let siblingsList = [];

        if (this.bySearch) {
          arr = [...this.items];
        } else if (this.byFilter) {
          for (let i = 1; i <= count; i++) {
            let result = await this.get({
              url:
                this.$store.state.domain +
                "students/Filterdata?cls=" +
                this.filter.cls +
                "&sec=" +
                this.filter.sec +
                "&status=" +
                this.filter.status +
                "&db=" +
                this.$store.state.userData.db +
                "&cID=" +
                this.filter.campusID +
                "&page=" +
                i +
                siblingQuery,
              token: this.$store.state.userData.token,
            });
            const pageRows = Array.isArray(result?.data)
              ? result.data
              : Array.isArray(result)
              ? result
              : [];
            arr = [...arr, ...pageRows];

            const pageSiblings = Array.isArray(result?.siblings)
              ? result.siblings
              : Array.isArray(result?.data?.siblings)
              ? result.data.siblings
              : [];
            if (pageSiblings.length) {
              siblingsList = [...siblingsList, ...pageSiblings];
            }
          }
        } else {
          const paramStr = this.sessionID ? "&sessionID=" + this.sessionID : "";
          for (let i = 1; i <= count; i++) {
            let res = await this.get({
              url:
                this.$store.state.domain +
                "Students/LoadDataPagination?db=" +
                this.$store.state.userData.db +
                "&cID=" +
                this.$store.state.userData.cId +
                "&clsID=0&section=0&page=" +
                i +
                "&status=" +
                this.currentStatus +
                "&isExport=" +
                exportVal +
                paramStr,
              token: this.$store.state.userData.token,
            });
            arr = [...arr, ...res.data];
          }
        }
        // console.log(arr);
        const expData = arr.map((item) => {
          let fd = {};
          fieldCols.forEach((elem) => {
            let d;
            if (elem.text == "class_admitted") {
              let obj = this.classesOptions.find(
                (el) => el.id == item[elem.value]
              );
              d = { [elem.text]: obj ? obj.name : "" };
            } else if (
              [
                "date_of_birth",
                "date_of_admission",
                "date_of_leaving",
              ].includes(elem.text)
            ) {
              // removing T00:00:00 from dates
              d = {
                [elem.text]: item[elem.value]
                  ? this.formatDate(item[elem.value].split("T")[0])
                  : item[elem.value],
              };
            } else if (
              ["admitted campues", "current campues", "campus"].includes(
                elem.text
              )
            ) {
              let cname = this.getCampus(item[elem.value]);
              d = { [elem.text]: cname };
            } else {
              d = { [elem.text]: item[elem.value] };
            }
            Object.assign(fd, d);
          });

          if (includeSiblings) {
            const matched = this.getStudentSiblings(item, siblingsList);
            fd.Siblings = matched
              .map((sib) => sib.name || "")
              .filter(Boolean)
              .join(", ");
            fd["Siblings Class"] = matched
              .map((sib) => this.resolveSiblingClassLabel(sib))
              .filter(Boolean)
              .join(", ");
          }

          return fd;
        });
        // console.log(expData);

        if (!fieldCols.length && !includeSiblings) {
          this.$bvToast.toast(this.$t("Please select the field to export"), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
          this.exporting = false;
          return;
        }

        const columnOrder = [
          ...fieldCols.map((e) => e.text),
          ...(includeSiblings ? ["Siblings", "Siblings Class"] : []),
        ];
        const stamp = new Date().toISOString().slice(0, 10);
        const worksheet = buildFormattedWorksheet(expData, {
          columnOrder,
          columnLabels: STUDENT_EXPORT_HEADER_LABELS,
          title: this.$t("Students"),
          subtitle: `${this.$t("Exported")} ${stamp}`,
        });
        await writeWorkbookToFile(
          worksheet,
          `students-${stamp}.xlsx`,
          "Students"
        );
        this.exporting = false;
      } else {
        this.$bvToast.toast(this.$t("Please select the field to export"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },

    async exportData() {
      this.exporting = true;

      const count = this.total < 50 ? 1 : Math.ceil(this.total / 50);
      let arr = [];

      if (this.byFilter) {
        for (let i = 1; i <= count; i++) {
          let result = await this.get({
            url:
              this.$store.state.domain +
              "students/Filterdata?cls=" +
              this.filter.cls +
              "&sec=" +
              this.filter.sec +
              "&status=" +
              this.filter.status +
              "&db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.filter.campusID +
              "&page=" +
              i,
            token: this.$store.state.userData.token,
          });
          arr = [...arr, ...result.data];
        }
      } else {
        for (let i = 1; i <= count; i++) {
          let res = await this.get({
            url:
              this.$store.state.domain +
              "Students/LoadDataPagination?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId +
              "&clsID=0&section=0&page=" +
              i +
              "&status=" +
              this.currentStatus,
            token: this.$store.state.userData.token,
          });
          arr = [...arr, ...res.data];
        }
      }
      // console.log(arr);
      const expData = arr.map((item) => ({
        gr: item.grNo,
        family_code: item.family_code,
        name: item.name,
        father: item.father_name,
        surname: item.surname,
        gender: item.gender,
        contact: item.contact_father,
        contact_mother: item.contact_mother,
        contact_student: item.contact_student,
        current_address: item.address_current,
        class: item.meta_class,
        fees: item.monthly_fee,
        status: item.status,
        house: item.house,
        rfID: item.rfid_number,
      }));

      const stamp = new Date().toISOString().slice(0, 10);
      const worksheet = buildFormattedWorksheet(expData, {
        columns: STUDENT_QUICK_EXPORT_COLUMNS,
        title: this.$t("Students"),
        subtitle: `${this.$t("Exported")} ${stamp}`,
      });
      await writeWorkbookToFile(
        worksheet,
        `students-${stamp}.xlsx`,
        "Students"
      );

      this.exporting = false;
    },

    resolveImportId(value) {
      if (value === null || value === undefined || value === "") {
        return 0;
      }
      const num = Number(value);
      return Number.isFinite(num) ? num : 0;
    },
    normalizeImportRows(rows) {
      return (rows || []).map((row) => ({
        ...row,
        id: this.resolveImportId(row.id),
      }));
    },

    async Import() {
      this.stdImporting = true;
      const schema = {
        id: {
          prop: "id",
          type: Number,
        },
        grNo: {
          prop: "grNo",
          type: String,
        },
        family_code: {
          prop: "family_code",
          type: Number,
        },
        name: {
          prop: "name",
          type: String,
        },
        father_name: {
          prop: "father_name",
          type: String,
        },
        gender: {
          prop: "gender",
          type: String,
        },
        picture: {
          prop: "picture",
          type: String,
        },
        date_of_birth: {
          prop: "date_of_birth",
          type: Date,
        },
        date_of_birth_words: {
          prop: "date_of_birth_words",
          type: String,
        },
        blood_group: {
          prop: "blood_group",
          type: String,
        },
        nationality: {
          prop: "nationality",
          type: String,
        },
        religion: {
          prop: "religion",
          type: String,
        },
        place_of_birth: {
          prop: "place_of_birth",
          type: String,
        },
        mother_tongue: {
          prop: "mother_tongue",
          type: String,
        },
        address_current: {
          prop: "address_current",
          type: String,
        },
        address_permanent: {
          prop: "address_permanent",
          type: String,
        },
        contact_student: {
          prop: "contact_student",
          type: String,
        },
        contact_father: {
          prop: "contact_father",
          type: String,
        },
        contact_mother: {
          prop: "contact_mother",
          type: String,
        },
        contact_home: {
          prop: "contact_home",
          type: String,
        },
        contact_tutor: {
          prop: "contact_tutor",
          type: String,
        },
        last_institute: {
          prop: "last_institute",
          type: String,
        },
        last_class: {
          prop: "last_class",
          type: String,
        },
        last_session: {
          prop: "last_session",
          type: String,
        },
        last_result: {
          prop: "last_result",
          type: String,
        },
        last_note: {
          prop: "last_note",
          type: String,
        },
        class_admitted: {
          prop: "class_admitted",
          type: String,
        },
        class_current: {
          prop: "class_current",
          type: String,
        },
        section_admitted: {
          prop: "section_admitted",
          type: String,
        },
        section_current: {
          prop: "section_current",
          type: String,
        },
        rollNumber: {
          prop: "rollNumber",
          type: Number,
        },
        house: {
          prop: "house",
          type: String,
        },
        rfid_number: {
          prop: "rfid_number",
          type: String,
        },
        bform_number: {
          prop: "bform_number",
          type: String,
        },
        date_of_registration: {
          prop: "date_of_registration",
          type: Date,
        },
        date_of_readmission: {
          prop: "date_of_readmission",
          type: Date,
        },
        father_cnic: {
          prop: "father_cnic",
          type: String,
        },
        father_education: {
          prop: "father_education",
          type: String,
        },
        father_occupation: {
          prop: "father_occupation",
          type: String,
        },
        monthly_income: {
          prop: "monthly_income",
          type: String,
        },
        office_phone: {
          prop: "office_phone",
          type: String,
        },
        office_address: {
          prop: "office_address",
          type: String,
        },
        father_email: {
          prop: "father_email",
          type: String,
        },
        father_employer: {
          prop: "father_employer",
          type: String,
        },
        mother_name: {
          prop: "mother_name",
          type: String,
        },
        mother_cnic: {
          prop: "mother_cnic",
          type: String,
        },
        mother_education: {
          prop: "mother_education",
          type: String,
        },
        mother_occupation: {
          prop: "mother_occupation",
          type: String,
        },
        mother_office_phone: {
          prop: "mother_office_phone",
          type: String,
        },
        mother_office_address: {
          prop: "mother_office_address",
          type: String,
        },
        mother_email: {
          prop: "mother_email",
          type: String,
        },
        mother_employer: {
          prop: "mother_employer",
          type: String,
        },
        guardian_name: {
          prop: "guardian_name",
          type: String,
        },
        guardian_cnic: {
          prop: "guardian_cnic",
          type: String,
        },
        guardian_education: {
          prop: "guardian_education",
          type: String,
        },
        guardian_occupation: {
          prop: "guardian_occupation",
          type: String,
        },
        guardian_office_phone: {
          prop: "guardian_office_phone",
          type: String,
        },
        guardian_office_address: {
          prop: "guardian_office_address",
          type: String,
        },
        guardian_email: {
          prop: "guardian_email",
          type: String,
        },
        guardian_employer: {
          prop: "guardian_employer",
          type: String,
        },
        guardian_relationship: {
          prop: "guardian_relationship",
          type: String,
        },
        emergency_name: {
          prop: "emergency_name",
          type: String,
        },
        emergency_contact: {
          prop: "emergency_contact",
          type: String,
        },
        emergency_relationship: {
          prop: "emergency_relationship",
          type: String,
        },
        physical_handicap: {
          prop: "physical_handicap",
          type: String,
        },
        allergies: {
          prop: "allergies",
          type: String,
        },
        remarks: {
          prop: "remarks",
          type: String,
        },
        monthly_fee: {
          prop: "monthly_fee",
          type: Number,
        },
        discount_percentage: {
          prop: "discount_percentage",
          type: Number,
        },
        challan_due_date: {
          prop: "challan_due_date",
          type: Date,
        },
        campusID: {
          prop: "campusID",
          type: Number,
        },
        session: {
          prop: "session",
          type: String,
        },
        status: {
          prop: "status",
          type: String,
        },
        docs: {
          prop: "docs",
          type: String,
        },
        date_of_admission: {
          prop: "date_of_admission",
          type: Date,
        },
        date_of_leaving: {
          prop: "date_of_leaving",
          type: Date,
        },
        roll_number: {
          prop: "roll_number",
          type: Number,
        },
        classFee: {
          prop: "classFee",
          type: Number,
        },
        discount: {
          prop: "discount",
          type: Number,
        },
        discountNote: {
          prop: "discountNote",
          type: String,
        },
        surname: {
          prop: "surname",
          type: String,
        },
      };
      // console.log("import....");
      const input = document.getElementById("importFile");
      // console.log(input.files);
      await readXlsxFile(input.files[0], { schema })
        .then((rows) => {
          this.stdData = this.normalizeImportRows(rows.rows);
        })
        .catch((err) => {
          console.log(err);
          this.stdImporting = false;
        });
      // console.log(this.stdData);
      const chunkSize = 10000;
      let chunkLength = 0;

      for (let i = 0; i < this.stdData.length; i += chunkSize) {
        const chunk = this.stdData.slice(i, i + chunkSize);
        chunkLength += chunk.length;

        // console.log(chunk);
        var status = this.post({
          url:
            this.$store.state.domain +
            "Students/SaveAll?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: chunk,
          message: "Students data imported.",
          importing: true,
          lastChunk: chunkLength == this.stdData.length,
          context: this,
          token: this.$store.state.userData.token,
        });

        if (!status) this.stdImporting = false;
        else if (chunkLength == this.stdData.length) this.stdImporting = false;
      }

      // input.addEventListener("change", () => {

      // });
    },
    async ImportFee() {
      this.feeImporting = true;
      const schema = {
        id: {
          prop: "id",
          type: Number,
        },
        sID: {
          prop: "sID",
          type: Number,
        },
        billID: {
          prop: "billID",
          type: Number,
        },
        classID: {
          prop: "classID",
          type: String,
        },
        secID: {
          prop: "secID",
          type: String,
        },
        month: {
          prop: "month",
          type: String,
        },
        year: {
          prop: "year",
          type: Number,
        },
        generatedOn: {
          prop: "generatedOn",
          type: Date,
        },
        feesType: {
          prop: "feesType",
          type: String,
        },
        actualFee: {
          prop: "actualFee",
          type: Number,
        },
        discount: {
          prop: "discount",
          type: Number,
        },
        netFee: {
          prop: "netFee",
          type: Number,
        },
        status: {
          prop: "status",
          type: String,
        },
        rcvd: {
          prop: "rcvd",
          type: Number,
        },
        balance: {
          prop: "balance",
          type: Number,
        },
        rcvdDate: {
          prop: "rcvdDate",
          type: Date,
        },
        createdBy: {
          prop: "createdBy",
          type: Number,
        },
        modificationTime: {
          prop: "modificationTime",
          type: Date,
        },
        barcode: {
          prop: "barcode",
          type: Number,
        },
        monthYear: {
          prop: "monthYear",
          type: String,
        },
        accountID: {
          prop: "accountID",
          type: Number,
        },
        isDeleted: {
          prop: "isDeleted",
          type: Boolean,
        },
        deletedOn: {
          prop: "deletedOn",
          type: Date,
        },
        deletedBy: {
          prop: "deletedBy",
          type: Number,
        },
        timelyDiscount: {
          prop: "timelyDiscount",
          type: Number,
        },
        lateFee: {
          prop: "lateFee",
          type: Number,
        },
        campusID: {
          prop: "campusID",
          type: Number,
        },
        monthVal: {
          prop: "monthVal",
          type: String,
        },
        rcvdBy: {
          prop: "rcvdBy",
          type: Number,
        },
      };
      // console.log("import fee....");
      const input = document.getElementById("importFee");
      // console.log(input.files);
      await readXlsxFile(input.files[0], { schema })
        .then((rows) => {
          this.feeData = this.normalizeImportRows(rows.rows);
        })
        .catch((err) => {
          console.log(err);
          this.feeImporting = false;
        });
      // console.log(this.feeData);
      const chunkSize = 4000;
      let chunkLength = 0;

      for (let i = 0; i < this.feeData.length; i += chunkSize) {
        const chunk = this.feeData.slice(i, i + chunkSize);
        chunkLength += chunk.length;

        // console.log(chunk);
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Fees/SaveAll?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: chunk,
          message: "Fee data imported.",
          importing: true,
          lastChunk: chunkLength == this.feeData.length,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (!status) this.feeImporting = false;
        else if (chunkLength == this.feeData.length) this.feeImporting = false;
      }
      // input.addEventListener("change", () => {

      // });
    },

    // ---- Custom fee import (StudentsCustomFee/Import) ----
    formatCustomFeeMoney(val) {
      const n = Number(val);
      if (Number.isNaN(n)) return val ?? "";
      return n.toLocaleString();
    },

    async openCustomFeeImportModal() {
      this.visibility2 = false;
      this.resetCustomFeeImportModal();
      this.showCustomFeeImportModal = true;
      this.$nextTick(() => this.scrollCustomFeeModalToTop());
      await this.loadImportFeeTypes();
    },

    scrollCustomFeeModalToTop() {
      const modalBody = document.querySelector(
        "#modal-import-custom-fee .modal-body"
      );
      if (modalBody) modalBody.scrollTop = 0;
    },

    resetCustomFeeImportModal() {
      this.customFeeStep = "form";
      this.customFeeObj = { feeTypeID: null };
      this.customFeeRows = [];
      this.customFeePreview = [];
      this.customFeeParseStats = { included: 0, excludedNoAmount: 0 };
      this.customFeeFile = null;
      this.customFeeParsing = false;
      this.customFeeSubmitting = false;
      this.customFeeResult = {};
      if (this.$refs.customFeeImportFile) {
        this.$refs.customFeeImportFile.value = "";
      }
    },

    async loadImportFeeTypes() {
      this.importFeeTypeLoading = true;
      try {
        // Same API the student custom-fee section uses.
        const res = await this.get({
          url:
            this.$store.state.domain +
            "FeeType/LoadAll?db=" +
            this.$store.state.userData.db +
            "&cId=" +
            this.$store.state.userData.cId,
          token: this.$store.state.userData.token,
        });
        const list = Array.isArray(res)
          ? res
          : res && Array.isArray(res.data)
          ? res.data
          : [];
        this.importFeeTypeOptions = list
          .filter(
            (ft) =>
              ft &&
              Number(ft.id) > 0 &&
              String(ft.recurrence || "").toLowerCase() !== "default"
          )
          .map((ft) => ({
            ...ft,
            id: Number(ft.id),
            feeType: ft.feeType || ft.title || `Fee ${ft.id}`,
          }));
        if (!this.importFeeTypeOptions.length) {
          this.$bvToast.toast(
            this.$t("No custom fee types found for this campus."),
            {
              title: this.$t("Warning"),
              variant: "warning",
              toaster: "b-toaster-top-center",
            }
          );
        }
      } catch (error) {
        console.error("Error loading import fee types:", error);
        this.importFeeTypeOptions = [];
      } finally {
        this.importFeeTypeLoading = false;
      }
    },

    async exportCustomFeeTemplate() {
      const selectedIds = this.stdIDs || [];
      let rows = Array.isArray(this.items) ? [...this.items] : [];
      if (selectedIds.length) {
        rows = rows.filter((s) => selectedIds.includes(s.id));
      }
      if (!rows.length) {
        this.$bvToast.toast(this.$t("No students found to export"), {
          title: this.$t("Warning"),
          variant: "warning",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      this.customFeeExporting = true;
      try {
        const expData = rows.map((student) => ({
          sID: student.id,
          name: student.name || "",
          amount: "",
        }));
        const stamp = new Date().toISOString().slice(0, 10);
        const feeTypeName = this.selectedImportFeeType
          ? this.selectedImportFeeType.feeType
          : "-";
        const worksheet = buildFormattedWorksheet(expData, {
          columns: CUSTOM_FEE_IMPORT_COLUMNS,
          title: this.$t("Custom Fee Import"),
          subtitle: `${this.$t("Fee Type")}: ${feeTypeName} · ${stamp}`,
        });
        await writeWorkbookToFile(
          worksheet,
          `custom-fee-import-${stamp}.xlsx`,
          "Custom Fee"
        );
      } catch (error) {
        console.error("Error exporting custom fee template:", error);
        this.$bvToast.toast(this.$t("Failed to export data"), {
          title: this.$t("Error"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.customFeeExporting = false;
      }
    },

    findCustomFeeImportHeaderRowIndex(rows) {
      if (!rows || !rows.length) return -1;
      const scanLimit = Math.min(rows.length, 15);
      for (let i = 0; i < scanLimit; i += 1) {
        const headers = (rows[i] || []).map((h) =>
          String(h ?? "")
            .toLowerCase()
            .trim()
        );
        const indexes = this.getCustomFeeImportColumnIndexes(headers);
        if (indexes.sID !== -1 && indexes.amount !== -1) {
          return i;
        }
      }
      return -1;
    },

    getCustomFeeImportColumnIndexes(headers) {
      const firstIndex = (...labels) => {
        for (const label of labels) {
          const idx = headers.findIndex((h) => h === label);
          if (idx !== -1) return idx;
        }
        return -1;
      };
      const sID =
        firstIndex("student id") !== -1
          ? firstIndex("student id")
          : firstIndex("sid", "s_id", "studentid", "student_id") !== -1
          ? firstIndex("sid", "s_id", "studentid", "student_id")
          : firstIndex("id");
      const name =
        firstIndex("student name") !== -1
          ? firstIndex("student name")
          : firstIndex("name");
      const amount =
        firstIndex("amount") !== -1
          ? firstIndex("amount")
          : headers.findIndex((h) => h.includes("amount"));
      return { sID, name, amount };
    },

    parseCustomFeeImportRow(row, indexes, rowNo) {
      const cell = (idx) =>
        idx >= 0 && row[idx] !== null && row[idx] !== undefined
          ? String(row[idx]).trim()
          : "";

      const sIDRaw = cell(indexes.sID);
      const sID = Number(sIDRaw);
      if (!sIDRaw || !Number.isFinite(sID) || sID <= 0) {
        return { kind: "skip" };
      }

      const amountCell = indexes.amount >= 0 ? row[indexes.amount] : "";
      const amountRaw =
        typeof amountCell === "number"
          ? String(amountCell)
          : String(amountCell ?? "").trim();

      if (!amountRaw) {
        return { kind: "excluded" };
      }

      const amount = Number(amountRaw.replace(/,/g, ""));
      if (!Number.isFinite(amount) || amount <= 0) {
        return { kind: "excluded" };
      }

      return {
        kind: "included",
        item: {
          row: rowNo,
          sID,
          name: cell(indexes.name),
          amount: Math.round(amount),
        },
      };
    },

    async onCustomFeeImportFileSelected(event) {
      const input = event.target;
      const file = input.files && input.files[0];
      if (!file) return;

      this.customFeeParsing = true;
      this.customFeeFile = file;
      this.customFeeRows = [];
      this.customFeePreview = [];
      this.customFeeParseStats = { included: 0, excludedNoAmount: 0 };

      try {
        await this.$nextTick();
        // Let the spinner paint before the (synchronous) XLSX parse starts.
        await new Promise((resolve) => setTimeout(resolve, 0));
        const rows = await readXlsxFile(file);

        if (!rows || rows.length < 2) {
          this.$bvToast.toast(
            this.$t("File must have a header row and at least one data row"),
            {
              title: this.$t("Invalid file"),
              variant: "warning",
              toaster: "b-toaster-top-center",
            }
          );
          return;
        }

        const headerRowIndex = this.findCustomFeeImportHeaderRowIndex(rows);
        if (headerRowIndex === -1) {
          this.$bvToast.toast(
            this.$t('Columns "Student ID" and "Amount" are required'),
            {
              title: this.$t("Invalid format"),
              variant: "warning",
              toaster: "b-toaster-top-center",
            }
          );
          return;
        }

        const headers = (rows[headerRowIndex] || []).map((h) =>
          String(h ?? "")
            .toLowerCase()
            .trim()
        );
        const indexes = this.getCustomFeeImportColumnIndexes(headers);

        const parsed = [];
        let excludedNoAmount = 0;
        for (let i = headerRowIndex + 1; i < rows.length; i += 1) {
          const result = this.parseCustomFeeImportRow(
            rows[i],
            indexes,
            i + 1
          );
          if (!result || result.kind === "skip") continue;
          if (result.kind === "excluded") {
            excludedNoAmount += 1;
            continue;
          }
          if (result.kind === "included" && result.item) {
            parsed.push(result.item);
          }
        }

        this.customFeeRows = parsed;
        this.customFeePreview = parsed.slice(0, 50);
        this.customFeeParseStats = {
          included: parsed.length,
          excludedNoAmount,
        };

        if (!parsed.length) {
          const msg = excludedNoAmount
            ? `${this.$t("No rows with amount to import")}. ${excludedNoAmount} ${this.$t(
                "excluded (no amount entered)"
              )}.`
            : this.$t("No valid rows found in file");
          this.$bvToast.toast(msg, {
            title: this.$t("Warning"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          });
        }
      } catch (error) {
        console.error("Error reading custom fee file:", error);
        this.$bvToast.toast(this.$t("Failed to read file"), {
          title: this.$t("Error"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        this.customFeeRows = [];
        this.customFeePreview = [];
        this.customFeeParseStats = { included: 0, excludedNoAmount: 0 };
      } finally {
        this.customFeeParsing = false;
        if (input) input.value = "";
      }
    },

    async submitImportCustomFee() {
      const feeTypeID = Number(this.customFeeObj.feeTypeID);
      if (!feeTypeID) {
        this.$bvToast.toast(this.$t("Please select a fee type."), {
          title: this.$t("Validation"),
          variant: "warning",
          toaster: "b-toaster-top-center",
        });
        return;
      }
      if (!this.customFeeRows.length) {
        this.$bvToast.toast(
          this.$t("Import a file with at least one valid row"),
          {
            title: this.$t("Validation"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          }
        );
        return;
      }

      this.customFeeSubmitting = true;
      try {
        const rows = this.customFeeRows.map((r) => ({
          sID: r.sID,
          feeTypeID,
          amount: r.amount,
          row: r.row,
        }));
        const userID =
          this.$store.state.userData.userID ||
          this.$store.state.userData.localID ||
          0;
        const url =
          this.$store.state.domain +
          "StudentsCustomFee/Import?db=" +
          encodeURIComponent(this.$store.state.userData.db) +
          "&cID=" +
          this.$store.state.userData.cId +
          "&userID=" +
          userID;

        const res = await this.post({
          url,
          body: rows,
          token: this.$store.state.userData.token,
          context: this,
          allResponse: true,
        });

        const isSuccess =
          res &&
          typeof res === "object" &&
          (String(res.status || "").toLowerCase() === "success" ||
            res.savedCount !== undefined ||
            res.createdCount !== undefined);

        if (isSuccess) {
          this.customFeeResult = res;
          this.customFeeStep = "summary";
          this.$nextTick(() => this.scrollCustomFeeModalToTop());
          this.$bvToast.toast(
            `${this.$t("Saved")} ${res.savedCount || 0}, ${this.$t(
              "Skipped"
            )} ${res.skippedCount || 0}`,
            {
              title: this.$t("Success"),
              variant: "success",
              toaster: "b-toaster-top-center",
            }
          );
        } else if (res && typeof res === "object" && res.message) {
          this.$bvToast.toast(res.message, {
            title: this.$t("Error"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        }
      } catch (error) {
        console.error("Error importing custom fees:", error);
        this.$bvToast.toast(this.$t("Import failed."), {
          title: this.$t("Error"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.customFeeSubmitting = false;
      }
    },

    // ---- Bulk driver link import (StudentDriver/Import) ----
    async openBulkDriverLinkModal() {
      this.visibility2 = false;
      this.resetBulkDriverLinkModal();
      this.showBulkDriverLinkModal = true;
      await this.loadDriverLinkOptions();
    },

    resetBulkDriverLinkModal() {
      this.driverLinkStep = "form";
      this.driverLinkObj = { driverID: null, vehicleID: null };
      this.driverLinkRows = [];
      this.driverLinkPreview = [];
      this.driverLinkParseStats = { included: 0, skipped: 0 };
      this.driverLinkFile = null;
      this.driverLinkParsing = false;
      this.driverLinkSubmitting = false;
      this.driverLinkResult = {};
      if (this.$refs.driverLinkImportFile) {
        this.$refs.driverLinkImportFile.value = "";
      }
    },

    formatDriverLinkVehicle(vehicle) {
      if (!vehicle) return "";
      const parts = [vehicle.brand, vehicle.model, vehicle.vehicleNo]
        .map((part) => (part === null || part === undefined ? "" : String(part).trim()))
        .filter(Boolean);
      return parts.length ? parts.join(" ") : `Vehicle #${vehicle.id ?? ""}`;
    },

    driverLinkVehicleLabel(vehicleID) {
      if (!vehicleID) return "-";
      const vehicle = (this.driverLinkVehicleOptions || []).find(
        (option) => Number(option.id) === Number(vehicleID)
      );
      return vehicle ? vehicle.name : `Vehicle #${vehicleID}`;
    },

    onDriverLinkDriverChange(driverID) {
      // A vehicle always belongs to a driver, so reset it and pick the
      // driver's first vehicle (same behaviour as the student driver section).
      this.driverLinkObj.vehicleID = null;
      const driver = (this.driverLinkOptions || []).find(
        (item) => Number(item.id) === Number(driverID)
      );
      const vehicles =
        driver && Array.isArray(driver.vehicles) ? driver.vehicles : [];
      if (vehicles.length) {
        this.driverLinkObj.vehicleID = Number(vehicles[0].id) || null;
      }
    },

    async loadDriverLinkOptions() {
      this.driverLinkOptionsLoading = true;
      try {
        const url =
          this.$store.state.domain +
          "Driver/LoadData?db=" +
          encodeURIComponent(this.$store.state.userData.db) +
          "&cID=" +
          this.$store.state.userData.cId;

        const response = await this.get({
          url,
          token: this.$store.state.userData.token,
          returnData: true,
        });

        let list = [];
        if (Array.isArray(response)) {
          list = response;
        } else if (response && Array.isArray(response.data)) {
          list = response.data;
        }

        this.driverLinkOptions = list
          .filter((row) => row && (row.driver || row.id))
          .map((row) => ({
            id: Number(row.driver?.id ?? row.id) || 0,
            name: row.driver?.name ?? row.name ?? "Driver",
            contact: row.driver?.contact ?? row.contact ?? "",
            vehicles: row.details || [],
          }))
          .filter((driver) => driver.id > 0);

        if (!this.driverLinkOptions.length) {
          this.$bvToast.toast(this.$t("No drivers found for this campus."), {
            title: this.$t("Warning"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          });
        }
      } catch (error) {
        console.error("Error loading drivers:", error);
        this.driverLinkOptions = [];
      } finally {
        this.driverLinkOptionsLoading = false;
      }
    },

    getDriverLinkStudents() {
      const selectedIds = this.stdIDs || [];
      let rows = Array.isArray(this.items) ? [...this.items] : [];
      if (selectedIds.length) {
        rows = rows.filter((student) => selectedIds.includes(student.id));
      }
      return rows;
    },

    async exportBulkDriverLinkTemplate() {
      const rows = this.getDriverLinkStudents();
      if (!rows.length) {
        this.$bvToast.toast(this.$t("No students found to export"), {
          title: this.$t("Warning"),
          variant: "warning",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      this.driverLinkExporting = true;
      try {
        const expData = rows.map((student) => ({
          sID: student.id,
          name: student.name || "",
        }));
        const stamp = new Date().toISOString().slice(0, 10);
        const driverName = this.selectedBulkDriver
          ? this.selectedBulkDriver.name
          : "-";
        const vehicleName = this.driverLinkObj.vehicleID
          ? this.driverLinkVehicleLabel(this.driverLinkObj.vehicleID)
          : "";
        const worksheet = buildFormattedWorksheet(expData, {
          columns: [
            { key: "sID", label: "Student ID" },
            { key: "name", label: "Student Name" },
          ],
          title: this.$t("Bulk Driver Link"),
          subtitle: [
            `${this.$t("Driver")}: ${driverName}`,
            vehicleName ? `${this.$t("Vehicle")}: ${vehicleName}` : "",
            stamp,
          ]
            .filter(Boolean)
            .join(" · "),
        });
        await writeWorkbookToFile(
          worksheet,
          `bulk-driver-link-${stamp}.xlsx`,
          "Driver Link"
        );
      } catch (error) {
        console.error("Error exporting driver link template:", error);
        this.$bvToast.toast(this.$t("Failed to export data"), {
          title: this.$t("Error"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.driverLinkExporting = false;
      }
    },

    getDriverLinkColumnIndexes(headers) {
      const find = (...labels) => {
        for (const label of labels) {
          const idx = headers.findIndex((h) => h === label);
          if (idx !== -1) return idx;
        }
        return -1;
      };
      return {
        sID: find("student id", "sid", "s_id", "studentid", "id"),
        name: find("student name", "name"),
      };
    },

    async onBulkDriverLinkFileSelected(event) {
      const input = event.target;
      const file = input.files && input.files[0];
      if (!file) return;

      this.driverLinkParsing = true;
      this.driverLinkFile = file;
      this.driverLinkRows = [];
      this.driverLinkPreview = [];
      this.driverLinkParseStats = { included: 0, skipped: 0 };

      try {
        await this.$nextTick();
        await new Promise((resolve) => setTimeout(resolve, 0));
        const rows = await readXlsxFile(file);

        if (!rows || rows.length < 2) {
          this.$bvToast.toast(
            this.$t("File must have a header row and at least one data row"),
            {
              title: this.$t("Invalid file"),
              variant: "warning",
              toaster: "b-toaster-top-center",
            }
          );
          return;
        }

        let headerRowIndex = -1;
        let indexes = { sID: -1, name: -1 };
        const scanLimit = Math.min(rows.length, 15);
        for (let i = 0; i < scanLimit; i += 1) {
          const headers = (rows[i] || []).map((h) =>
            String(h ?? "")
              .toLowerCase()
              .trim()
          );
          const candidate = this.getDriverLinkColumnIndexes(headers);
          if (candidate.sID !== -1) {
            headerRowIndex = i;
            indexes = candidate;
            break;
          }
        }

        if (headerRowIndex === -1) {
          this.$bvToast.toast(
            this.$t('Column "Student ID" is required'),
            {
              title: this.$t("Invalid format"),
              variant: "warning",
              toaster: "b-toaster-top-center",
            }
          );
          return;
        }

        const parsed = [];
        let skipped = 0;
        for (let i = headerRowIndex + 1; i < rows.length; i += 1) {
          const row = rows[i] || [];
          const sIDRaw =
            indexes.sID >= 0 && row[indexes.sID] != null
              ? String(row[indexes.sID]).trim()
              : "";
          const sID = Number(sIDRaw);
          if (!sIDRaw || !Number.isFinite(sID) || sID <= 0) {
            skipped += 1;
            continue;
          }
          parsed.push({
            row: i + 1,
            sID,
            name:
              indexes.name >= 0 && row[indexes.name] != null
                ? String(row[indexes.name]).trim()
                : "",
          });
        }

        this.driverLinkRows = parsed;
        this.driverLinkPreview = parsed.slice(0, 50);
        this.driverLinkParseStats = { included: parsed.length, skipped };

        if (!parsed.length) {
          this.$bvToast.toast(this.$t("No valid rows found in file"), {
            title: this.$t("Warning"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          });
        }
      } catch (error) {
        console.error("Error reading driver link file:", error);
        this.$bvToast.toast(this.$t("Failed to read file"), {
          title: this.$t("Error"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        this.driverLinkRows = [];
        this.driverLinkPreview = [];
        this.driverLinkParseStats = { included: 0, skipped: 0 };
      } finally {
        this.driverLinkParsing = false;
        if (input) input.value = "";
      }
    },

    async submitBulkDriverLink() {
      const driverID = Number(this.driverLinkObj.driverID);
      if (!driverID) {
        this.$bvToast.toast(this.$t("Please select a driver."), {
          title: this.$t("Validation"),
          variant: "warning",
          toaster: "b-toaster-top-center",
        });
        return;
      }
      if (!this.driverLinkRows.length) {
        this.$bvToast.toast(
          this.$t("Import a file with at least one valid row"),
          {
            title: this.$t("Validation"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          }
        );
        return;
      }

      this.driverLinkSubmitting = true;
      try {
        const vehicleID = Number(this.driverLinkObj.vehicleID) || 0;
        const rows = this.driverLinkRows.map((r) => ({
          sID: r.sID,
          driverID,
          ...(vehicleID ? { vehicleID } : {}),
          row: r.row,
        }));
        const userID =
          this.$store.state.userData.userID ||
          this.$store.state.userData.localID ||
          0;
        const url =
          this.$store.state.domain +
          "StudentDriver/Import?db=" +
          encodeURIComponent(this.$store.state.userData.db) +
          "&cID=" +
          this.$store.state.userData.cId +
          "&userID=" +
          userID;

        const res = await this.post({
          url,
          body: rows,
          token: this.$store.state.userData.token,
          context: this,
          allResponse: true,
        });

        const isSuccess =
          res &&
          typeof res === "object" &&
          (String(res.status || "").toLowerCase() === "success" ||
            res.savedCount !== undefined ||
            res.createdCount !== undefined);

        if (isSuccess) {
          this.driverLinkResult = res;
          this.driverLinkStep = "summary";
          this.$bvToast.toast(
            `${this.$t("Saved")} ${res.savedCount || 0}, ${this.$t(
              "Skipped"
            )} ${res.skippedCount || 0}`,
            {
              title: this.$t("Success"),
              variant: "success",
              toaster: "b-toaster-top-center",
            }
          );
        } else if (res && typeof res === "object" && res.message) {
          this.$bvToast.toast(res.message, {
            title: this.$t("Error"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        }
      } catch (error) {
        console.error("Error importing student driver links:", error);
        this.$bvToast.toast(this.$t("Import failed."), {
          title: this.$t("Error"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.driverLinkSubmitting = false;
      }
    },

    async ImportStaff() {
      this.staffImporting = true;
      const schema = {
        id: {
          prop: "id",
          type: Number,
        },
        rfID: {
          prop: "rfID",
          type: Number,
        },
        name: {
          prop: "name",
          type: String,
        },
        father_name: {
          prop: "father_name",
          type: String,
        },
        designation: {
          prop: "designation",
          type: String,
        },
        gender: {
          prop: "gender",
          type: String,
        },
        picture: {
          prop: "picture",
          type: String,
        },
        date_of_birth: {
          prop: "date_of_birth",
          type: Date,
        },
        address_current: {
          prop: "address_current",
          type: String,
        },
        address_permanent: {
          prop: "address_permanent",
          type: String,
        },
        contact_number: {
          prop: "contact_number",
          type: String,
        },
        emergency_contact_person: {
          prop: "emergency_contact_person",
          type: String,
        },
        emergency_contact_relation: {
          prop: "emergency_contact_relation",
          type: String,
        },
        emergency_number: {
          prop: "emergency_number",
          type: String,
        },
        qualification: {
          prop: "qualification",
          type: String,
        },
        experience: {
          prop: "experience",
          type: String,
        },
        campusID: {
          prop: "campusID",
          type: Number,
        },
        canPostNewsFeed: {
          prop: "canPostNewsFeed",
          type: Boolean,
        },
        totalPeriods: {
          prop: "totalPeriods",
          type: Number,
        },
        status: {
          prop: "status",
          type: String,
        },
        deviceID: {
          prop: "deviceID",
          type: String,
        },
        departmentID: {
          prop: "departmentID",
          type: Number,
        },
        availibility: {
          prop: "availibility",
          type: String,
        },
        documents: {
          prop: "documents",
          type: String,
        },
        expectedSalary: {
          prop: "expectedSalary",
          type: Number,
        },
        appointedOn: {
          prop: "appointedOn",
          type: Date,
        },
        basicSalary: {
          prop: "basicSalary",
          type: Number,
        },
        bonuses: {
          prop: "bonuses",
          type: Number,
        },
        totalSalary: {
          prop: "totalSalary",
          type: Number,
        },
        note: {
          prop: "note",
          type: String,
        },
        allowedLeaves: {
          prop: "allowedLeaves",
          type: Number,
        },
        joinsAt: {
          prop: "joinsAt",
          type: Date,
        },
        accountTitle: {
          prop: "accountTitle",
          type: String,
        },
        accountNumber: {
          prop: "accountNumber",
          type: String,
        },
        payMode: {
          prop: "payMode",
          type: String,
        },
      };
      // console.log("import staff....");
      const input = document.getElementById("importStaff");
      // console.log(input.files);
      await readXlsxFile(input.files[0], { schema })
        .then((rows) => {
          this.staffData = this.normalizeImportRows(rows.rows);
        })
        .catch((err) => {
          console.log(err);
          this.staffImporting = false;
        });
      // console.log(this.staffData);
      const chunkSize = 10000;
      let chunkLength = 0;

      for (let i = 0; i < this.staffData.length; i += chunkSize) {
        const chunk = this.staffData.slice(i, i + chunkSize);
        chunkLength += chunk.length;

        // console.log(chunk);
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Staff/SaveAll?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: chunk,
          message: "Staff data imported.",
          importing: true,
          lastChunk: chunkLength == this.staffData.length,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (!status) this.staffImporting = false;
        else if (chunkLength == this.staffData.length)
          this.staffImporting = false;
      }
    },
    move() {
      if (this.byFilter) this.Filter(this.currentPage);
      else this.LoadData();
    },
    async Filter(page) {
      // console.log("filterdata", this.filter);
      // if (this.CheckClassCurrent() == true) {
      // }
      this.dataLoading = true;
      try {
        this.$bvModal.hide("modal-login");
        this.$bvModal.hide("modal-reg");
        this.$bvModal.hide("modal-adm");
        let url =
          this.$store.state.domain +
          "students/Filterdata?cls=" +
          this.filter.cls +
          "&sec=" +
          this.filter.sec +
          "&status=" +
          this.filter.status +
          "&db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.filter.campusID +
          "&page=" +
          page +
          "&acceptedBy=" +
          this.acceptedBy;

        if (this.currentStatus == "registered") {
          // console.log(this.filterDate);
          if (this.filterDate) {
            if (this.regFilter.dateType == "admission") {
              url = url + `&testDate=${this.filterDate}&interviewDate=`;
            } else url = url + `&testDate=&interviewDate=${this.filterDate}`;
          } else url = url + `&testDate=&interviewDate=`;
        } else if (this.currentStatus == "admission") {
          let dtF = this.admFilter.dtFrom ? this.admFilter.dtFrom : "";
          let dtT = this.admFilter.dtTo ? this.admFilter.dtTo : "";

          url =
            this.$store.state.domain +
            "Students/LoadAdmissionKSA?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&clsID=0&section=0&page=" +
            page +
            "&status=present&filterDTFrom=" +
            dtF +
            "&filterDTTo=" +
            dtT;
        }
        let myitem = await this.get({
          url: url,
          token: this.$store.state.userData.token,
          returnData: true,
        });
        const parsed = this.applyStudentGridPayload(myitem);
        this.items = parsed.items;
        this.total = parsed.total;
        this.stdDetails = parsed.stdDetails;
        this.allDocs = parsed.allDocs;
        // console.log("items", this.items);

        this.byFilter = true;
        this.bySearch = false;
        let fData = {
          cls: this.filter.cls,
          sec: this.filter.sec,
          status: this.filter.status,
          dateType: this.regFilter.dateType,
          filterDate: this.filterDate,
          byFilter: this.byFilter,
          page: page,
          currentStatus: this.currentStatus,
          total: this.total,
          db: this.$store.state.userData.db,
          cID: this.$store.state.userData.cId,
          campusID: this.filter.campusID,
          acceptedBy: this.acceptedBy,
          bySearch: this.bySearch,
          searchQuery: this.searchQuery,
          searchType: this.searchType,
        };
        let ind = this.filterData.findIndex(
          (el) =>
            el.db == this.$store.state.userData.db &&
            el.cID == this.$store.state.userData.cId
        );
        if (ind != -1) {
          this.filterData[ind] = { ...fData };
        } else {
          this.filterData.push(fData);
        }
        this.$store.commit("setStdFilter", this.filterData);

        // console.log(this.filterData);
      } catch (error) {
        console.error("Filter", error);
        this.items = [];
        this.total = 0;
        this.stdDetails = [];
        this.allDocs = [];
        this.$bvToast.toast(this.$t("Failed to load students."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.dataLoading = false;
      }
    },
    openFilter() {
      if (this.currentStatus == "registered") {
        this.$bvModal.show("modal-reg");
        this.filter.status = "registered";
      } else if (this.currentStatus == "admission") {
        this.$bvModal.show("modal-adm");
      } else {
        this.$bvModal.show("modal-login");
        this.filter.status =
          this.currentStatus === "suspend" ||
          this.currentStatus === "left" ||
          this.currentStatus === "present"
            ? this.currentStatus
            : "present";
      }
    },
    CheckClassCurrent() {
      var elem = this.$refs["class_current"];
      if (this.filter.cls == 0) {
        return elem ? (elem.state = false) : false;
      } else {
        return elem ? (elem.state = true) : true;
      }
    },
    fillKentPrintSections(text) {
      this.kentPrintSections = [];
      if (text !== "filled") this.kentPrintSec = 0;
      if (this.kentPrintClass === 0) {
        this.kentPrintSections = [
          { section: "All " + this.allSectionLabel, id: 0 },
        ];
        return;
      }
      this.classes.forEach((elem) => {
        if (elem.cls.id === this.kentPrintClass) {
          if (elem.sections.length) {
            this.kentPrintSections = [...elem.sections];
            this.kentPrintSections.unshift({
              section: "All " + this.allSectionLabel,
              id: 0,
            });
          } else {
            this.kentPrintSections = [
              { section: "All " + this.allSectionLabel, id: 0 },
            ];
          }
        }
      });
    },
    FillSectionsCurrent(text) {
      // console.log(this.filter.cls);
      this.currentSections = [];
      if (text != "filled") this.filter.sec = 0;
      if (this.filter.cls == 0) {
        this.currentSections = [
          { section: "All " + this.allSectionLabel, id: 0 },
        ];
      } else {
        this.classes.forEach((elem) => {
          if (elem.cls.id === this.filter.cls) {
            if (elem.sections.length != 0) {
              this.currentSections = [...elem.sections];
              this.currentSections.unshift({
                section: "All " + this.allSectionLabel,
                id: 0,
              });
            } else {
              // console.log("null");
              this.currentSections = [
                { section: "All " + this.allSectionLabel, id: 0 },
              ];
            }
          }
        });
      }
      // console.log("Thisis", this.currentSections);
    },
    async LoadFilter(text) {
      if (text == "selected") {
        this.filter.cls = 0;
        this.filter.sec = 0;
      }
      this.filterloading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.filter.campusID +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      //  this.items =[];
      let myitem = await this.get(obj);
      this.classes = myitem;
      this.classesOptions = [];
      this.classes.forEach((el) => this.classesOptions.push(el.cls));
      // console.log(this.classesOptions);
      this.filterloading = false;
      if (this.filter.cls > 0) this.FillSectionsCurrent("filled");
    },

    OpenImport() {
      this.visibility2 = true;
    },
    Edit(id, readmit) {
      this.$router.push({
        name: "manage-student",
        params: {
          id,
          readmit,
        },
      });
    },
    AddOpen(text) {
      // console.log(text);
      this.$router.push({
        name: "manage-student",
        params: {
          selected: text,
          id: 0,
        },
      });
    },
    View(item) {
      // console.log(item);
      this.$router.push({
        name: "apps-users-view",
        params: {
          id: item.id,
          item,
        },
      });
    },
    CheckReason() {
      var elem = this.$refs["reason"];
      if (this.leaveObj.reason.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDate() {
      var elem = this.$refs["leave_date"];
      if (!this.leaveObj.date_of_leaving) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    hideSideBar() {
      this.visibility = false;
    },
    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "students/delete?id=" +
            id +
            "&db=" +
            this.$store.state.userData.db +
            "&userID=" +
            this.$store.state.userData.userID,
          message: "Student deleted successfully.",
          context: this,
          body: null,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData();
      }
      // Swal.fire({
      //   title: 'Are you sure?',
      //   text: this.$t("You won't be able to revert this!"),
      //   icon: 'warning',
      //   showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   confirmButtonText: 'Yes, Delete it!',
      // }).then(result => {
      //   if (result.isConfirmed) {

      //   }
      // });
    },

    resolveSuspendMode(item) {
      const mode = String(item?.suspend_mode || "").toLowerCase();
      if (mode === "full" || mode === "partial") {
        return mode;
      }
      const allSuspended =
        !!item?.suspend_for_attentance &&
        !!item?.suspend_for_homework &&
        !!item?.suspend_for_exams &&
        !!item?.suspend_for_messaging;
      return allSuspended ? "full" : "partial";
    },

    openSus(item) {
      this.susObj = {
        sID: item.id,
        suspend_till: item.suspend_till,
        suspend_reason: item.suspend_reason,
        suspend_mode: this.resolveSuspendMode(item),
        suspend_for_attentance: !!item.suspend_for_attentance,
        suspend_for_homework: !!item.suspend_for_homework,
        suspend_for_exams: !!item.suspend_for_exams,
        suspend_for_messaging: !!item.suspend_for_messaging,
      };
      this.sidebarTitle = `${item.name}<br/>Gr: ${item.grNo}`;
      this.currentSelected = "";
      this.visibility5 = true;
      var elem = this.$refs["sus_date"];
      elem.state = undefined;
      var elem = this.$refs["sus_reason"];
      elem.state = undefined;
      var elem = this.$refs["sus_for"];
      if (elem) elem.state = undefined;
    },
    onSuspendModeChange(mode) {
      if (mode === "full") {
        this.susObj.suspend_for_attentance = true;
        this.susObj.suspend_for_homework = true;
        this.susObj.suspend_for_exams = true;
        this.susObj.suspend_for_messaging = true;
      }
      this.CheckSusFor();
    },
    setTillDate(val) {
      this.currentSelected = val;
      let date;
      if (!this.susObj.suspend_till) {
        date = new Date();
      } else {
        date = new Date(this.susObj.suspend_till);
      }
      if (val == "week") {
        this.susObj.suspend_till = new Date(
          date.getTime() + 7 * 24 * 60 * 60 * 1000
        )
          .toISOString()
          .split("T")[0];
      } else if (val == "month") {
        date.setMonth(date.getMonth() + 1);
        this.susObj.suspend_till = date.toISOString().split("T")[0];
      } else {
        date.setFullYear(date.getFullYear() + 1);
        this.susObj.suspend_till = date.toISOString().split("T")[0];
      }
      // console.log(this.susObj.suspend_till);
    },
    CheckSusDate() {
      var elem = this.$refs["sus_date"];
      if (!this.susObj.suspend_till) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckSusReason() {
      var elem = this.$refs["sus_reason"];
      if (!this.susObj.suspend_reason) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckSusFor() {
      if (this.susObj.suspend_mode === "full") {
        var fullElem = this.$refs["sus_for"];
        if (fullElem) fullElem.state = true;
        return true;
      }
      var elem = this.$refs["sus_for"];
      if (
        !this.susObj.suspend_for_attentance &&
        !this.susObj.suspend_for_exams &&
        !this.susObj.suspend_for_homework &&
        !this.susObj.suspend_for_messaging
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async Suspend() {
      // console.log(this.leaveObj);
      this.CheckSusReason();
      this.CheckSusDate();
      this.CheckSusFor();
      if (
        this.CheckSusReason() == true &&
        this.CheckSusDate() == true &&
        this.CheckSusFor() == true
      ) {
        if (this.susObj.suspend_mode === "full") {
          this.susObj.suspend_for_attentance = true;
          this.susObj.suspend_for_homework = true;
          this.susObj.suspend_for_exams = true;
          this.susObj.suspend_for_messaging = true;
        }
        // console.log(this.susObj);
        this.request = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Students/Suspend?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&userID=" +
            this.$store.state.userData.userID,
          body: this.susObj,
          message: "Student suspended!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.LoadData();
          this.visibility5 = false;
        }
      }
    },
    async ClearSuspend() {
      this.request = true;
      var status = await this.post({
        url:
          this.$store.state.domain +
          "Students/ClearSuspension?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&sID=" +
          this.susObj.sID,
        message: "suspension removed!",
        context: this,
        token: this.$store.state.userData.token,
      });
      this.request = false;
      if (status) {
        this.LoadData();
        this.visibility5 = false;
      }
    },

    showReqDetails(item) {
      this.detailObj = { ...item };
      this.visibility8 = true;
    },
    async openLeaveReq(item, typeVal) {
      this.currentStd = item;
      this.reqAmount = null;
      this.reqAmountFeedback = "";
      this.reqObj = {
        id: 0,
        sID: item.id,
        request_date: new Date().toJSON(),
        reason: "",
        leaving_date: null,
        note: "",
        document: "",
        status: "pending",
        requested_by: this.$store.state.userData.userID,
        campusID: item.campusID,
        type: "general",
        approved_by: 0,
        approved_document: "",
        entityID: 0,
        meta_data: "",
      };
      this.docList = [];

      this.currentOptions = [{ text: "General", value: "general" }];
      if (typeVal) {
        if (typeVal == "confirm-admission") {
          this.currentOptions = [
            { text: "Confirm Admission", value: "confirm-admission" },
          ];
        } else if (typeVal == "left") {
          this.currentOptions = [{ text: "Left", value: "left" }];
        }
      } else {
        if (["present", "registered"].includes(item.status.toLowerCase())) {
          this.currentOptions = [
            ...this.currentOptions,
            { text: "Left", value: "left" },
            { text: "TC", value: "tc" },
            { text: "Transfer", value: "transfer" },
          ];
        }
        if (
          this.approvalList.length > 0 &&
          ["present", "registered"].includes(item.status.toLowerCase())
        ) {
          this.currentOptions = [{ text: "Left", value: "left" }];
        }
        if (
          this.approvalList.includes("monthly-discount") &&
          ["present", "registered"].includes(item.status.toLowerCase())
        ) {
          this.currentOptions.push({
            text: "Update Monthly Fee",
            value: "monthly-discount",
          });
        }
        if (
          this.approvalList.includes("confirm-admission") &&
          ["registered"].includes(item.status.toLowerCase())
        ) {
          this.currentOptions.push({
            text: "Confirm Admission",
            value: "confirm-admission",
          });
        }
        if (this.currentOptions.length == 0) {
          this.currentOptions = [{ text: "General", value: "general" }];
        }
      }
      this.reqObj.type = this.currentOptions[0]?.value || "general";
      // else {
      //   this.currentOptions = [
      //     ...this.currentOptions,
      //     { text: "Re Enroll", value: "re enroll" },
      //   ];
      // }
      await this.LoadReqData(item.id);

      let text = "";
      if (["myskoolhpgs", "myskoolprofectus"].includes(this.reportDomain)) {
        text = `Gr: ${item.grNoLocal} CID: ${item.grNo}`;
      } else {
        text = `Gr: ${item.grNo} ID: ${item.id}`;
      }
      this.sidebarTitle = `${item.name}<br/>${text}`;
      this.visibility6 = true;
    },
    async addDoc() {
      if (this.$refs.reqDocs.files.length > 0) {
        let docs = this.$refs.reqDocs.files;
        this.docLoading = true;
        try {
          const uploaded = await uploadToMySkool(docs);
          getUploadedPaths(uploaded).forEach((path) => {
            this.docList.push(path);
          });
          this.reqObj.document = this.docList.join(",");
        } catch (err) {
          console.log(err);
        } finally {
          this.docLoading = false;
        }
      }
    },
    removeDoc(index) {
      this.docList.splice(index, 1);
      this.reqObj.document = this.docList.join(",");
    },
    CheckReqDate() {
      var elem = this.$refs["req_date"];
      if (!this.reqObj.request_date) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckReqReason() {
      var elem = this.$refs["req_reason"];
      if (this.reqObj.reason.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckReqAmount() {
      if (this.reqObj.type === "monthly-discount") {
        var elem = this.$refs["req_amount"];
        if (
          this.reqAmount === null ||
          this.reqAmount === undefined ||
          this.reqAmount === ""
        ) {
          this.reqAmountFeedback = this.$t("Amount is required");
          if (elem) elem.state = false;
          return false;
        } else if (isNaN(this.reqAmount) || Number(this.reqAmount) < 0) {
          this.reqAmountFeedback = this.$t("Amount cannot be less than 0");
          if (elem) elem.state = false;
          return false;
        } else if (
          this.currentStd &&
          Number(this.reqAmount) === Number(this.currentStd.monthly_fee)
        ) {
          this.reqAmountFeedback = this.$t(
            "New monthly fee cannot be same as current monthly fee"
          );
          if (elem) elem.state = false;
          return false;
        } else {
          this.reqAmountFeedback = "";
          if (elem) elem.state = true;
          return true;
        }
      }
      return true;
    },
    async saveLeaveReq() {
      if (this.reqObj.type && this.reqObj.type.toLowerCase() !== "general") {
        const alreadyPending =
          this.reqData &&
          this.reqData.some(
            (r) =>
              r.type &&
              r.type.toLowerCase() === this.reqObj.type.toLowerCase() &&
              r.status &&
              r.status.toLowerCase() === "pending"
          );
        if (alreadyPending) {
          const req_label =
            this.reqObj.type == "monthly-discount"
              ? "Monthly Fee"
              : this.reqObj.type == "confirm-admission"
              ? "Confirm Admission"
              : this.reqObj.type;
          this.$bvToast.toast(`A ${req_label} request is already in pending.`, {
            title: "Warning!",
            variant: "warning",
            solid: true,
          });
          return;
        }
      }
      if (
        this.CheckReqReason() == true &&
        this.CheckReqDate() == true &&
        this.CheckReqAmount() == true
      ) {
        // console.log(this.reqObj);
        this.reqObj.leaving_date = this.reqObj.request_date;
        let payload = { ...this.reqObj };
        if (this.approvalList.includes(this.reqObj.type)) {
          payload.request_date = new Date().toJSON();
        }
        if (this.reqObj.type === "monthly-discount") {
          payload.entityID = 0;
          payload.meta_data = JSON.stringify({
            amount: this.reqAmount != null ? Number(this.reqAmount) : 0,
            current_fee: this.currentStd ? this.currentStd.monthly_fee : 0,
          });
        }
        this.saving = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "studentLeftRequest?db=" +
            this.$store.state.userData.db,
          body: payload,
          message: "Request saved successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.saving = false;
        if (status) {
          this.visibility6 = false;
          // if (this.byFilter) this.Filter(this.currentPage);
          // else this.LoadData();
        }
      }
    },
    async LoadReqData(id) {
      this.totalDues = 0;
      this.reqData = [];
      var obj = {
        url:
          this.$store.state.domain +
          "studentLeftRequest/LoadDataStudent?db=" +
          this.$store.state.userData.db +
          "&sID=" +
          id,
        token: this.$store.state.userData.token,
        dashboard: true,
      };
      let res = await this.get(obj);
      // console.log(res);
      this.totalDues = res.dues;
      this.reqData = res.data;
    },

    async Leave(item) {
      if (this.approvalList.includes("left")) {
        this.openLeaveReq(item, "left");
        return;
      }
      this.leaveObj = {
        sID: item.id,
        reason: "",
        date_of_leaving: null,
      };
      this.leftSelected = "None";
      await this.loadDues(item.id, item.campusID);
      this.sidebarTitle = `${item.name}<br/>Gr: ${item.grNo}`;
      this.visibility = true;

      var elem = this.$refs["reason"];
      elem.state = undefined;
      var elem = this.$refs["leave_date"];
      elem.state = undefined;
    },
    async loadDues(id, cID) {
      var obj = {
        url:
          this.$store.state.domain +
          "Fees/GetStudentBalance?db=" +
          this.$store.state.userData.db +
          "&campusID=" +
          cID +
          "&sID=" +
          id,
        token: this.$store.state.userData.token,
        dashboard: true,
      };
      let res = await this.get(obj);
      this.totalDues = res.data;
      this.leaveObj = {
        sID: id,
        reason: res.last_note || "",
        date_of_leaving: res.date_of_leaving || null,
      };
      this.leftSelected = res.leavingCategory || "None";
    },

    async Add() {
      // console.log(this.leaveObj);
      if (this.CheckReason() == true && this.CheckDate() == true) {
        this.request = true;
        let st = this.leftSelected == "None" ? "" : this.leftSelected;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Students/MarkLeft?db=" +
            this.$store.state.userData.db +
            "&status=" +
            st +
            "&userID=" +
            this.$store.state.userData.userID,
          body: this.leaveObj,
          message: `Student marked as letf!`,
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.LoadData();
          this.visibility = false;
        }
      }
    },

    async LoadData() {
      this.dataLoading = true;
      this.byFilter = false;
      this.bySearch = false;
      this.items = [];
      try {
        let myitem;
        if (this.currentStatus == "admission") {
          myitem = await this.get({
            url:
              this.$store.state.domain +
              "Students/LoadAdmissionKSA?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId +
              "&clsID=0&section=0&page=" +
              this.currentPage +
              "&status=present&filterDTFrom=&filterDTTo=",
            token: this.$store.state.userData.token,
            returnData: true,
          });
        } else {
          const paramStr = this.sessionID ? "&sessionID=" + this.sessionID : "";
          myitem = await this.get({
            url:
              this.$store.state.domain +
              "Students/LoadDataPagination?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId +
              "&clsID=0&section=0&page=" +
              this.currentPage +
              "&status=" +
              this.currentStatus +
              paramStr,
            token: this.$store.state.userData.token,
            returnData: true,
          });
        }

        const parsed = this.applyStudentGridPayload(myitem);
        this.items = parsed.items;
        this.total = parsed.total;
        this.stdDetails = parsed.stdDetails;
        this.allDocs = parsed.allDocs;
        // console.log("resp", myitem);
        // console.log("items", this.items);

        let fData = {
          cls: this.filter.cls,
          sec: this.filter.sec,
          status: this.filter.status,
          dateType: this.regFilter.dateType,
          filterDate: this.filterDate,
          byFilter: this.byFilter,
          page: this.currentPage,
          currentStatus: this.currentStatus,
          total: this.total,
          db: this.$store.state.userData.db,
          cID: this.$store.state.userData.cId,
          campusID: this.filter.campusID,
          acceptedBy: this.acceptedBy,
          bySearch: this.bySearch,
          searchQuery: this.searchQuery,
          searchType: this.searchType,
        };
        let ind = this.filterData.findIndex(
          (el) =>
            el.db == this.$store.state.userData.db &&
            el.cID == this.$store.state.userData.cId
        );
        if (ind != -1) {
          this.filterData[ind] = { ...fData };
        } else {
          this.filterData.push(fData);
        }
        this.$store.commit("setStdFilter", this.filterData);
      } catch (error) {
        console.error("LoadData", error);
        this.items = [];
        this.total = 0;
        this.stdDetails = [];
        this.allDocs = [];
        this.$bvToast.toast(this.$t("Failed to load students."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.dataLoading = false;
      }

      // console.log(this.filterData);
    },

    ClearSearch() {
      this.searchQuery = "";
      this.loadSearch();
    },
    async loadSearch(from) {
      if (this.searchQuery.trim() == "") {
        this.currentPage = 1;
        this.LoadData();
      } else {
        this.byFilter = false;
        this.bySearch = true;
        this.dataLoading = true;

        try {
          const paramStr = this.sessionID ? "&sessionID=" + this.sessionID : "";

          let myitem = await this.get({
            url:
              this.$store.state.domain +
              "Students/Search?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId +
              "&keyword=" +
              this.searchQuery +
              "&type=" +
              this.searchType.replace(" ", "_") +
              paramStr,
            token: this.$store.state.userData.token,
            dashboard: true,
          });
          const parsed = this.applyStudentGridPayload(myitem);
          this.items = parsed.items;
          this.stdDetails = parsed.stdDetails;
          this.allDocs = parsed.allDocs;
          this.total = 0;
          this.currentPage = 1;

          // auto open view student on search by receipt
          this.$nextTick(() => {
            if (
              ["myskoolhpgs"].includes(this.reportDomain) &&
              this.items.length > 0 &&
              this.searchType == "receipt" &&
              this.rights.view &&
              !from
            ) {
              let obj = this.items[0];
              this.$router.push({
                name: "apps-users-view",
                params: {
                  id: obj.id,
                  item: { ...obj },
                },
              });
            }
          });

          let fData = {
            cls: this.filter.cls,
            sec: this.filter.sec,
            status: this.filter.status,
            dateType: this.regFilter.dateType,
            filterDate: this.filterDate,
            byFilter: this.byFilter,
            page: this.currentPage,
            currentStatus: this.currentStatus,
            total: this.total,
            db: this.$store.state.userData.db,
            cID: this.$store.state.userData.cId,
            campusID: this.filter.campusID,
            acceptedBy: this.acceptedBy,
            bySearch: this.bySearch,
            searchQuery: this.searchQuery,
            searchType: this.searchType,
          };
          let ind = this.filterData.findIndex(
            (el) =>
              el.db == this.$store.state.userData.db &&
              el.cID == this.$store.state.userData.cId
          );
          if (ind != -1) {
            this.filterData[ind] = { ...fData };
          } else {
            this.filterData.push(fData);
          }
          this.$store.commit("setStdFilter", this.filterData);
        } catch (error) {
          console.error("loadSearch", error);
          this.items = [];
          this.stdDetails = [];
          this.allDocs = [];
          this.total = 0;
        } finally {
          this.dataLoading = false;
        }
      }
    },

    openOptions() {
      this.$bvModal.show("modal-search");
    },
    saveState(val) {
      this.searchType = val;
      this.$store.commit("setSearch", this.searchType);
      this.$bvModal.hide("modal-search");
    },

    async loadSettings() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["head_office"], // "faceID", Add faceID to settings check
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });

      const headOfficeObj = res.find((el) => el.key == "head_office");
      this.isHeadOffice =
        headOfficeObj &&
        headOfficeObj.campusID == this.$store.state.userData.cId;
      if (this.isHeadOffice && this.reportDomain != "myskoolhpgs") {
        this.fields.splice(3, 0, { label: "campus", key: "campus" });
        this.otherFields.splice(3, 0, {
          label: "campus",
          key: "campus",
        });
      }

      // const faceIdSetting = res.find(
      //   (el) => el.key == "faceID" && el.value == "true"
      // );
      // this.showFaceId = faceIdSetting?.valueBool || false;
      // alert(this.showFaceId);
    },

    async registerFaceId(item) {
      try {
        if (!item.rfID) {
          this.$root.$bvToast.toast(this.$t("Please define RFID for student"), {
            title: this.$t("Error"),
            variant: "danger",
            solid: true,
          });
          return;
        }

        this.faceIdLoading = true;
        this.currentStudentId = item.id;

        const formattedDomain = this.reportDomain.replace(/_/g, "-");
        const campusId = this.$store.state.userData.cId;
        const baseUrl = `https://${formattedDomain}-${campusId}.cloudious.net/create-enrollment-link?cID=${campusId}`;
        const enrollmentUrl = baseUrl.replace(/^http:/, "https:");

        const response = await fetch(enrollmentUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: item.name,
            id: item.rfID,
          }),
        });

        const data = await response.json();
        this.enrollmentLink = data.enrollmentLink.replace(/^http:/, "https:");
        this.showFaceIdModal = true;

        setTimeout(() => {
          const iframe = document.querySelector("iframe");
          if (iframe) {
            iframe.setAttribute("allow", "camera;microphone");
          }
        }, 100);
      } catch (error) {
        console.error("Error registering face ID:", error);
        this.$root.$bvToast.toast(this.$t("Error registering face ID"), {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
      } finally {
        this.faceIdLoading = false;
      }
    },

    async shareWhatsApp() {
      try {
        const response = await this.post({
          url: `${this.$store.state.domain}Chat/ShareFaceLink?db=${this.$store.state.userData.db}`,
          body: {
            tID: this.currentStudentId,
            link: this.enrollmentLink,
            isTeacher: false,
          },
          token: this.$store.state.userData.token,
          message: "Link sent on WhatsApp",
          context: this,
        });

        if (response) {
          this.showFaceIdModal = false;
        }
      } catch (error) {
        console.error("Error sharing link:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>
<style lang="css">
.adjust-head {
  height: 2.5rem;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.search-type:hover {
  background-color: rgba(128, 116, 229, 0.12);
  color: var(--primary);
  transform: scaleY(1.03);
}

.input-group {
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
}

.input-group-prepend .input-group-text {
  border: none;
}

.custom-checkbox .custom-control-label {
  cursor: pointer !important;
}

.rotate-table.table-responsive {
  transform: rotateX(180deg);
}
.rotate-table.table-responsive > ::v-deep.table {
  transform: rotateX(180deg);
}

/* adjust color on selection */
.table-responsive
  > ::v-deep.b-table
  > tbody
  .b-table-row-selected.table-active
  td.b-table-sticky-column {
  background-color: inherit !important;
}
/* no sticky column on smaller screen */
@media (max-width: 768px) {
  .table-responsive
    > ::v-deep.table.b-table
    > tbody
    > tr
    > .b-table-sticky-column {
    position: static !important;
  }
}

.cropper {
  width: 400px;
  height: 400px;
  max-height: 400px;
  max-width: 400px;
  position: fixed;
  top: 55vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

/* Custom fee import modal */
.import-parse-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.import-parse-stat {
  flex: 1 1 140px;
  border-radius: 8px;
  padding: 10px 12px;
  border: 1px solid #ebe9f1;
  text-align: center;
}
.import-parse-stat--ready {
  background: #f3f0ff;
  border-color: #dcd6ff;
}
.import-parse-stat--skip {
  background: #f8f8f8;
  border-color: #ebe9f1;
}
.import-parse-stat--inc {
  background: #f6fff9;
  border-color: #c3f0d3;
}
.import-parse-stat__num {
  display: block;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.2;
  color: #5e5873;
}
.import-parse-stat--ready .import-parse-stat__num {
  color: #7367f0;
}
.import-parse-stat--skip .import-parse-stat__num {
  color: #ff9f43;
}
.import-parse-stat--inc .import-parse-stat__num {
  color: #28c76f;
}
.import-parse-stat__lbl {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #6e6b7b;
  margin-top: 2px;
}
.summary-table-wrap {
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  overflow: hidden;
}
.import-preview-table {
  max-height: 280px;
}
.bulk-inc-preview-table ::v-deep thead th {
  font-size: 11px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.bulk-inc-preview-table ::v-deep tbody td {
  font-size: 13px;
  padding-top: 0.45rem;
  padding-bottom: 0.45rem;
}
.bulk-inc-summary-table ::v-deep thead th {
  background: #f3f2f7 !important;
  border-bottom: 1px solid #ebe9f1 !important;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #6e6b7b;
  vertical-align: middle;
  white-space: nowrap;
}
.bulk-inc-summary-table ::v-deep tbody td {
  font-size: 13px;
  vertical-align: middle;
  font-variant-numeric: tabular-nums;
}

/* Custom fee import summary */
.custom-fee-summary__hero {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  margin-bottom: 12px;
  border: 1px solid #c3f0d3;
  border-radius: 12px;
  background: linear-gradient(135deg, #f6fff9 0%, #ffffff 100%);
}
.custom-fee-summary__icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e8f8ee;
  color: #28c76f;
}
.custom-fee-summary__hero-text h5 {
  font-weight: 700;
  color: #5e5873;
}
.custom-fee-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
}
.custom-fee-stat {
  flex: 1 1 120px;
  padding: 10px 12px;
  text-align: center;
  border: 1px solid #ebe9f1;
  border-radius: 10px;
  background: #ffffff;
}
.custom-fee-stat--saved {
  border-color: #dcd6ff;
  background: #f3f0ff;
}
.custom-fee-stat--updated {
  border-color: #cfe6ff;
  background: #f2f8ff;
}
.custom-fee-stat--skipped {
  border-color: #ffe8c8;
  background: #fff8ef;
}
.custom-fee-stat__num {
  display: block;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.2;
  color: #5e5873;
}
.custom-fee-stat--saved .custom-fee-stat__num {
  color: #7367f0;
}
.custom-fee-stat--updated .custom-fee-stat__num {
  color: #0d6efd;
}
.custom-fee-stat--skipped .custom-fee-stat__num {
  color: #ff9f43;
}
.custom-fee-stat__lbl {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  font-weight: 600;
  color: #6e6b7b;
}
.import-preview-table__title {
  font-size: 12px;
}
</style>
